
      var $parcel$global = globalThis;
    var $e0783f4603742bdd$exports = {};
/*! jQuery v2.2.4 | (c) jQuery Foundation | jquery.org/license */ !function(a, b) {
    "object" == typeof $e0783f4603742bdd$exports ? $e0783f4603742bdd$exports = a.document ? b(a, !0) : function(a) {
        if (!a.document) throw new Error("jQuery requires a window with a document");
        return b(a);
    } : b(a);
}("undefined" != typeof window ? window : $e0783f4603742bdd$exports, function(a, b) {
    var c = [], d = a.document, e = c.slice, f = c.concat, g = c.push, h = c.indexOf, i = {}, j = i.toString, k = i.hasOwnProperty, l = {}, m = "2.2.4", n = function(a, b) {
        return new n.fn.init(a, b);
    }, o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, p = /^-ms-/, q = /-([\da-z])/gi, r = function(a, b) {
        return b.toUpperCase();
    };
    n.fn = n.prototype = {
        jquery: m,
        constructor: n,
        selector: "",
        length: 0,
        toArray: function() {
            return e.call(this);
        },
        get: function(a) {
            return null != a ? 0 > a ? this[a + this.length] : this[a] : e.call(this);
        },
        pushStack: function(a) {
            var b = n.merge(this.constructor(), a);
            return b.prevObject = this, b.context = this.context, b;
        },
        each: function(a) {
            return n.each(this, a);
        },
        map: function(a) {
            return this.pushStack(n.map(this, function(b, c) {
                return a.call(b, c, b);
            }));
        },
        slice: function() {
            return this.pushStack(e.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        eq: function(a) {
            var b = this.length, c = +a + (0 > a ? b : 0);
            return this.pushStack(c >= 0 && b > c ? [
                this[c]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        push: g,
        sort: c.sort,
        splice: c.splice
    }, n.extend = n.fn.extend = function() {
        var a, b, c, d, e, f, g = arguments[0] || {}, h = 1, i = arguments.length, j = !1;
        for("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == typeof g || n.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++)if (null != (a = arguments[h])) for(b in a)c = g[b], d = a[b], g !== d && (j && d && (n.isPlainObject(d) || (e = n.isArray(d))) ? (e ? (e = !1, f = c && n.isArray(c) ? c : []) : f = c && n.isPlainObject(c) ? c : {}, g[b] = n.extend(j, f, d)) : void 0 !== d && (g[b] = d));
        return g;
    }, n.extend({
        expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(a) {
            throw new Error(a);
        },
        noop: function() {},
        isFunction: function(a) {
            return "function" === n.type(a);
        },
        isArray: Array.isArray,
        isWindow: function(a) {
            return null != a && a === a.window;
        },
        isNumeric: function(a) {
            var b = a && a.toString();
            return !n.isArray(a) && b - parseFloat(b) + 1 >= 0;
        },
        isPlainObject: function(a) {
            var b;
            if ("object" !== n.type(a) || a.nodeType || n.isWindow(a)) return !1;
            if (a.constructor && !k.call(a, "constructor") && !k.call(a.constructor.prototype || {}, "isPrototypeOf")) return !1;
            for(b in a);
            return void 0 === b || k.call(a, b);
        },
        isEmptyObject: function(a) {
            var b;
            for(b in a)return !1;
            return !0;
        },
        type: function(a) {
            return null == a ? a + "" : "object" == typeof a || "function" == typeof a ? i[j.call(a)] || "object" : typeof a;
        },
        globalEval: function(a) {
            var b, c = eval;
            a = n.trim(a), a && (1 === a.indexOf("use strict") ? (b = d.createElement("script"), b.text = a, d.head.appendChild(b).parentNode.removeChild(b)) : c(a));
        },
        camelCase: function(a) {
            return a.replace(p, "ms-").replace(q, r);
        },
        nodeName: function(a, b) {
            return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
        },
        each: function(a, b) {
            var c, d = 0;
            if (s(a)) {
                for(c = a.length; c > d; d++)if (b.call(a[d], d, a[d]) === !1) break;
            } else for(d in a)if (b.call(a[d], d, a[d]) === !1) break;
            return a;
        },
        trim: function(a) {
            return null == a ? "" : (a + "").replace(o, "");
        },
        makeArray: function(a, b) {
            var c = b || [];
            return null != a && (s(Object(a)) ? n.merge(c, "string" == typeof a ? [
                a
            ] : a) : g.call(c, a)), c;
        },
        inArray: function(a, b, c) {
            return null == b ? -1 : h.call(b, a, c);
        },
        merge: function(a, b) {
            for(var c = +b.length, d = 0, e = a.length; c > d; d++)a[e++] = b[d];
            return a.length = e, a;
        },
        grep: function(a, b, c) {
            for(var d, e = [], f = 0, g = a.length, h = !c; g > f; f++)d = !b(a[f], f), d !== h && e.push(a[f]);
            return e;
        },
        map: function(a, b, c) {
            var d, e, g = 0, h = [];
            if (s(a)) for(d = a.length; d > g; g++)e = b(a[g], g, c), null != e && h.push(e);
            else for(g in a)e = b(a[g], g, c), null != e && h.push(e);
            return f.apply([], h);
        },
        guid: 1,
        proxy: function(a, b) {
            var c, d, f;
            return "string" == typeof b && (c = a[b], b = a, a = c), n.isFunction(a) ? (d = e.call(arguments, 2), f = function() {
                return a.apply(b || this, d.concat(e.call(arguments)));
            }, f.guid = a.guid = a.guid || n.guid++, f) : void 0;
        },
        now: Date.now,
        support: l
    }), "function" == typeof Symbol && (n.fn[Symbol.iterator] = c[Symbol.iterator]), n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(a, b) {
        i["[object " + b + "]"] = b.toLowerCase();
    });
    function s(a) {
        var b = !!a && "length" in a && a.length, c = n.type(a);
        return "function" === c || n.isWindow(a) ? !1 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a;
    }
    var t = function(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u = "sizzle" + 1 * new Date, v = a.document, w = 0, x = 0, y = ga(), z = ga(), A = ga(), B = function(a, b) {
            return a === b && (l = !0), 0;
        }, C = -2147483648, D = {}.hasOwnProperty, E = [], F = E.pop, G = E.push, H = E.push, I = E.slice, J = function(a, b) {
            for(var c = 0, d = a.length; d > c; c++)if (a[c] === b) return c;
            return -1;
        }, K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", L = "[\\x20\\t\\r\\n\\f]", M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", N = "\\[" + L + "*(" + M + ")(?:" + L + "*([*^$|!~]?=)" + L + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + M + "))|)" + L + "*\\]", O = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + N + ")*)|.*)\\)|)", P = new RegExp(L + "+", "g"), Q = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"), R = new RegExp("^" + L + "*," + L + "*"), S = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"), T = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"), U = new RegExp(O), V = new RegExp("^" + M + "$"), W = {
            ID: new RegExp("^#(" + M + ")"),
            CLASS: new RegExp("^\\.(" + M + ")"),
            TAG: new RegExp("^(" + M + "|[*])"),
            ATTR: new RegExp("^" + N),
            PSEUDO: new RegExp("^" + O),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L + "*(even|odd|(([+-]|)(\\d*)n|)" + L + "*(?:([+-]|)" + L + "*(\\d+)|))" + L + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + K + ")$", "i"),
            needsContext: new RegExp("^" + L + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L + "*((?:-\\d)?\\d*)" + L + "*\\)|)(?=[^-]|$)", "i")
        }, X = /^(?:input|select|textarea|button)$/i, Y = /^h\d$/i, Z = /^[^{]+\{\s*\[native \w/, $ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, _ = /[+~]/, aa = /'|\\/g, ba = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"), ca = function(a, b, c) {
            var d = "0x" + b - 65536;
            return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320);
        }, da = function() {
            m();
        };
        try {
            H.apply(E = I.call(v.childNodes), v.childNodes), E[v.childNodes.length].nodeType;
        } catch (ea) {
            H = {
                apply: E.length ? function(a, b) {
                    G.apply(a, I.call(b));
                } : function(a, b) {
                    var c = a.length, d = 0;
                    while(a[c++] = b[d++]);
                    a.length = c - 1;
                }
            };
        }
        function fa(a, b, d, e) {
            var f, h, j, k, l, o, r, s, w = b && b.ownerDocument, x = b ? b.nodeType : 9;
            if (d = d || [], "string" != typeof a || !a || 1 !== x && 9 !== x && 11 !== x) return d;
            if (!e && ((b ? b.ownerDocument || b : v) !== n && m(b), b = b || n, p)) {
                if (11 !== x && (o = $.exec(a))) {
                    if (f = o[1]) {
                        if (9 === x) {
                            if (!(j = b.getElementById(f))) return d;
                            if (j.id === f) return d.push(j), d;
                        } else if (w && (j = w.getElementById(f)) && t(b, j) && j.id === f) return d.push(j), d;
                    } else {
                        if (o[2]) return H.apply(d, b.getElementsByTagName(a)), d;
                        if ((f = o[3]) && c.getElementsByClassName && b.getElementsByClassName) return H.apply(d, b.getElementsByClassName(f)), d;
                    }
                }
                if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
                    if (1 !== x) w = b, s = a;
                    else if ("object" !== b.nodeName.toLowerCase()) {
                        (k = b.getAttribute("id")) ? k = k.replace(aa, "\\$&") : b.setAttribute("id", k = u), r = g(a), h = r.length, l = V.test(k) ? "#" + k : "[id='" + k + "']";
                        while(h--)r[h] = l + " " + qa(r[h]);
                        s = r.join(","), w = _.test(a) && oa(b.parentNode) || b;
                    }
                    if (s) try {
                        return H.apply(d, w.querySelectorAll(s)), d;
                    } catch (y) {} finally{
                        k === u && b.removeAttribute("id");
                    }
                }
            }
            return i(a.replace(Q, "$1"), b, d, e);
        }
        function ga() {
            var a = [];
            function b(c, e) {
                return a.push(c + " ") > d.cacheLength && delete b[a.shift()], b[c + " "] = e;
            }
            return b;
        }
        function ha(a) {
            return a[u] = !0, a;
        }
        function ia(a) {
            var b = n.createElement("div");
            try {
                return !!a(b);
            } catch (c) {
                return !1;
            } finally{
                b.parentNode && b.parentNode.removeChild(b), b = null;
            }
        }
        function ja(a, b) {
            var c = a.split("|"), e = c.length;
            while(e--)d.attrHandle[c[e]] = b;
        }
        function ka(a, b) {
            var c = b && a, d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || C) - (~a.sourceIndex || C);
            if (d) return d;
            if (c) {
                while(c = c.nextSibling)if (c === b) return -1;
            }
            return a ? 1 : -1;
        }
        function la(a) {
            return function(b) {
                var c = b.nodeName.toLowerCase();
                return "input" === c && b.type === a;
            };
        }
        function ma(a) {
            return function(b) {
                var c = b.nodeName.toLowerCase();
                return ("input" === c || "button" === c) && b.type === a;
            };
        }
        function na(a) {
            return ha(function(b) {
                return b = +b, ha(function(c, d) {
                    var e, f = a([], c.length, b), g = f.length;
                    while(g--)c[e = f[g]] && (c[e] = !(d[e] = c[e]));
                });
            });
        }
        function oa(a) {
            return a && "undefined" != typeof a.getElementsByTagName && a;
        }
        c = fa.support = {}, f = fa.isXML = function(a) {
            var b = a && (a.ownerDocument || a).documentElement;
            return b ? "HTML" !== b.nodeName : !1;
        }, m = fa.setDocument = function(a) {
            var b, e, g = a ? a.ownerDocument || a : v;
            return g !== n && 9 === g.nodeType && g.documentElement ? (n = g, o = n.documentElement, p = !f(n), (e = n.defaultView) && e.top !== e && (e.addEventListener ? e.addEventListener("unload", da, !1) : e.attachEvent && e.attachEvent("onunload", da)), c.attributes = ia(function(a) {
                return a.className = "i", !a.getAttribute("className");
            }), c.getElementsByTagName = ia(function(a) {
                return a.appendChild(n.createComment("")), !a.getElementsByTagName("*").length;
            }), c.getElementsByClassName = Z.test(n.getElementsByClassName), c.getById = ia(function(a) {
                return o.appendChild(a).id = u, !n.getElementsByName || !n.getElementsByName(u).length;
            }), c.getById ? (d.find.ID = function(a, b) {
                if ("undefined" != typeof b.getElementById && p) {
                    var c = b.getElementById(a);
                    return c ? [
                        c
                    ] : [];
                }
            }, d.filter.ID = function(a) {
                var b = a.replace(ba, ca);
                return function(a) {
                    return a.getAttribute("id") === b;
                };
            }) : (delete d.find.ID, d.filter.ID = function(a) {
                var b = a.replace(ba, ca);
                return function(a) {
                    var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");
                    return c && c.value === b;
                };
            }), d.find.TAG = c.getElementsByTagName ? function(a, b) {
                return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0;
            } : function(a, b) {
                var c, d = [], e = 0, f = b.getElementsByTagName(a);
                if ("*" === a) {
                    while(c = f[e++])1 === c.nodeType && d.push(c);
                    return d;
                }
                return f;
            }, d.find.CLASS = c.getElementsByClassName && function(a, b) {
                return "undefined" != typeof b.getElementsByClassName && p ? b.getElementsByClassName(a) : void 0;
            }, r = [], q = [], (c.qsa = Z.test(n.querySelectorAll)) && (ia(function(a) {
                o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\r\\' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + L + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || q.push("\\[" + L + "*(?:value|" + K + ")"), a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="), a.querySelectorAll(":checked").length || q.push(":checked"), a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]");
            }), ia(function(a) {
                var b = n.createElement("input");
                b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && q.push("name" + L + "*[*^$|!~]?="), a.querySelectorAll(":enabled").length || q.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), q.push(",.*:");
            })), (c.matchesSelector = Z.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ia(function(a) {
                c.disconnectedMatch = s.call(a, "div"), s.call(a, "[s!='']:x"), r.push("!=", O);
            }), q = q.length && new RegExp(q.join("|")), r = r.length && new RegExp(r.join("|")), b = Z.test(o.compareDocumentPosition), t = b || Z.test(o.contains) ? function(a, b) {
                var c = 9 === a.nodeType ? a.documentElement : a, d = b && b.parentNode;
                return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)));
            } : function(a, b) {
                if (b) {
                    while(b = b.parentNode)if (b === a) return !0;
                }
                return !1;
            }, B = b ? function(a, b) {
                if (a === b) return l = !0, 0;
                var d = !a.compareDocumentPosition - !b.compareDocumentPosition;
                return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === n || a.ownerDocument === v && t(v, a) ? -1 : b === n || b.ownerDocument === v && t(v, b) ? 1 : k ? J(k, a) - J(k, b) : 0 : 4 & d ? -1 : 1);
            } : function(a, b) {
                if (a === b) return l = !0, 0;
                var c, d = 0, e = a.parentNode, f = b.parentNode, g = [
                    a
                ], h = [
                    b
                ];
                if (!e || !f) return a === n ? -1 : b === n ? 1 : e ? -1 : f ? 1 : k ? J(k, a) - J(k, b) : 0;
                if (e === f) return ka(a, b);
                c = a;
                while(c = c.parentNode)g.unshift(c);
                c = b;
                while(c = c.parentNode)h.unshift(c);
                while(g[d] === h[d])d++;
                return d ? ka(g[d], h[d]) : g[d] === v ? -1 : h[d] === v ? 1 : 0;
            }, n) : n;
        }, fa.matches = function(a, b) {
            return fa(a, null, null, b);
        }, fa.matchesSelector = function(a, b) {
            if ((a.ownerDocument || a) !== n && m(a), b = b.replace(T, "='$1']"), c.matchesSelector && p && !A[b + " "] && (!r || !r.test(b)) && (!q || !q.test(b))) try {
                var d = s.call(a, b);
                if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d;
            } catch (e) {}
            return fa(b, n, null, [
                a
            ]).length > 0;
        }, fa.contains = function(a, b) {
            return (a.ownerDocument || a) !== n && m(a), t(a, b);
        }, fa.attr = function(a, b) {
            (a.ownerDocument || a) !== n && m(a);
            var e = d.attrHandle[b.toLowerCase()], f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
            return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null;
        }, fa.error = function(a) {
            throw new Error("Syntax error, unrecognized expression: " + a);
        }, fa.uniqueSort = function(a) {
            var b, d = [], e = 0, f = 0;
            if (l = !c.detectDuplicates, k = !c.sortStable && a.slice(0), a.sort(B), l) {
                while(b = a[f++])b === a[f] && (e = d.push(f));
                while(e--)a.splice(d[e], 1);
            }
            return k = null, a;
        }, e = fa.getText = function(a) {
            var b, c = "", d = 0, f = a.nodeType;
            if (f) {
                if (1 === f || 9 === f || 11 === f) {
                    if ("string" == typeof a.textContent) return a.textContent;
                    for(a = a.firstChild; a; a = a.nextSibling)c += e(a);
                } else if (3 === f || 4 === f) return a.nodeValue;
            } else while(b = a[d++])c += e(b);
            return c;
        }, d = fa.selectors = {
            cacheLength: 50,
            createPseudo: ha,
            match: W,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(a) {
                    return a[1] = a[1].replace(ba, ca), a[3] = (a[3] || a[4] || a[5] || "").replace(ba, ca), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4);
                },
                CHILD: function(a) {
                    return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || fa.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && fa.error(a[0]), a;
                },
                PSEUDO: function(a) {
                    var b, c = !a[6] && a[2];
                    return W.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && U.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3));
                }
            },
            filter: {
                TAG: function(a) {
                    var b = a.replace(ba, ca).toLowerCase();
                    return "*" === a ? function() {
                        return !0;
                    } : function(a) {
                        return a.nodeName && a.nodeName.toLowerCase() === b;
                    };
                },
                CLASS: function(a) {
                    var b = y[a + " "];
                    return b || (b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)"), y(a, function(a) {
                        return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "");
                    }));
                },
                ATTR: function(a, b, c) {
                    return function(d) {
                        var e = fa.attr(d, a);
                        return null == e ? "!=" === b : b ? (e += "", "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(P, " ") + " ").indexOf(c) > -1 : "|=" === b ? e === c || e.slice(0, c.length + 1) === c + "-" : !1) : !0;
                    };
                },
                CHILD: function(a, b, c, d, e) {
                    var f = "nth" !== a.slice(0, 3), g = "last" !== a.slice(-4), h = "of-type" === b;
                    return 1 === d && 0 === e ? function(a) {
                        return !!a.parentNode;
                    } : function(b, c, i) {
                        var j, k, l, m, n, o, p = f !== g ? "nextSibling" : "previousSibling", q = b.parentNode, r = h && b.nodeName.toLowerCase(), s = !i && !h, t = !1;
                        if (q) {
                            if (f) {
                                while(p){
                                    m = b;
                                    while(m = m[p])if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) return !1;
                                    o = p = "only" === a && !o && "nextSibling";
                                }
                                return !0;
                            }
                            if (o = [
                                g ? q.firstChild : q.lastChild
                            ], g && s) {
                                m = q, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n && j[2], m = n && q.childNodes[n];
                                while(m = ++n && m && m[p] || (t = n = 0) || o.pop())if (1 === m.nodeType && ++t && m === b) {
                                    k[a] = [
                                        w,
                                        n,
                                        t
                                    ];
                                    break;
                                }
                            } else if (s && (m = b, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n), t === !1) {
                                while(m = ++n && m && m[p] || (t = n = 0) || o.pop())if ((h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) && ++t && (s && (l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), k[a] = [
                                    w,
                                    t
                                ]), m === b)) break;
                            }
                            return t -= e, t === d || t % d === 0 && t / d >= 0;
                        }
                    };
                },
                PSEUDO: function(a, b) {
                    var c, e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || fa.error("unsupported pseudo: " + a);
                    return e[u] ? e(b) : e.length > 1 ? (c = [
                        a,
                        a,
                        "",
                        b
                    ], d.setFilters.hasOwnProperty(a.toLowerCase()) ? ha(function(a, c) {
                        var d, f = e(a, b), g = f.length;
                        while(g--)d = J(a, f[g]), a[d] = !(c[d] = f[g]);
                    }) : function(a) {
                        return e(a, 0, c);
                    }) : e;
                }
            },
            pseudos: {
                not: ha(function(a) {
                    var b = [], c = [], d = h(a.replace(Q, "$1"));
                    return d[u] ? ha(function(a, b, c, e) {
                        var f, g = d(a, null, e, []), h = a.length;
                        while(h--)(f = g[h]) && (a[h] = !(b[h] = f));
                    }) : function(a, e, f) {
                        return b[0] = a, d(b, null, f, c), b[0] = null, !c.pop();
                    };
                }),
                has: ha(function(a) {
                    return function(b) {
                        return fa(a, b).length > 0;
                    };
                }),
                contains: ha(function(a) {
                    return a = a.replace(ba, ca), function(b) {
                        return (b.textContent || b.innerText || e(b)).indexOf(a) > -1;
                    };
                }),
                lang: ha(function(a) {
                    return V.test(a || "") || fa.error("unsupported lang: " + a), a = a.replace(ba, ca).toLowerCase(), function(b) {
                        var c;
                        do if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-");
                        while ((b = b.parentNode) && 1 === b.nodeType);
                        return !1;
                    };
                }),
                target: function(b) {
                    var c = a.location && a.location.hash;
                    return c && c.slice(1) === b.id;
                },
                root: function(a) {
                    return a === o;
                },
                focus: function(a) {
                    return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex);
                },
                enabled: function(a) {
                    return a.disabled === !1;
                },
                disabled: function(a) {
                    return a.disabled === !0;
                },
                checked: function(a) {
                    var b = a.nodeName.toLowerCase();
                    return "input" === b && !!a.checked || "option" === b && !!a.selected;
                },
                selected: function(a) {
                    return a.parentNode && a.parentNode.selectedIndex, a.selected === !0;
                },
                empty: function(a) {
                    for(a = a.firstChild; a; a = a.nextSibling)if (a.nodeType < 6) return !1;
                    return !0;
                },
                parent: function(a) {
                    return !d.pseudos.empty(a);
                },
                header: function(a) {
                    return Y.test(a.nodeName);
                },
                input: function(a) {
                    return X.test(a.nodeName);
                },
                button: function(a) {
                    var b = a.nodeName.toLowerCase();
                    return "input" === b && "button" === a.type || "button" === b;
                },
                text: function(a) {
                    var b;
                    return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase());
                },
                first: na(function() {
                    return [
                        0
                    ];
                }),
                last: na(function(a, b) {
                    return [
                        b - 1
                    ];
                }),
                eq: na(function(a, b, c) {
                    return [
                        0 > c ? c + b : c
                    ];
                }),
                even: na(function(a, b) {
                    for(var c = 0; b > c; c += 2)a.push(c);
                    return a;
                }),
                odd: na(function(a, b) {
                    for(var c = 1; b > c; c += 2)a.push(c);
                    return a;
                }),
                lt: na(function(a, b, c) {
                    for(var d = 0 > c ? c + b : c; --d >= 0;)a.push(d);
                    return a;
                }),
                gt: na(function(a, b, c) {
                    for(var d = 0 > c ? c + b : c; ++d < b;)a.push(d);
                    return a;
                })
            }
        }, d.pseudos.nth = d.pseudos.eq;
        for(b in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })d.pseudos[b] = la(b);
        for(b in {
            submit: !0,
            reset: !0
        })d.pseudos[b] = ma(b);
        function pa() {}
        pa.prototype = d.filters = d.pseudos, d.setFilters = new pa, g = fa.tokenize = function(a, b) {
            var c, e, f, g, h, i, j, k = z[a + " "];
            if (k) return b ? 0 : k.slice(0);
            h = a, i = [], j = d.preFilter;
            while(h){
                c && !(e = R.exec(h)) || (e && (h = h.slice(e[0].length) || h), i.push(f = [])), c = !1, (e = S.exec(h)) && (c = e.shift(), f.push({
                    value: c,
                    type: e[0].replace(Q, " ")
                }), h = h.slice(c.length));
                for(g in d.filter)!(e = W[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(), f.push({
                    value: c,
                    type: g,
                    matches: e
                }), h = h.slice(c.length));
                if (!c) break;
            }
            return b ? h.length : h ? fa.error(a) : z(a, i).slice(0);
        };
        function qa(a) {
            for(var b = 0, c = a.length, d = ""; c > b; b++)d += a[b].value;
            return d;
        }
        function ra(a, b, c) {
            var d = b.dir, e = c && "parentNode" === d, f = x++;
            return b.first ? function(b, c, f) {
                while(b = b[d])if (1 === b.nodeType || e) return a(b, c, f);
            } : function(b, c, g) {
                var h, i, j, k = [
                    w,
                    f
                ];
                if (g) {
                    while(b = b[d])if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
                } else while(b = b[d])if (1 === b.nodeType || e) {
                    if (j = b[u] || (b[u] = {}), i = j[b.uniqueID] || (j[b.uniqueID] = {}), (h = i[d]) && h[0] === w && h[1] === f) return k[2] = h[2];
                    if (i[d] = k, k[2] = a(b, c, g)) return !0;
                }
            };
        }
        function sa(a) {
            return a.length > 1 ? function(b, c, d) {
                var e = a.length;
                while(e--)if (!a[e](b, c, d)) return !1;
                return !0;
            } : a[0];
        }
        function ta(a, b, c) {
            for(var d = 0, e = b.length; e > d; d++)fa(a, b[d], c);
            return c;
        }
        function ua(a, b, c, d, e) {
            for(var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++)(f = a[h]) && (c && !c(f, d, e) || (g.push(f), j && b.push(h)));
            return g;
        }
        function va(a, b, c, d, e, f) {
            return d && !d[u] && (d = va(d)), e && !e[u] && (e = va(e, f)), ha(function(f, g, h, i) {
                var j, k, l, m = [], n = [], o = g.length, p = f || ta(b || "*", h.nodeType ? [
                    h
                ] : h, []), q = !a || !f && b ? p : ua(p, m, a, h, i), r = c ? e || (f ? a : o || d) ? [] : g : q;
                if (c && c(q, r, h, i), d) {
                    j = ua(r, n), d(j, [], h, i), k = j.length;
                    while(k--)(l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
                }
                if (f) {
                    if (e || a) {
                        if (e) {
                            j = [], k = r.length;
                            while(k--)(l = r[k]) && j.push(q[k] = l);
                            e(null, r = [], j, i);
                        }
                        k = r.length;
                        while(k--)(l = r[k]) && (j = e ? J(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l));
                    }
                } else r = ua(r === g ? r.splice(o, r.length) : r), e ? e(null, g, r, i) : H.apply(g, r);
            });
        }
        function wa(a) {
            for(var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = ra(function(a) {
                return a === b;
            }, h, !0), l = ra(function(a) {
                return J(b, a) > -1;
            }, h, !0), m = [
                function(a, c, d) {
                    var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d));
                    return b = null, e;
                }
            ]; f > i; i++)if (c = d.relative[a[i].type]) m = [
                ra(sa(m), c)
            ];
            else {
                if (c = d.filter[a[i].type].apply(null, a[i].matches), c[u]) {
                    for(e = ++i; f > e; e++)if (d.relative[a[e].type]) break;
                    return va(i > 1 && sa(m), i > 1 && qa(a.slice(0, i - 1).concat({
                        value: " " === a[i - 2].type ? "*" : ""
                    })).replace(Q, "$1"), c, e > i && wa(a.slice(i, e)), f > e && wa(a = a.slice(e)), f > e && qa(a));
                }
                m.push(c);
            }
            return sa(m);
        }
        function xa(a, b) {
            var c = b.length > 0, e = a.length > 0, f = function(f, g, h, i, k) {
                var l, o, q, r = 0, s = "0", t = f && [], u = [], v = j, x = f || e && d.find.TAG("*", k), y = w += null == v ? 1 : Math.random() || .1, z = x.length;
                for(k && (j = g === n || g || k); s !== z && null != (l = x[s]); s++){
                    if (e && l) {
                        o = 0, g || l.ownerDocument === n || (m(l), h = !p);
                        while(q = a[o++])if (q(l, g || n, h)) {
                            i.push(l);
                            break;
                        }
                        k && (w = y);
                    }
                    c && ((l = !q && l) && r--, f && t.push(l));
                }
                if (r += s, c && s !== r) {
                    o = 0;
                    while(q = b[o++])q(t, u, g, h);
                    if (f) {
                        if (r > 0) while(s--)t[s] || u[s] || (u[s] = F.call(i));
                        u = ua(u);
                    }
                    H.apply(i, u), k && !f && u.length > 0 && r + b.length > 1 && fa.uniqueSort(i);
                }
                return k && (w = y, j = v), t;
            };
            return c ? ha(f) : f;
        }
        return h = fa.compile = function(a, b) {
            var c, d = [], e = [], f = A[a + " "];
            if (!f) {
                b || (b = g(a)), c = b.length;
                while(c--)f = wa(b[c]), f[u] ? d.push(f) : e.push(f);
                f = A(a, xa(e, d)), f.selector = a;
            }
            return f;
        }, i = fa.select = function(a, b, e, f) {
            var i, j, k, l, m, n = "function" == typeof a && a, o = !f && g(a = n.selector || a);
            if (e = e || [], 1 === o.length) {
                if (j = o[0] = o[0].slice(0), j.length > 2 && "ID" === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type]) {
                    if (b = (d.find.ID(k.matches[0].replace(ba, ca), b) || [])[0], !b) return e;
                    n && (b = b.parentNode), a = a.slice(j.shift().value.length);
                }
                i = W.needsContext.test(a) ? 0 : j.length;
                while(i--){
                    if (k = j[i], d.relative[l = k.type]) break;
                    if ((m = d.find[l]) && (f = m(k.matches[0].replace(ba, ca), _.test(j[0].type) && oa(b.parentNode) || b))) {
                        if (j.splice(i, 1), a = f.length && qa(j), !a) return H.apply(e, f), e;
                        break;
                    }
                }
            }
            return (n || h(a, o))(f, b, !p, e, !b || _.test(a) && oa(b.parentNode) || b), e;
        }, c.sortStable = u.split("").sort(B).join("") === u, c.detectDuplicates = !!l, m(), c.sortDetached = ia(function(a) {
            return 1 & a.compareDocumentPosition(n.createElement("div"));
        }), ia(function(a) {
            return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href");
        }) || ja("type|href|height|width", function(a, b, c) {
            return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
        }), c.attributes && ia(function(a) {
            return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value");
        }) || ja("value", function(a, b, c) {
            return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue;
        }), ia(function(a) {
            return null == a.getAttribute("disabled");
        }) || ja(K, function(a, b, c) {
            var d;
            return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null;
        }), fa;
    }(a);
    n.find = t, n.expr = t.selectors, n.expr[":"] = n.expr.pseudos, n.uniqueSort = n.unique = t.uniqueSort, n.text = t.getText, n.isXMLDoc = t.isXML, n.contains = t.contains;
    var u = function(a, b, c) {
        var d = [], e = void 0 !== c;
        while((a = a[b]) && 9 !== a.nodeType)if (1 === a.nodeType) {
            if (e && n(a).is(c)) break;
            d.push(a);
        }
        return d;
    }, v = function(a, b) {
        for(var c = []; a; a = a.nextSibling)1 === a.nodeType && a !== b && c.push(a);
        return c;
    }, w = n.expr.match.needsContext, x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/, y = /^.[^:#\[\.,]*$/;
    function z(a, b, c) {
        if (n.isFunction(b)) return n.grep(a, function(a, d) {
            return !!b.call(a, d, a) !== c;
        });
        if (b.nodeType) return n.grep(a, function(a) {
            return a === b !== c;
        });
        if ("string" == typeof b) {
            if (y.test(b)) return n.filter(b, a, c);
            b = n.filter(b, a);
        }
        return n.grep(a, function(a) {
            return h.call(b, a) > -1 !== c;
        });
    }
    n.filter = function(a, b, c) {
        var d = b[0];
        return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? n.find.matchesSelector(d, a) ? [
            d
        ] : [] : n.find.matches(a, n.grep(b, function(a) {
            return 1 === a.nodeType;
        }));
    }, n.fn.extend({
        find: function(a) {
            var b, c = this.length, d = [], e = this;
            if ("string" != typeof a) return this.pushStack(n(a).filter(function() {
                for(b = 0; c > b; b++)if (n.contains(e[b], this)) return !0;
            }));
            for(b = 0; c > b; b++)n.find(a, e[b], d);
            return d = this.pushStack(c > 1 ? n.unique(d) : d), d.selector = this.selector ? this.selector + " " + a : a, d;
        },
        filter: function(a) {
            return this.pushStack(z(this, a || [], !1));
        },
        not: function(a) {
            return this.pushStack(z(this, a || [], !0));
        },
        is: function(a) {
            return !!z(this, "string" == typeof a && w.test(a) ? n(a) : a || [], !1).length;
        }
    });
    var A, B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/, C = n.fn.init = function(a, b, c) {
        var e, f;
        if (!a) return this;
        if (c = c || A, "string" == typeof a) {
            if (e = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [
                null,
                a,
                null
            ] : B.exec(a), !e || !e[1] && b) return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);
            if (e[1]) {
                if (b = b instanceof n ? b[0] : b, n.merge(this, n.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)), x.test(e[1]) && n.isPlainObject(b)) for(e in b)n.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
                return this;
            }
            return f = d.getElementById(e[2]), f && f.parentNode && (this.length = 1, this[0] = f), this.context = d, this.selector = a, this;
        }
        return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : n.isFunction(a) ? void 0 !== c.ready ? c.ready(a) : a(n) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), n.makeArray(a, this));
    };
    C.prototype = n.fn, A = n(d);
    var D = /^(?:parents|prev(?:Until|All))/, E = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    n.fn.extend({
        has: function(a) {
            var b = n(a, this), c = b.length;
            return this.filter(function() {
                for(var a = 0; c > a; a++)if (n.contains(this, b[a])) return !0;
            });
        },
        closest: function(a, b) {
            for(var c, d = 0, e = this.length, f = [], g = w.test(a) || "string" != typeof a ? n(a, b || this.context) : 0; e > d; d++)for(c = this[d]; c && c !== b; c = c.parentNode)if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && n.find.matchesSelector(c, a))) {
                f.push(c);
                break;
            }
            return this.pushStack(f.length > 1 ? n.uniqueSort(f) : f);
        },
        index: function(a) {
            return a ? "string" == typeof a ? h.call(n(a), this[0]) : h.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function(a, b) {
            return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a, b))));
        },
        addBack: function(a) {
            return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
        }
    });
    function F(a, b) {
        while((a = a[b]) && 1 !== a.nodeType);
        return a;
    }
    n.each({
        parent: function(a) {
            var b = a.parentNode;
            return b && 11 !== b.nodeType ? b : null;
        },
        parents: function(a) {
            return u(a, "parentNode");
        },
        parentsUntil: function(a, b, c) {
            return u(a, "parentNode", c);
        },
        next: function(a) {
            return F(a, "nextSibling");
        },
        prev: function(a) {
            return F(a, "previousSibling");
        },
        nextAll: function(a) {
            return u(a, "nextSibling");
        },
        prevAll: function(a) {
            return u(a, "previousSibling");
        },
        nextUntil: function(a, b, c) {
            return u(a, "nextSibling", c);
        },
        prevUntil: function(a, b, c) {
            return u(a, "previousSibling", c);
        },
        siblings: function(a) {
            return v((a.parentNode || {}).firstChild, a);
        },
        children: function(a) {
            return v(a.firstChild);
        },
        contents: function(a) {
            return a.contentDocument || n.merge([], a.childNodes);
        }
    }, function(a, b) {
        n.fn[a] = function(c, d) {
            var e = n.map(this, b, c);
            return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = n.filter(d, e)), this.length > 1 && (E[a] || n.uniqueSort(e), D.test(a) && e.reverse()), this.pushStack(e);
        };
    });
    var G = /\S+/g;
    function H(a) {
        var b = {};
        return n.each(a.match(G) || [], function(a, c) {
            b[c] = !0;
        }), b;
    }
    n.Callbacks = function(a) {
        a = "string" == typeof a ? H(a) : n.extend({}, a);
        var b, c, d, e, f = [], g = [], h = -1, i = function() {
            for(e = a.once, d = b = !0; g.length; h = -1){
                c = g.shift();
                while(++h < f.length)f[h].apply(c[0], c[1]) === !1 && a.stopOnFalse && (h = f.length, c = !1);
            }
            a.memory || (c = !1), b = !1, e && (f = c ? [] : "");
        }, j = {
            add: function() {
                return f && (c && !b && (h = f.length - 1, g.push(c)), function d(b) {
                    n.each(b, function(b, c) {
                        n.isFunction(c) ? a.unique && j.has(c) || f.push(c) : c && c.length && "string" !== n.type(c) && d(c);
                    });
                }(arguments), c && !b && i()), this;
            },
            remove: function() {
                return n.each(arguments, function(a, b) {
                    var c;
                    while((c = n.inArray(b, f, c)) > -1)f.splice(c, 1), h >= c && h--;
                }), this;
            },
            has: function(a) {
                return a ? n.inArray(a, f) > -1 : f.length > 0;
            },
            empty: function() {
                return f && (f = []), this;
            },
            disable: function() {
                return e = g = [], f = c = "", this;
            },
            disabled: function() {
                return !f;
            },
            lock: function() {
                return e = g = [], c || (f = c = ""), this;
            },
            locked: function() {
                return !!e;
            },
            fireWith: function(a, c) {
                return e || (c = c || [], c = [
                    a,
                    c.slice ? c.slice() : c
                ], g.push(c), b || i()), this;
            },
            fire: function() {
                return j.fireWith(this, arguments), this;
            },
            fired: function() {
                return !!d;
            }
        };
        return j;
    }, n.extend({
        Deferred: function(a) {
            var b = [
                [
                    "resolve",
                    "done",
                    n.Callbacks("once memory"),
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    n.Callbacks("once memory"),
                    "rejected"
                ],
                [
                    "notify",
                    "progress",
                    n.Callbacks("memory")
                ]
            ], c = "pending", d = {
                state: function() {
                    return c;
                },
                always: function() {
                    return e.done(arguments).fail(arguments), this;
                },
                then: function() {
                    var a = arguments;
                    return n.Deferred(function(c) {
                        n.each(b, function(b, f) {
                            var g = n.isFunction(a[b]) && a[b];
                            e[f[1]](function() {
                                var a = g && g.apply(this, arguments);
                                a && n.isFunction(a.promise) ? a.promise().progress(c.notify).done(c.resolve).fail(c.reject) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [
                                    a
                                ] : arguments);
                            });
                        }), a = null;
                    }).promise();
                },
                promise: function(a) {
                    return null != a ? n.extend(a, d) : d;
                }
            }, e = {};
            return d.pipe = d.then, n.each(b, function(a, f) {
                var g = f[2], h = f[3];
                d[f[1]] = g.add, h && g.add(function() {
                    c = h;
                }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function() {
                    return e[f[0] + "With"](this === e ? d : this, arguments), this;
                }, e[f[0] + "With"] = g.fireWith;
            }), d.promise(e), a && a.call(e, e), e;
        },
        when: function(a) {
            var b = 0, c = e.call(arguments), d = c.length, f = 1 !== d || a && n.isFunction(a.promise) ? d : 0, g = 1 === f ? a : n.Deferred(), h = function(a, b, c) {
                return function(d) {
                    b[a] = this, c[a] = arguments.length > 1 ? e.call(arguments) : d, c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c);
                };
            }, i, j, k;
            if (d > 1) for(i = new Array(d), j = new Array(d), k = new Array(d); d > b; b++)c[b] && n.isFunction(c[b].promise) ? c[b].promise().progress(h(b, j, i)).done(h(b, k, c)).fail(g.reject) : --f;
            return f || g.resolveWith(k, c), g.promise();
        }
    });
    var I;
    n.fn.ready = function(a) {
        return n.ready.promise().done(a), this;
    }, n.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(a) {
            a ? n.readyWait++ : n.ready(!0);
        },
        ready: function(a) {
            (a === !0 ? --n.readyWait : n.isReady) || (n.isReady = !0, a !== !0 && --n.readyWait > 0 || (I.resolveWith(d, [
                n
            ]), n.fn.triggerHandler && (n(d).triggerHandler("ready"), n(d).off("ready"))));
        }
    });
    function J() {
        d.removeEventListener("DOMContentLoaded", J), a.removeEventListener("load", J), n.ready();
    }
    n.ready.promise = function(b) {
        return I || (I = n.Deferred(), "complete" === d.readyState || "loading" !== d.readyState && !d.documentElement.doScroll ? a.setTimeout(n.ready) : (d.addEventListener("DOMContentLoaded", J), a.addEventListener("load", J))), I.promise(b);
    }, n.ready.promise();
    var K = function(a, b, c, d, e, f, g) {
        var h = 0, i = a.length, j = null == c;
        if ("object" === n.type(c)) {
            e = !0;
            for(h in c)K(a, b, h, c[h], !0, f, g);
        } else if (void 0 !== d && (e = !0, n.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function(a, b, c) {
            return j.call(n(a), c);
        })), b)) for(; i > h; h++)b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
        return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
    }, L = function(a) {
        return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType;
    };
    function M() {
        this.expando = n.expando + M.uid++;
    }
    M.uid = 1, M.prototype = {
        register: function(a, b) {
            var c = b || {};
            return a.nodeType ? a[this.expando] = c : Object.defineProperty(a, this.expando, {
                value: c,
                writable: !0,
                configurable: !0
            }), a[this.expando];
        },
        cache: function(a) {
            if (!L(a)) return {};
            var b = a[this.expando];
            return b || (b = {}, L(a) && (a.nodeType ? a[this.expando] = b : Object.defineProperty(a, this.expando, {
                value: b,
                configurable: !0
            }))), b;
        },
        set: function(a, b, c) {
            var d, e = this.cache(a);
            if ("string" == typeof b) e[b] = c;
            else for(d in b)e[d] = b[d];
            return e;
        },
        get: function(a, b) {
            return void 0 === b ? this.cache(a) : a[this.expando] && a[this.expando][b];
        },
        access: function(a, b, c) {
            var d;
            return void 0 === b || b && "string" == typeof b && void 0 === c ? (d = this.get(a, b), void 0 !== d ? d : this.get(a, n.camelCase(b))) : (this.set(a, b, c), void 0 !== c ? c : b);
        },
        remove: function(a, b) {
            var c, d, e, f = a[this.expando];
            if (void 0 !== f) {
                if (void 0 === b) this.register(a);
                else {
                    n.isArray(b) ? d = b.concat(b.map(n.camelCase)) : (e = n.camelCase(b), b in f ? d = [
                        b,
                        e
                    ] : (d = e, d = d in f ? [
                        d
                    ] : d.match(G) || [])), c = d.length;
                    while(c--)delete f[d[c]];
                }
                (void 0 === b || n.isEmptyObject(f)) && (a.nodeType ? a[this.expando] = void 0 : delete a[this.expando]);
            }
        },
        hasData: function(a) {
            var b = a[this.expando];
            return void 0 !== b && !n.isEmptyObject(b);
        }
    };
    var N = new M, O = new M, P = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, Q = /[A-Z]/g;
    function R(a, b, c) {
        var d;
        if (void 0 === c && 1 === a.nodeType) {
            if (d = "data-" + b.replace(Q, "-$&").toLowerCase(), c = a.getAttribute(d), "string" == typeof c) {
                try {
                    c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : P.test(c) ? n.parseJSON(c) : c;
                } catch (e) {}
                O.set(a, b, c);
            } else c = void 0;
        }
        return c;
    }
    n.extend({
        hasData: function(a) {
            return O.hasData(a) || N.hasData(a);
        },
        data: function(a, b, c) {
            return O.access(a, b, c);
        },
        removeData: function(a, b) {
            O.remove(a, b);
        },
        _data: function(a, b, c) {
            return N.access(a, b, c);
        },
        _removeData: function(a, b) {
            N.remove(a, b);
        }
    }), n.fn.extend({
        data: function(a, b) {
            var c, d, e, f = this[0], g = f && f.attributes;
            if (void 0 === a) {
                if (this.length && (e = O.get(f), 1 === f.nodeType && !N.get(f, "hasDataAttrs"))) {
                    c = g.length;
                    while(c--)g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = n.camelCase(d.slice(5)), R(f, d, e[d])));
                    N.set(f, "hasDataAttrs", !0);
                }
                return e;
            }
            return "object" == typeof a ? this.each(function() {
                O.set(this, a);
            }) : K(this, function(b) {
                var c, d;
                if (f && void 0 === b) {
                    if (c = O.get(f, a) || O.get(f, a.replace(Q, "-$&").toLowerCase()), void 0 !== c) return c;
                    if (d = n.camelCase(a), c = O.get(f, d), void 0 !== c) return c;
                    if (c = R(f, d, void 0), void 0 !== c) return c;
                } else d = n.camelCase(a), this.each(function() {
                    var c = O.get(this, d);
                    O.set(this, d, b), a.indexOf("-") > -1 && void 0 !== c && O.set(this, a, b);
                });
            }, null, b, arguments.length > 1, null, !0);
        },
        removeData: function(a) {
            return this.each(function() {
                O.remove(this, a);
            });
        }
    }), n.extend({
        queue: function(a, b, c) {
            var d;
            return a ? (b = (b || "fx") + "queue", d = N.get(a, b), c && (!d || n.isArray(c) ? d = N.access(a, b, n.makeArray(c)) : d.push(c)), d || []) : void 0;
        },
        dequeue: function(a, b) {
            b = b || "fx";
            var c = n.queue(a, b), d = c.length, e = c.shift(), f = n._queueHooks(a, b), g = function() {
                n.dequeue(a, b);
            };
            "inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire();
        },
        _queueHooks: function(a, b) {
            var c = b + "queueHooks";
            return N.get(a, c) || N.access(a, c, {
                empty: n.Callbacks("once memory").add(function() {
                    N.remove(a, [
                        b + "queue",
                        c
                    ]);
                })
            });
        }
    }), n.fn.extend({
        queue: function(a, b) {
            var c = 2;
            return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? n.queue(this[0], a) : void 0 === b ? this : this.each(function() {
                var c = n.queue(this, a, b);
                n._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a);
            });
        },
        dequeue: function(a) {
            return this.each(function() {
                n.dequeue(this, a);
            });
        },
        clearQueue: function(a) {
            return this.queue(a || "fx", []);
        },
        promise: function(a, b) {
            var c, d = 1, e = n.Deferred(), f = this, g = this.length, h = function() {
                --d || e.resolveWith(f, [
                    f
                ]);
            };
            "string" != typeof a && (b = a, a = void 0), a = a || "fx";
            while(g--)c = N.get(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
            return h(), e.promise(b);
        }
    });
    var S = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, T = new RegExp("^(?:([+-])=|)(" + S + ")([a-z%]*)$", "i"), U = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ], V = function(a, b) {
        return a = b || a, "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a);
    };
    function W(a, b, c, d) {
        var e, f = 1, g = 20, h = d ? function() {
            return d.cur();
        } : function() {
            return n.css(a, b, "");
        }, i = h(), j = c && c[3] || (n.cssNumber[b] ? "" : "px"), k = (n.cssNumber[b] || "px" !== j && +i) && T.exec(n.css(a, b));
        if (k && k[3] !== j) {
            j = j || k[3], c = c || [], k = +i || 1;
            do f = f || ".5", k /= f, n.style(a, b, k + j);
            while (f !== (f = h() / i) && 1 !== f && --g);
        }
        return c && (k = +k || +i || 0, e = c[1] ? k + (c[1] + 1) * c[2] : +c[2], d && (d.unit = j, d.start = k, d.end = e)), e;
    }
    var X = /^(?:checkbox|radio)$/i, Y = /<([\w:-]+)/, Z = /^$|\/(?:java|ecma)script/i, $ = {
        option: [
            1,
            "<select multiple='multiple'>",
            "</select>"
        ],
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    $.optgroup = $.option, $.tbody = $.tfoot = $.colgroup = $.caption = $.thead, $.th = $.td;
    function _(a, b) {
        var c = "undefined" != typeof a.getElementsByTagName ? a.getElementsByTagName(b || "*") : "undefined" != typeof a.querySelectorAll ? a.querySelectorAll(b || "*") : [];
        return void 0 === b || b && n.nodeName(a, b) ? n.merge([
            a
        ], c) : c;
    }
    function aa(a, b) {
        for(var c = 0, d = a.length; d > c; c++)N.set(a[c], "globalEval", !b || N.get(b[c], "globalEval"));
    }
    var ba = /<|&#?\w+;/;
    function ca(a, b, c, d, e) {
        for(var f, g, h, i, j, k, l = b.createDocumentFragment(), m = [], o = 0, p = a.length; p > o; o++)if (f = a[o], f || 0 === f) {
            if ("object" === n.type(f)) n.merge(m, f.nodeType ? [
                f
            ] : f);
            else if (ba.test(f)) {
                g = g || l.appendChild(b.createElement("div")), h = (Y.exec(f) || [
                    "",
                    ""
                ])[1].toLowerCase(), i = $[h] || $._default, g.innerHTML = i[1] + n.htmlPrefilter(f) + i[2], k = i[0];
                while(k--)g = g.lastChild;
                n.merge(m, g.childNodes), g = l.firstChild, g.textContent = "";
            } else m.push(b.createTextNode(f));
        }
        l.textContent = "", o = 0;
        while(f = m[o++])if (d && n.inArray(f, d) > -1) e && e.push(f);
        else if (j = n.contains(f.ownerDocument, f), g = _(l.appendChild(f), "script"), j && aa(g), c) {
            k = 0;
            while(f = g[k++])Z.test(f.type || "") && c.push(f);
        }
        return l;
    }
    !function() {
        var a = d.createDocumentFragment(), b = a.appendChild(d.createElement("div")), c = d.createElement("input");
        c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), b.appendChild(c), l.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, b.innerHTML = "<textarea>x</textarea>", l.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue;
    }();
    var da = /^key/, ea = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, fa = /^([^.]*)(?:\.(.+)|)/;
    function ga() {
        return !0;
    }
    function ha() {
        return !1;
    }
    function ia() {
        try {
            return d.activeElement;
        } catch (a) {}
    }
    function ja(a, b, c, d, e, f) {
        var g, h;
        if ("object" == typeof b) {
            "string" != typeof c && (d = d || c, c = void 0);
            for(h in b)ja(a, h, c, d, b[h], f);
            return a;
        }
        if (null == d && null == e ? (e = c, d = c = void 0) : null == e && ("string" == typeof c ? (e = d, d = void 0) : (e = d, d = c, c = void 0)), e === !1) e = ha;
        else if (!e) return a;
        return 1 === f && (g = e, e = function(a) {
            return n().off(a), g.apply(this, arguments);
        }, e.guid = g.guid || (g.guid = n.guid++)), a.each(function() {
            n.event.add(this, b, e, d, c);
        });
    }
    n.event = {
        global: {},
        add: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, o, p, q, r = N.get(a);
            if (r) {
                c.handler && (f = c, c = f.handler, e = f.selector), c.guid || (c.guid = n.guid++), (i = r.events) || (i = r.events = {}), (g = r.handle) || (g = r.handle = function(b) {
                    return "undefined" != typeof n && n.event.triggered !== b.type ? n.event.dispatch.apply(a, arguments) : void 0;
                }), b = (b || "").match(G) || [
                    ""
                ], j = b.length;
                while(j--)h = fa.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o && (l = n.event.special[o] || {}, o = (e ? l.delegateType : l.bindType) || o, l = n.event.special[o] || {}, k = n.extend({
                    type: o,
                    origType: q,
                    data: d,
                    handler: c,
                    guid: c.guid,
                    selector: e,
                    needsContext: e && n.expr.match.needsContext.test(e),
                    namespace: p.join(".")
                }, f), (m = i[o]) || (m = i[o] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, p, g) !== !1 || a.addEventListener && a.addEventListener(o, g)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), n.event.global[o] = !0);
            }
        },
        remove: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, o, p, q, r = N.hasData(a) && N.get(a);
            if (r && (i = r.events)) {
                b = (b || "").match(G) || [
                    ""
                ], j = b.length;
                while(j--)if (h = fa.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o) {
                    l = n.event.special[o] || {}, o = (d ? l.delegateType : l.bindType) || o, m = i[o] || [], h = h[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length;
                    while(f--)k = m[f], !e && q !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));
                    g && !m.length && (l.teardown && l.teardown.call(a, p, r.handle) !== !1 || n.removeEvent(a, o, r.handle), delete i[o]);
                } else for(o in i)n.event.remove(a, o + b[j], c, d, !0);
                n.isEmptyObject(i) && N.remove(a, "handle events");
            }
        },
        dispatch: function(a) {
            a = n.event.fix(a);
            var b, c, d, f, g, h = [], i = e.call(arguments), j = (N.get(this, "events") || {})[a.type] || [], k = n.event.special[a.type] || {};
            if (i[0] = a, a.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, a) !== !1) {
                h = n.event.handlers.call(this, a, j), b = 0;
                while((f = h[b++]) && !a.isPropagationStopped()){
                    a.currentTarget = f.elem, c = 0;
                    while((g = f.handlers[c++]) && !a.isImmediatePropagationStopped())a.rnamespace && !a.rnamespace.test(g.namespace) || (a.handleObj = g, a.data = g.data, d = ((n.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i), void 0 !== d && (a.result = d) === !1 && (a.preventDefault(), a.stopPropagation()));
                }
                return k.postDispatch && k.postDispatch.call(this, a), a.result;
            }
        },
        handlers: function(a, b) {
            var c, d, e, f, g = [], h = b.delegateCount, i = a.target;
            if (h && i.nodeType && ("click" !== a.type || isNaN(a.button) || a.button < 1)) {
                for(; i !== this; i = i.parentNode || this)if (1 === i.nodeType && (i.disabled !== !0 || "click" !== a.type)) {
                    for(d = [], c = 0; h > c; c++)f = b[c], e = f.selector + " ", void 0 === d[e] && (d[e] = f.needsContext ? n(e, this).index(i) > -1 : n.find(e, this, null, [
                        i
                    ]).length), d[e] && d.push(f);
                    d.length && g.push({
                        elem: i,
                        handlers: d
                    });
                }
            }
            return h < b.length && g.push({
                elem: this,
                handlers: b.slice(h)
            }), g;
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(a, b) {
                return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a;
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(a, b) {
                var c, e, f, g = b.button;
                return null == a.pageX && null != b.clientX && (c = a.target.ownerDocument || d, e = c.documentElement, f = c.body, a.pageX = b.clientX + (e && e.scrollLeft || f && f.scrollLeft || 0) - (e && e.clientLeft || f && f.clientLeft || 0), a.pageY = b.clientY + (e && e.scrollTop || f && f.scrollTop || 0) - (e && e.clientTop || f && f.clientTop || 0)), a.which || void 0 === g || (a.which = 1 & g ? 1 : 2 & g ? 3 : 4 & g ? 2 : 0), a;
            }
        },
        fix: function(a) {
            if (a[n.expando]) return a;
            var b, c, e, f = a.type, g = a, h = this.fixHooks[f];
            h || (this.fixHooks[f] = h = ea.test(f) ? this.mouseHooks : da.test(f) ? this.keyHooks : {}), e = h.props ? this.props.concat(h.props) : this.props, a = new n.Event(g), b = e.length;
            while(b--)c = e[b], a[c] = g[c];
            return a.target || (a.target = d), 3 === a.target.nodeType && (a.target = a.target.parentNode), h.filter ? h.filter(a, g) : a;
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== ia() && this.focus ? (this.focus(), !1) : void 0;
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === ia() && this.blur ? (this.blur(), !1) : void 0;
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && n.nodeName(this, "input") ? (this.click(), !1) : void 0;
                },
                _default: function(a) {
                    return n.nodeName(a.target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(a) {
                    void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result);
                }
            }
        }
    }, n.removeEvent = function(a, b, c) {
        a.removeEventListener && a.removeEventListener(b, c);
    }, n.Event = function(a, b) {
        return this instanceof n.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? ga : ha) : this.type = a, b && n.extend(this, b), this.timeStamp = a && a.timeStamp || n.now(), void (this[n.expando] = !0)) : new n.Event(a, b);
    }, n.Event.prototype = {
        constructor: n.Event,
        isDefaultPrevented: ha,
        isPropagationStopped: ha,
        isImmediatePropagationStopped: ha,
        isSimulated: !1,
        preventDefault: function() {
            var a = this.originalEvent;
            this.isDefaultPrevented = ga, a && !this.isSimulated && a.preventDefault();
        },
        stopPropagation: function() {
            var a = this.originalEvent;
            this.isPropagationStopped = ga, a && !this.isSimulated && a.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var a = this.originalEvent;
            this.isImmediatePropagationStopped = ga, a && !this.isSimulated && a.stopImmediatePropagation(), this.stopPropagation();
        }
    }, n.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(a, b) {
        n.event.special[a] = {
            delegateType: b,
            bindType: b,
            handle: function(a) {
                var c, d = this, e = a.relatedTarget, f = a.handleObj;
                return e && (e === d || n.contains(d, e)) || (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c;
            }
        };
    }), n.fn.extend({
        on: function(a, b, c, d) {
            return ja(this, a, b, c, d);
        },
        one: function(a, b, c, d) {
            return ja(this, a, b, c, d, 1);
        },
        off: function(a, b, c) {
            var d, e;
            if (a && a.preventDefault && a.handleObj) return d = a.handleObj, n(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;
            if ("object" == typeof a) {
                for(e in a)this.off(e, b, a[e]);
                return this;
            }
            return b !== !1 && "function" != typeof b || (c = b, b = void 0), c === !1 && (c = ha), this.each(function() {
                n.event.remove(this, a, c, b);
            });
        }
    });
    var ka = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi, la = /<script|<style|<link/i, ma = /checked\s*(?:[^=]|=\s*.checked.)/i, na = /^true\/(.*)/, oa = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function pa(a, b) {
        return n.nodeName(a, "table") && n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a;
    }
    function qa(a) {
        return a.type = (null !== a.getAttribute("type")) + "/" + a.type, a;
    }
    function ra(a) {
        var b = na.exec(a.type);
        return b ? a.type = b[1] : a.removeAttribute("type"), a;
    }
    function sa(a, b) {
        var c, d, e, f, g, h, i, j;
        if (1 === b.nodeType) {
            if (N.hasData(a) && (f = N.access(a), g = N.set(b, f), j = f.events)) {
                delete g.handle, g.events = {};
                for(e in j)for(c = 0, d = j[e].length; d > c; c++)n.event.add(b, e, j[e][c]);
            }
            O.hasData(a) && (h = O.access(a), i = n.extend({}, h), O.set(b, i));
        }
    }
    function ta(a, b) {
        var c = b.nodeName.toLowerCase();
        "input" === c && X.test(a.type) ? b.checked = a.checked : "input" !== c && "textarea" !== c || (b.defaultValue = a.defaultValue);
    }
    function ua(a, b, c, d) {
        b = f.apply([], b);
        var e, g, h, i, j, k, m = 0, o = a.length, p = o - 1, q = b[0], r = n.isFunction(q);
        if (r || o > 1 && "string" == typeof q && !l.checkClone && ma.test(q)) return a.each(function(e) {
            var f = a.eq(e);
            r && (b[0] = q.call(this, e, f.html())), ua(f, b, c, d);
        });
        if (o && (e = ca(b, a[0].ownerDocument, !1, a, d), g = e.firstChild, 1 === e.childNodes.length && (e = g), g || d)) {
            for(h = n.map(_(e, "script"), qa), i = h.length; o > m; m++)j = e, m !== p && (j = n.clone(j, !0, !0), i && n.merge(h, _(j, "script"))), c.call(a[m], j, m);
            if (i) for(k = h[h.length - 1].ownerDocument, n.map(h, ra), m = 0; i > m; m++)j = h[m], Z.test(j.type || "") && !N.access(j, "globalEval") && n.contains(k, j) && (j.src ? n._evalUrl && n._evalUrl(j.src) : n.globalEval(j.textContent.replace(oa, "")));
        }
        return a;
    }
    function va(a, b, c) {
        for(var d, e = b ? n.filter(b, a) : a, f = 0; null != (d = e[f]); f++)c || 1 !== d.nodeType || n.cleanData(_(d)), d.parentNode && (c && n.contains(d.ownerDocument, d) && aa(_(d, "script")), d.parentNode.removeChild(d));
        return a;
    }
    n.extend({
        htmlPrefilter: function(a) {
            return a.replace(ka, "<$1></$2>");
        },
        clone: function(a, b, c) {
            var d, e, f, g, h = a.cloneNode(!0), i = n.contains(a.ownerDocument, a);
            if (!(l.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || n.isXMLDoc(a))) for(g = _(h), f = _(a), d = 0, e = f.length; e > d; d++)ta(f[d], g[d]);
            if (b) {
                if (c) for(f = f || _(a), g = g || _(h), d = 0, e = f.length; e > d; d++)sa(f[d], g[d]);
                else sa(a, h);
            }
            return g = _(h, "script"), g.length > 0 && aa(g, !i && _(a, "script")), h;
        },
        cleanData: function(a) {
            for(var b, c, d, e = n.event.special, f = 0; void 0 !== (c = a[f]); f++)if (L(c)) {
                if (b = c[N.expando]) {
                    if (b.events) for(d in b.events)e[d] ? n.event.remove(c, d) : n.removeEvent(c, d, b.handle);
                    c[N.expando] = void 0;
                }
                c[O.expando] && (c[O.expando] = void 0);
            }
        }
    }), n.fn.extend({
        domManip: ua,
        detach: function(a) {
            return va(this, a, !0);
        },
        remove: function(a) {
            return va(this, a);
        },
        text: function(a) {
            return K(this, function(a) {
                return void 0 === a ? n.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = a);
                });
            }, null, a, arguments.length);
        },
        append: function() {
            return ua(this, arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = pa(this, a);
                    b.appendChild(a);
                }
            });
        },
        prepend: function() {
            return ua(this, arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = pa(this, a);
                    b.insertBefore(a, b.firstChild);
                }
            });
        },
        before: function() {
            return ua(this, arguments, function(a) {
                this.parentNode && this.parentNode.insertBefore(a, this);
            });
        },
        after: function() {
            return ua(this, arguments, function(a) {
                this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
            });
        },
        empty: function() {
            for(var a, b = 0; null != (a = this[b]); b++)1 === a.nodeType && (n.cleanData(_(a, !1)), a.textContent = "");
            return this;
        },
        clone: function(a, b) {
            return a = null == a ? !1 : a, b = null == b ? a : b, this.map(function() {
                return n.clone(this, a, b);
            });
        },
        html: function(a) {
            return K(this, function(a) {
                var b = this[0] || {}, c = 0, d = this.length;
                if (void 0 === a && 1 === b.nodeType) return b.innerHTML;
                if ("string" == typeof a && !la.test(a) && !$[(Y.exec(a) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    a = n.htmlPrefilter(a);
                    try {
                        for(; d > c; c++)b = this[c] || {}, 1 === b.nodeType && (n.cleanData(_(b, !1)), b.innerHTML = a);
                        b = 0;
                    } catch (e) {}
                }
                b && this.empty().append(a);
            }, null, a, arguments.length);
        },
        replaceWith: function() {
            var a = [];
            return ua(this, arguments, function(b) {
                var c = this.parentNode;
                n.inArray(this, a) < 0 && (n.cleanData(_(this)), c && c.replaceChild(b, this));
            }, a);
        }
    }), n.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(a, b) {
        n.fn[a] = function(a) {
            for(var c, d = [], e = n(a), f = e.length - 1, h = 0; f >= h; h++)c = h === f ? this : this.clone(!0), n(e[h])[b](c), g.apply(d, c.get());
            return this.pushStack(d);
        };
    });
    var wa, xa = {
        HTML: "block",
        BODY: "block"
    };
    function ya(a, b) {
        var c = n(b.createElement(a)).appendTo(b.body), d = n.css(c[0], "display");
        return c.detach(), d;
    }
    function za(a) {
        var b = d, c = xa[a];
        return c || (c = ya(a, b), "none" !== c && c || (wa = (wa || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement), b = wa[0].contentDocument, b.write(), b.close(), c = ya(a, b), wa.detach()), xa[a] = c), c;
    }
    var Aa = /^margin/, Ba = new RegExp("^(" + S + ")(?!px)[a-z%]+$", "i"), Ca = function(b) {
        var c = b.ownerDocument.defaultView;
        return c && c.opener || (c = a), c.getComputedStyle(b);
    }, Da = function(a, b, c, d) {
        var e, f, g = {};
        for(f in b)g[f] = a.style[f], a.style[f] = b[f];
        e = c.apply(a, d || []);
        for(f in b)a.style[f] = g[f];
        return e;
    }, Ea = d.documentElement;
    !function() {
        var b, c, e, f, g = d.createElement("div"), h = d.createElement("div");
        if (h.style) {
            h.style.backgroundClip = "content-box", h.cloneNode(!0).style.backgroundClip = "", l.clearCloneStyle = "content-box" === h.style.backgroundClip, g.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", g.appendChild(h);
            function i() {
                h.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", h.innerHTML = "", Ea.appendChild(g);
                var d = a.getComputedStyle(h);
                b = "1%" !== d.top, f = "2px" === d.marginLeft, c = "4px" === d.width, h.style.marginRight = "50%", e = "4px" === d.marginRight, Ea.removeChild(g);
            }
            n.extend(l, {
                pixelPosition: function() {
                    return i(), b;
                },
                boxSizingReliable: function() {
                    return null == c && i(), c;
                },
                pixelMarginRight: function() {
                    return null == c && i(), e;
                },
                reliableMarginLeft: function() {
                    return null == c && i(), f;
                },
                reliableMarginRight: function() {
                    var b, c = h.appendChild(d.createElement("div"));
                    return c.style.cssText = h.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", c.style.marginRight = c.style.width = "0", h.style.width = "1px", Ea.appendChild(g), b = !parseFloat(a.getComputedStyle(c).marginRight), Ea.removeChild(g), h.removeChild(c), b;
                }
            });
        }
    }();
    function Fa(a, b, c) {
        var d, e, f, g, h = a.style;
        return c = c || Ca(a), g = c ? c.getPropertyValue(b) || c[b] : void 0, "" !== g && void 0 !== g || n.contains(a.ownerDocument, a) || (g = n.style(a, b)), c && !l.pixelMarginRight() && Ba.test(g) && Aa.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f), void 0 !== g ? g + "" : g;
    }
    function Ga(a, b) {
        return {
            get: function() {
                return a() ? void delete this.get : (this.get = b).apply(this, arguments);
            }
        };
    }
    var Ha = /^(none|table(?!-c[ea]).+)/, Ia = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, Ja = {
        letterSpacing: "0",
        fontWeight: "400"
    }, Ka = [
        "Webkit",
        "O",
        "Moz",
        "ms"
    ], La = d.createElement("div").style;
    function Ma(a) {
        if (a in La) return a;
        var b = a[0].toUpperCase() + a.slice(1), c = Ka.length;
        while(c--)if (a = Ka[c] + b, a in La) return a;
    }
    function Na(a, b, c) {
        var d = T.exec(b);
        return d ? Math.max(0, d[2] - (c || 0)) + (d[3] || "px") : b;
    }
    function Oa(a, b, c, d, e) {
        for(var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2)"margin" === c && (g += n.css(a, c + U[f], !0, e)), d ? ("content" === c && (g -= n.css(a, "padding" + U[f], !0, e)), "margin" !== c && (g -= n.css(a, "border" + U[f] + "Width", !0, e))) : (g += n.css(a, "padding" + U[f], !0, e), "padding" !== c && (g += n.css(a, "border" + U[f] + "Width", !0, e)));
        return g;
    }
    function Pa(a, b, c) {
        var d = !0, e = "width" === b ? a.offsetWidth : a.offsetHeight, f = Ca(a), g = "border-box" === n.css(a, "boxSizing", !1, f);
        if (0 >= e || null == e) {
            if (e = Fa(a, b, f), (0 > e || null == e) && (e = a.style[b]), Ba.test(e)) return e;
            d = g && (l.boxSizingReliable() || e === a.style[b]), e = parseFloat(e) || 0;
        }
        return e + Oa(a, b, c || (g ? "border" : "content"), d, f) + "px";
    }
    function Qa(a, b) {
        for(var c, d, e, f = [], g = 0, h = a.length; h > g; g++)d = a[g], d.style && (f[g] = N.get(d, "olddisplay"), c = d.style.display, b ? (f[g] || "none" !== c || (d.style.display = ""), "" === d.style.display && V(d) && (f[g] = N.access(d, "olddisplay", za(d.nodeName)))) : (e = V(d), "none" === c && e || N.set(d, "olddisplay", e ? c : n.css(d, "display"))));
        for(g = 0; h > g; g++)d = a[g], d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none"));
        return a;
    }
    n.extend({
        cssHooks: {
            opacity: {
                get: function(a, b) {
                    if (b) {
                        var c = Fa(a, "opacity");
                        return "" === c ? "1" : c;
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            "float": "cssFloat"
        },
        style: function(a, b, c, d) {
            if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
                var e, f, g, h = n.camelCase(b), i = a.style;
                return b = n.cssProps[h] || (n.cssProps[h] = Ma(h) || h), g = n.cssHooks[b] || n.cssHooks[h], void 0 === c ? g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b] : (f = typeof c, "string" === f && (e = T.exec(c)) && e[1] && (c = W(a, b, e), f = "number"), null != c && c === c && ("number" === f && (c += e && e[3] || (n.cssNumber[h] ? "" : "px")), l.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"), g && "set" in g && void 0 === (c = g.set(a, c, d)) || (i[b] = c)), void 0);
            }
        },
        css: function(a, b, c, d) {
            var e, f, g, h = n.camelCase(b);
            return b = n.cssProps[h] || (n.cssProps[h] = Ma(h) || h), g = n.cssHooks[b] || n.cssHooks[h], g && "get" in g && (e = g.get(a, !0, c)), void 0 === e && (e = Fa(a, b, d)), "normal" === e && b in Ja && (e = Ja[b]), "" === c || c ? (f = parseFloat(e), c === !0 || isFinite(f) ? f || 0 : e) : e;
        }
    }), n.each([
        "height",
        "width"
    ], function(a, b) {
        n.cssHooks[b] = {
            get: function(a, c, d) {
                return c ? Ha.test(n.css(a, "display")) && 0 === a.offsetWidth ? Da(a, Ia, function() {
                    return Pa(a, b, d);
                }) : Pa(a, b, d) : void 0;
            },
            set: function(a, c, d) {
                var e, f = d && Ca(a), g = d && Oa(a, b, d, "border-box" === n.css(a, "boxSizing", !1, f), f);
                return g && (e = T.exec(c)) && "px" !== (e[3] || "px") && (a.style[b] = c, c = n.css(a, b)), Na(a, c, g);
            }
        };
    }), n.cssHooks.marginLeft = Ga(l.reliableMarginLeft, function(a, b) {
        return b ? (parseFloat(Fa(a, "marginLeft")) || a.getBoundingClientRect().left - Da(a, {
            marginLeft: 0
        }, function() {
            return a.getBoundingClientRect().left;
        })) + "px" : void 0;
    }), n.cssHooks.marginRight = Ga(l.reliableMarginRight, function(a, b) {
        return b ? Da(a, {
            display: "inline-block"
        }, Fa, [
            a,
            "marginRight"
        ]) : void 0;
    }), n.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(a, b) {
        n.cssHooks[a + b] = {
            expand: function(c) {
                for(var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [
                    c
                ]; 4 > d; d++)e[a + U[d] + b] = f[d] || f[d - 2] || f[0];
                return e;
            }
        }, Aa.test(a) || (n.cssHooks[a + b].set = Na);
    }), n.fn.extend({
        css: function(a, b) {
            return K(this, function(a, b, c) {
                var d, e, f = {}, g = 0;
                if (n.isArray(b)) {
                    for(d = Ca(a), e = b.length; e > g; g++)f[b[g]] = n.css(a, b[g], !1, d);
                    return f;
                }
                return void 0 !== c ? n.style(a, b, c) : n.css(a, b);
            }, a, b, arguments.length > 1);
        },
        show: function() {
            return Qa(this, !0);
        },
        hide: function() {
            return Qa(this);
        },
        toggle: function(a) {
            return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function() {
                V(this) ? n(this).show() : n(this).hide();
            });
        }
    });
    function Ra(a, b, c, d, e) {
        return new Ra.prototype.init(a, b, c, d, e);
    }
    n.Tween = Ra, Ra.prototype = {
        constructor: Ra,
        init: function(a, b, c, d, e, f) {
            this.elem = a, this.prop = c, this.easing = e || n.easing._default, this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (n.cssNumber[c] ? "" : "px");
        },
        cur: function() {
            var a = Ra.propHooks[this.prop];
            return a && a.get ? a.get(this) : Ra.propHooks._default.get(this);
        },
        run: function(a) {
            var b, c = Ra.propHooks[this.prop];
            return this.options.duration ? this.pos = b = n.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : Ra.propHooks._default.set(this), this;
        }
    }, Ra.prototype.init.prototype = Ra.prototype, Ra.propHooks = {
        _default: {
            get: function(a) {
                var b;
                return 1 !== a.elem.nodeType || null != a.elem[a.prop] && null == a.elem.style[a.prop] ? a.elem[a.prop] : (b = n.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0);
            },
            set: function(a) {
                n.fx.step[a.prop] ? n.fx.step[a.prop](a) : 1 !== a.elem.nodeType || null == a.elem.style[n.cssProps[a.prop]] && !n.cssHooks[a.prop] ? a.elem[a.prop] = a.now : n.style(a.elem, a.prop, a.now + a.unit);
            }
        }
    }, Ra.propHooks.scrollTop = Ra.propHooks.scrollLeft = {
        set: function(a) {
            a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
        }
    }, n.easing = {
        linear: function(a) {
            return a;
        },
        swing: function(a) {
            return .5 - Math.cos(a * Math.PI) / 2;
        },
        _default: "swing"
    }, n.fx = Ra.prototype.init, n.fx.step = {};
    var Sa, Ta, Ua = /^(?:toggle|show|hide)$/, Va = /queueHooks$/;
    function Wa() {
        return a.setTimeout(function() {
            Sa = void 0;
        }), Sa = n.now();
    }
    function Xa(a, b) {
        var c, d = 0, e = {
            height: a
        };
        for(b = b ? 1 : 0; 4 > d; d += 2 - b)c = U[d], e["margin" + c] = e["padding" + c] = a;
        return b && (e.opacity = e.width = a), e;
    }
    function Ya(a, b, c) {
        for(var d, e = (_a.tweeners[b] || []).concat(_a.tweeners["*"]), f = 0, g = e.length; g > f; f++)if (d = e[f].call(c, b, a)) return d;
    }
    function Za(a, b, c) {
        var d, e, f, g, h, i, j, k, l = this, m = {}, o = a.style, p = a.nodeType && V(a), q = N.get(a, "fxshow");
        c.queue || (h = n._queueHooks(a, "fx"), null == h.unqueued && (h.unqueued = 0, i = h.empty.fire, h.empty.fire = function() {
            h.unqueued || i();
        }), h.unqueued++, l.always(function() {
            l.always(function() {
                h.unqueued--, n.queue(a, "fx").length || h.empty.fire();
            });
        })), 1 === a.nodeType && ("height" in b || "width" in b) && (c.overflow = [
            o.overflow,
            o.overflowX,
            o.overflowY
        ], j = n.css(a, "display"), k = "none" === j ? N.get(a, "olddisplay") || za(a.nodeName) : j, "inline" === k && "none" === n.css(a, "float") && (o.display = "inline-block")), c.overflow && (o.overflow = "hidden", l.always(function() {
            o.overflow = c.overflow[0], o.overflowX = c.overflow[1], o.overflowY = c.overflow[2];
        }));
        for(d in b)if (e = b[d], Ua.exec(e)) {
            if (delete b[d], f = f || "toggle" === e, e === (p ? "hide" : "show")) {
                if ("show" !== e || !q || void 0 === q[d]) continue;
                p = !0;
            }
            m[d] = q && q[d] || n.style(a, d);
        } else j = void 0;
        if (n.isEmptyObject(m)) "inline" === ("none" === j ? za(a.nodeName) : j) && (o.display = j);
        else {
            q ? "hidden" in q && (p = q.hidden) : q = N.access(a, "fxshow", {}), f && (q.hidden = !p), p ? n(a).show() : l.done(function() {
                n(a).hide();
            }), l.done(function() {
                var b;
                N.remove(a, "fxshow");
                for(b in m)n.style(a, b, m[b]);
            });
            for(d in m)g = Ya(p ? q[d] : 0, d, l), d in q || (q[d] = g.start, p && (g.end = g.start, g.start = "width" === d || "height" === d ? 1 : 0));
        }
    }
    function $a(a, b) {
        var c, d, e, f, g;
        for(c in a)if (d = n.camelCase(c), e = b[d], f = a[c], n.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = n.cssHooks[d], g && "expand" in g) {
            f = g.expand(f), delete a[d];
            for(c in f)c in a || (a[c] = f[c], b[c] = e);
        } else b[d] = e;
    }
    function _a(a, b, c) {
        var d, e, f = 0, g = _a.prefilters.length, h = n.Deferred().always(function() {
            delete i.elem;
        }), i = function() {
            if (e) return !1;
            for(var b = Sa || Wa(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++)j.tweens[g].run(f);
            return h.notifyWith(a, [
                j,
                f,
                c
            ]), 1 > f && i ? c : (h.resolveWith(a, [
                j
            ]), !1);
        }, j = h.promise({
            elem: a,
            props: n.extend({}, b),
            opts: n.extend(!0, {
                specialEasing: {},
                easing: n.easing._default
            }, c),
            originalProperties: b,
            originalOptions: c,
            startTime: Sa || Wa(),
            duration: c.duration,
            tweens: [],
            createTween: function(b, c) {
                var d = n.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);
                return j.tweens.push(d), d;
            },
            stop: function(b) {
                var c = 0, d = b ? j.tweens.length : 0;
                if (e) return this;
                for(e = !0; d > c; c++)j.tweens[c].run(1);
                return b ? (h.notifyWith(a, [
                    j,
                    1,
                    0
                ]), h.resolveWith(a, [
                    j,
                    b
                ])) : h.rejectWith(a, [
                    j,
                    b
                ]), this;
            }
        }), k = j.props;
        for($a(k, j.opts.specialEasing); g > f; f++)if (d = _a.prefilters[f].call(j, a, k, j.opts)) return n.isFunction(d.stop) && (n._queueHooks(j.elem, j.opts.queue).stop = n.proxy(d.stop, d)), d;
        return n.map(k, Ya, j), n.isFunction(j.opts.start) && j.opts.start.call(a, j), n.fx.timer(n.extend(i, {
            elem: a,
            anim: j,
            queue: j.opts.queue
        })), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always);
    }
    n.Animation = n.extend(_a, {
        tweeners: {
            "*": [
                function(a, b) {
                    var c = this.createTween(a, b);
                    return W(c.elem, a, T.exec(b), c), c;
                }
            ]
        },
        tweener: function(a, b) {
            n.isFunction(a) ? (b = a, a = [
                "*"
            ]) : a = a.match(G);
            for(var c, d = 0, e = a.length; e > d; d++)c = a[d], _a.tweeners[c] = _a.tweeners[c] || [], _a.tweeners[c].unshift(b);
        },
        prefilters: [
            Za
        ],
        prefilter: function(a, b) {
            b ? _a.prefilters.unshift(a) : _a.prefilters.push(a);
        }
    }), n.speed = function(a, b, c) {
        var d = a && "object" == typeof a ? n.extend({}, a) : {
            complete: c || !c && b || n.isFunction(a) && a,
            duration: a,
            easing: c && b || b && !n.isFunction(b) && b
        };
        return d.duration = n.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in n.fx.speeds ? n.fx.speeds[d.duration] : n.fx.speeds._default, null != d.queue && d.queue !== !0 || (d.queue = "fx"), d.old = d.complete, d.complete = function() {
            n.isFunction(d.old) && d.old.call(this), d.queue && n.dequeue(this, d.queue);
        }, d;
    }, n.fn.extend({
        fadeTo: function(a, b, c, d) {
            return this.filter(V).css("opacity", 0).show().end().animate({
                opacity: b
            }, a, c, d);
        },
        animate: function(a, b, c, d) {
            var e = n.isEmptyObject(a), f = n.speed(b, c, d), g = function() {
                var b = _a(this, n.extend({}, a), f);
                (e || N.get(this, "finish")) && b.stop(!0);
            };
            return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g);
        },
        stop: function(a, b, c) {
            var d = function(a) {
                var b = a.stop;
                delete a.stop, b(c);
            };
            return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function() {
                var b = !0, e = null != a && a + "queueHooks", f = n.timers, g = N.get(this);
                if (e) g[e] && g[e].stop && d(g[e]);
                else for(e in g)g[e] && g[e].stop && Va.test(e) && d(g[e]);
                for(e = f.length; e--;)f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
                !b && c || n.dequeue(this, a);
            });
        },
        finish: function(a) {
            return a !== !1 && (a = a || "fx"), this.each(function() {
                var b, c = N.get(this), d = c[a + "queue"], e = c[a + "queueHooks"], f = n.timers, g = d ? d.length : 0;
                for(c.finish = !0, n.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;)f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
                for(b = 0; g > b; b++)d[b] && d[b].finish && d[b].finish.call(this);
                delete c.finish;
            });
        }
    }), n.each([
        "toggle",
        "show",
        "hide"
    ], function(a, b) {
        var c = n.fn[b];
        n.fn[b] = function(a, d, e) {
            return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(Xa(b, !0), a, d, e);
        };
    }), n.each({
        slideDown: Xa("show"),
        slideUp: Xa("hide"),
        slideToggle: Xa("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(a, b) {
        n.fn[a] = function(a, c, d) {
            return this.animate(b, a, c, d);
        };
    }), n.timers = [], n.fx.tick = function() {
        var a, b = 0, c = n.timers;
        for(Sa = n.now(); b < c.length; b++)a = c[b], a() || c[b] !== a || c.splice(b--, 1);
        c.length || n.fx.stop(), Sa = void 0;
    }, n.fx.timer = function(a) {
        n.timers.push(a), a() ? n.fx.start() : n.timers.pop();
    }, n.fx.interval = 13, n.fx.start = function() {
        Ta || (Ta = a.setInterval(n.fx.tick, n.fx.interval));
    }, n.fx.stop = function() {
        a.clearInterval(Ta), Ta = null;
    }, n.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, n.fn.delay = function(b, c) {
        return b = n.fx ? n.fx.speeds[b] || b : b, c = c || "fx", this.queue(c, function(c, d) {
            var e = a.setTimeout(c, b);
            d.stop = function() {
                a.clearTimeout(e);
            };
        });
    }, function() {
        var a = d.createElement("input"), b = d.createElement("select"), c = b.appendChild(d.createElement("option"));
        a.type = "checkbox", l.checkOn = "" !== a.value, l.optSelected = c.selected, b.disabled = !0, l.optDisabled = !c.disabled, a = d.createElement("input"), a.value = "t", a.type = "radio", l.radioValue = "t" === a.value;
    }();
    var ab, bb = n.expr.attrHandle;
    n.fn.extend({
        attr: function(a, b) {
            return K(this, n.attr, a, b, arguments.length > 1);
        },
        removeAttr: function(a) {
            return this.each(function() {
                n.removeAttr(this, a);
            });
        }
    }), n.extend({
        attr: function(a, b, c) {
            var d, e, f = a.nodeType;
            if (3 !== f && 8 !== f && 2 !== f) return "undefined" == typeof a.getAttribute ? n.prop(a, b, c) : (1 === f && n.isXMLDoc(a) || (b = b.toLowerCase(), e = n.attrHooks[b] || (n.expr.match.bool.test(b) ? ab : void 0)), void 0 !== c ? null === c ? void n.removeAttr(a, b) : e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : (a.setAttribute(b, c + ""), c) : e && "get" in e && null !== (d = e.get(a, b)) ? d : (d = n.find.attr(a, b), null == d ? void 0 : d));
        },
        attrHooks: {
            type: {
                set: function(a, b) {
                    if (!l.radioValue && "radio" === b && n.nodeName(a, "input")) {
                        var c = a.value;
                        return a.setAttribute("type", b), c && (a.value = c), b;
                    }
                }
            }
        },
        removeAttr: function(a, b) {
            var c, d, e = 0, f = b && b.match(G);
            if (f && 1 === a.nodeType) while(c = f[e++])d = n.propFix[c] || c, n.expr.match.bool.test(c) && (a[d] = !1), a.removeAttribute(c);
        }
    }), ab = {
        set: function(a, b, c) {
            return b === !1 ? n.removeAttr(a, c) : a.setAttribute(c, c), c;
        }
    }, n.each(n.expr.match.bool.source.match(/\w+/g), function(a, b) {
        var c = bb[b] || n.find.attr;
        bb[b] = function(a, b, d) {
            var e, f;
            return d || (f = bb[b], bb[b] = e, e = null != c(a, b, d) ? b.toLowerCase() : null, bb[b] = f), e;
        };
    });
    var cb = /^(?:input|select|textarea|button)$/i, db = /^(?:a|area)$/i;
    n.fn.extend({
        prop: function(a, b) {
            return K(this, n.prop, a, b, arguments.length > 1);
        },
        removeProp: function(a) {
            return this.each(function() {
                delete this[n.propFix[a] || a];
            });
        }
    }), n.extend({
        prop: function(a, b, c) {
            var d, e, f = a.nodeType;
            if (3 !== f && 8 !== f && 2 !== f) return 1 === f && n.isXMLDoc(a) || (b = n.propFix[b] || b, e = n.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b];
        },
        propHooks: {
            tabIndex: {
                get: function(a) {
                    var b = n.find.attr(a, "tabindex");
                    return b ? parseInt(b, 10) : cb.test(a.nodeName) || db.test(a.nodeName) && a.href ? 0 : -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    }), l.optSelected || (n.propHooks.selected = {
        get: function(a) {
            var b = a.parentNode;
            return b && b.parentNode && b.parentNode.selectedIndex, null;
        },
        set: function(a) {
            var b = a.parentNode;
            b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex);
        }
    }), n.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        n.propFix[this.toLowerCase()] = this;
    });
    var eb = /[\t\r\n\f]/g;
    function fb(a) {
        return a.getAttribute && a.getAttribute("class") || "";
    }
    n.fn.extend({
        addClass: function(a) {
            var b, c, d, e, f, g, h, i = 0;
            if (n.isFunction(a)) return this.each(function(b) {
                n(this).addClass(a.call(this, b, fb(this)));
            });
            if ("string" == typeof a && a) {
                b = a.match(G) || [];
                while(c = this[i++])if (e = fb(c), d = 1 === c.nodeType && (" " + e + " ").replace(eb, " ")) {
                    g = 0;
                    while(f = b[g++])d.indexOf(" " + f + " ") < 0 && (d += f + " ");
                    h = n.trim(d), e !== h && c.setAttribute("class", h);
                }
            }
            return this;
        },
        removeClass: function(a) {
            var b, c, d, e, f, g, h, i = 0;
            if (n.isFunction(a)) return this.each(function(b) {
                n(this).removeClass(a.call(this, b, fb(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            if ("string" == typeof a && a) {
                b = a.match(G) || [];
                while(c = this[i++])if (e = fb(c), d = 1 === c.nodeType && (" " + e + " ").replace(eb, " ")) {
                    g = 0;
                    while(f = b[g++])while(d.indexOf(" " + f + " ") > -1)d = d.replace(" " + f + " ", " ");
                    h = n.trim(d), e !== h && c.setAttribute("class", h);
                }
            }
            return this;
        },
        toggleClass: function(a, b) {
            var c = typeof a;
            return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : n.isFunction(a) ? this.each(function(c) {
                n(this).toggleClass(a.call(this, c, fb(this), b), b);
            }) : this.each(function() {
                var b, d, e, f;
                if ("string" === c) {
                    d = 0, e = n(this), f = a.match(G) || [];
                    while(b = f[d++])e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
                } else void 0 !== a && "boolean" !== c || (b = fb(this), b && N.set(this, "__className__", b), this.setAttribute && this.setAttribute("class", b || a === !1 ? "" : N.get(this, "__className__") || ""));
            });
        },
        hasClass: function(a) {
            var b, c, d = 0;
            b = " " + a + " ";
            while(c = this[d++])if (1 === c.nodeType && (" " + fb(c) + " ").replace(eb, " ").indexOf(b) > -1) return !0;
            return !1;
        }
    });
    var gb = /\r/g, hb = /[\x20\t\r\n\f]+/g;
    n.fn.extend({
        val: function(a) {
            var b, c, d, e = this[0];
            if (arguments.length) return d = n.isFunction(a), this.each(function(c) {
                var e;
                1 === this.nodeType && (e = d ? a.call(this, c, n(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : n.isArray(e) && (e = n.map(e, function(a) {
                    return null == a ? "" : a + "";
                })), b = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e));
            });
            if (e) return b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(gb, "") : null == c ? "" : c);
        }
    }), n.extend({
        valHooks: {
            option: {
                get: function(a) {
                    var b = n.find.attr(a, "value");
                    return null != b ? b : n.trim(n.text(a)).replace(hb, " ");
                }
            },
            select: {
                get: function(a) {
                    for(var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++)if (c = d[i], (c.selected || i === e) && (l.optDisabled ? !c.disabled : null === c.getAttribute("disabled")) && (!c.parentNode.disabled || !n.nodeName(c.parentNode, "optgroup"))) {
                        if (b = n(c).val(), f) return b;
                        g.push(b);
                    }
                    return g;
                },
                set: function(a, b) {
                    var c, d, e = a.options, f = n.makeArray(b), g = e.length;
                    while(g--)d = e[g], (d.selected = n.inArray(n.valHooks.option.get(d), f) > -1) && (c = !0);
                    return c || (a.selectedIndex = -1), f;
                }
            }
        }
    }), n.each([
        "radio",
        "checkbox"
    ], function() {
        n.valHooks[this] = {
            set: function(a, b) {
                return n.isArray(b) ? a.checked = n.inArray(n(a).val(), b) > -1 : void 0;
            }
        }, l.checkOn || (n.valHooks[this].get = function(a) {
            return null === a.getAttribute("value") ? "on" : a.value;
        });
    });
    var ib = /^(?:focusinfocus|focusoutblur)$/;
    n.extend(n.event, {
        trigger: function(b, c, e, f) {
            var g, h, i, j, l, m, o, p = [
                e || d
            ], q = k.call(b, "type") ? b.type : b, r = k.call(b, "namespace") ? b.namespace.split(".") : [];
            if (h = i = e = e || d, 3 !== e.nodeType && 8 !== e.nodeType && !ib.test(q + n.event.triggered) && (q.indexOf(".") > -1 && (r = q.split("."), q = r.shift(), r.sort()), l = q.indexOf(":") < 0 && "on" + q, b = b[n.expando] ? b : new n.Event(q, "object" == typeof b && b), b.isTrigger = f ? 2 : 3, b.namespace = r.join("."), b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = e), c = null == c ? [
                b
            ] : n.makeArray(c, [
                b
            ]), o = n.event.special[q] || {}, f || !o.trigger || o.trigger.apply(e, c) !== !1)) {
                if (!f && !o.noBubble && !n.isWindow(e)) {
                    for(j = o.delegateType || q, ib.test(j + q) || (h = h.parentNode); h; h = h.parentNode)p.push(h), i = h;
                    i === (e.ownerDocument || d) && p.push(i.defaultView || i.parentWindow || a);
                }
                g = 0;
                while((h = p[g++]) && !b.isPropagationStopped())b.type = g > 1 ? j : o.bindType || q, m = (N.get(h, "events") || {})[b.type] && N.get(h, "handle"), m && m.apply(h, c), m = l && h[l], m && m.apply && L(h) && (b.result = m.apply(h, c), b.result === !1 && b.preventDefault());
                return b.type = q, f || b.isDefaultPrevented() || o._default && o._default.apply(p.pop(), c) !== !1 || !L(e) || l && n.isFunction(e[q]) && !n.isWindow(e) && (i = e[l], i && (e[l] = null), n.event.triggered = q, e[q](), n.event.triggered = void 0, i && (e[l] = i)), b.result;
            }
        },
        simulate: function(a, b, c) {
            var d = n.extend(new n.Event, c, {
                type: a,
                isSimulated: !0
            });
            n.event.trigger(d, null, b);
        }
    }), n.fn.extend({
        trigger: function(a, b) {
            return this.each(function() {
                n.event.trigger(a, b, this);
            });
        },
        triggerHandler: function(a, b) {
            var c = this[0];
            return c ? n.event.trigger(a, b, c, !0) : void 0;
        }
    }), n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(a, b) {
        n.fn[b] = function(a, c) {
            return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b);
        };
    }), n.fn.extend({
        hover: function(a, b) {
            return this.mouseenter(a).mouseleave(b || a);
        }
    }), l.focusin = "onfocusin" in a, l.focusin || n.each({
        focus: "focusin",
        blur: "focusout"
    }, function(a, b) {
        var c = function(a) {
            n.event.simulate(b, a.target, n.event.fix(a));
        };
        n.event.special[b] = {
            setup: function() {
                var d = this.ownerDocument || this, e = N.access(d, b);
                e || d.addEventListener(a, c, !0), N.access(d, b, (e || 0) + 1);
            },
            teardown: function() {
                var d = this.ownerDocument || this, e = N.access(d, b) - 1;
                e ? N.access(d, b, e) : (d.removeEventListener(a, c, !0), N.remove(d, b));
            }
        };
    });
    var jb = a.location, kb = n.now(), lb = /\?/;
    n.parseJSON = function(a) {
        return JSON.parse(a + "");
    }, n.parseXML = function(b) {
        var c;
        if (!b || "string" != typeof b) return null;
        try {
            c = (new a.DOMParser).parseFromString(b, "text/xml");
        } catch (d) {
            c = void 0;
        }
        return c && !c.getElementsByTagName("parsererror").length || n.error("Invalid XML: " + b), c;
    };
    var mb = /#.*$/, nb = /([?&])_=[^&]*/, ob = /^(.*?):[ \t]*([^\r\n]*)$/gm, pb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, qb = /^(?:GET|HEAD)$/, rb = /^\/\//, sb = {}, tb = {}, ub = "*/".concat("*"), vb = d.createElement("a");
    vb.href = jb.href;
    function wb(a) {
        return function(b, c) {
            "string" != typeof b && (c = b, b = "*");
            var d, e = 0, f = b.toLowerCase().match(G) || [];
            if (n.isFunction(c)) while(d = f[e++])"+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c);
        };
    }
    function xb(a, b, c, d) {
        var e = {}, f = a === tb;
        function g(h) {
            var i;
            return e[h] = !0, n.each(a[h] || [], function(a, h) {
                var j = h(b, c, d);
                return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j), g(j), !1);
            }), i;
        }
        return g(b.dataTypes[0]) || !e["*"] && g("*");
    }
    function yb(a, b) {
        var c, d, e = n.ajaxSettings.flatOptions || {};
        for(c in b)void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
        return d && n.extend(!0, a, d), a;
    }
    function zb(a, b, c) {
        var d, e, f, g, h = a.contents, i = a.dataTypes;
        while("*" === i[0])i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
        if (d) {
            for(e in h)if (h[e] && h[e].test(d)) {
                i.unshift(e);
                break;
            }
        }
        if (i[0] in c) f = i[0];
        else {
            for(e in c){
                if (!i[0] || a.converters[e + " " + i[0]]) {
                    f = e;
                    break;
                }
                g || (g = e);
            }
            f = f || g;
        }
        return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
    }
    function Ab(a, b, c, d) {
        var e, f, g, h, i, j = {}, k = a.dataTypes.slice();
        if (k[1]) for(g in a.converters)j[g.toLowerCase()] = a.converters[g];
        f = k.shift();
        while(f)if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift()) {
            if ("*" === f) f = i;
            else if ("*" !== i && i !== f) {
                if (g = j[i + " " + f] || j["* " + f], !g) {
                    for(e in j)if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
                        g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));
                        break;
                    }
                }
                if (g !== !0) {
                    if (g && a["throws"]) b = g(b);
                    else try {
                        b = g(b);
                    } catch (l) {
                        return {
                            state: "parsererror",
                            error: g ? l : "No conversion from " + i + " to " + f
                        };
                    }
                }
            }
        }
        return {
            state: "success",
            data: b
        };
    }
    n.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: jb.href,
            type: "GET",
            isLocal: pb.test(jb.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": ub,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": n.parseJSON,
                "text xml": n.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(a, b) {
            return b ? yb(yb(a, n.ajaxSettings), b) : yb(n.ajaxSettings, a);
        },
        ajaxPrefilter: wb(sb),
        ajaxTransport: wb(tb),
        ajax: function(b, c) {
            "object" == typeof b && (c = b, b = void 0), c = c || {};
            var e, f, g, h, i, j, k, l, m = n.ajaxSetup({}, c), o = m.context || m, p = m.context && (o.nodeType || o.jquery) ? n(o) : n.event, q = n.Deferred(), r = n.Callbacks("once memory"), s = m.statusCode || {}, t = {}, u = {}, v = 0, w = "canceled", x = {
                readyState: 0,
                getResponseHeader: function(a) {
                    var b;
                    if (2 === v) {
                        if (!h) {
                            h = {};
                            while(b = ob.exec(g))h[b[1].toLowerCase()] = b[2];
                        }
                        b = h[a.toLowerCase()];
                    }
                    return null == b ? null : b;
                },
                getAllResponseHeaders: function() {
                    return 2 === v ? g : null;
                },
                setRequestHeader: function(a, b) {
                    var c = a.toLowerCase();
                    return v || (a = u[c] = u[c] || a, t[a] = b), this;
                },
                overrideMimeType: function(a) {
                    return v || (m.mimeType = a), this;
                },
                statusCode: function(a) {
                    var b;
                    if (a) {
                        if (2 > v) for(b in a)s[b] = [
                            s[b],
                            a[b]
                        ];
                        else x.always(a[x.status]);
                    }
                    return this;
                },
                abort: function(a) {
                    var b = a || w;
                    return e && e.abort(b), z(0, b), this;
                }
            };
            if (q.promise(x).complete = r.add, x.success = x.done, x.error = x.fail, m.url = ((b || m.url || jb.href) + "").replace(mb, "").replace(rb, jb.protocol + "//"), m.type = c.method || c.type || m.method || m.type, m.dataTypes = n.trim(m.dataType || "*").toLowerCase().match(G) || [
                ""
            ], null == m.crossDomain) {
                j = d.createElement("a");
                try {
                    j.href = m.url, j.href = j.href, m.crossDomain = vb.protocol + "//" + vb.host != j.protocol + "//" + j.host;
                } catch (y) {
                    m.crossDomain = !0;
                }
            }
            if (m.data && m.processData && "string" != typeof m.data && (m.data = n.param(m.data, m.traditional)), xb(sb, m, c, x), 2 === v) return x;
            k = n.event && m.global, k && 0 === n.active++ && n.event.trigger("ajaxStart"), m.type = m.type.toUpperCase(), m.hasContent = !qb.test(m.type), f = m.url, m.hasContent || (m.data && (f = m.url += (lb.test(f) ? "&" : "?") + m.data, delete m.data), m.cache === !1 && (m.url = nb.test(f) ? f.replace(nb, "$1_=" + kb++) : f + (lb.test(f) ? "&" : "?") + "_=" + kb++)), m.ifModified && (n.lastModified[f] && x.setRequestHeader("If-Modified-Since", n.lastModified[f]), n.etag[f] && x.setRequestHeader("If-None-Match", n.etag[f])), (m.data && m.hasContent && m.contentType !== !1 || c.contentType) && x.setRequestHeader("Content-Type", m.contentType), x.setRequestHeader("Accept", m.dataTypes[0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + ("*" !== m.dataTypes[0] ? ", " + ub + "; q=0.01" : "") : m.accepts["*"]);
            for(l in m.headers)x.setRequestHeader(l, m.headers[l]);
            if (m.beforeSend && (m.beforeSend.call(o, x, m) === !1 || 2 === v)) return x.abort();
            w = "abort";
            for(l in {
                success: 1,
                error: 1,
                complete: 1
            })x[l](m[l]);
            if (e = xb(tb, m, c, x)) {
                if (x.readyState = 1, k && p.trigger("ajaxSend", [
                    x,
                    m
                ]), 2 === v) return x;
                m.async && m.timeout > 0 && (i = a.setTimeout(function() {
                    x.abort("timeout");
                }, m.timeout));
                try {
                    v = 1, e.send(t, z);
                } catch (y) {
                    if (!(2 > v)) throw y;
                    z(-1, y);
                }
            } else z(-1, "No Transport");
            function z(b, c, d, h) {
                var j, l, t, u, w, y = c;
                2 !== v && (v = 2, i && a.clearTimeout(i), e = void 0, g = h || "", x.readyState = b > 0 ? 4 : 0, j = b >= 200 && 300 > b || 304 === b, d && (u = zb(m, x, d)), u = Ab(m, u, x, j), j ? (m.ifModified && (w = x.getResponseHeader("Last-Modified"), w && (n.lastModified[f] = w), w = x.getResponseHeader("etag"), w && (n.etag[f] = w)), 204 === b || "HEAD" === m.type ? y = "nocontent" : 304 === b ? y = "notmodified" : (y = u.state, l = u.data, t = u.error, j = !t)) : (t = y, !b && y || (y = "error", 0 > b && (b = 0))), x.status = b, x.statusText = (c || y) + "", j ? q.resolveWith(o, [
                    l,
                    y,
                    x
                ]) : q.rejectWith(o, [
                    x,
                    y,
                    t
                ]), x.statusCode(s), s = void 0, k && p.trigger(j ? "ajaxSuccess" : "ajaxError", [
                    x,
                    m,
                    j ? l : t
                ]), r.fireWith(o, [
                    x,
                    y
                ]), k && (p.trigger("ajaxComplete", [
                    x,
                    m
                ]), --n.active || n.event.trigger("ajaxStop")));
            }
            return x;
        },
        getJSON: function(a, b, c) {
            return n.get(a, b, c, "json");
        },
        getScript: function(a, b) {
            return n.get(a, void 0, b, "script");
        }
    }), n.each([
        "get",
        "post"
    ], function(a, b) {
        n[b] = function(a, c, d, e) {
            return n.isFunction(c) && (e = e || d, d = c, c = void 0), n.ajax(n.extend({
                url: a,
                type: b,
                dataType: e,
                data: c,
                success: d
            }, n.isPlainObject(a) && a));
        };
    }), n._evalUrl = function(a) {
        return n.ajax({
            url: a,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            "throws": !0
        });
    }, n.fn.extend({
        wrapAll: function(a) {
            var b;
            return n.isFunction(a) ? this.each(function(b) {
                n(this).wrapAll(a.call(this, b));
            }) : (this[0] && (b = n(a, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && b.insertBefore(this[0]), b.map(function() {
                var a = this;
                while(a.firstElementChild)a = a.firstElementChild;
                return a;
            }).append(this)), this);
        },
        wrapInner: function(a) {
            return n.isFunction(a) ? this.each(function(b) {
                n(this).wrapInner(a.call(this, b));
            }) : this.each(function() {
                var b = n(this), c = b.contents();
                c.length ? c.wrapAll(a) : b.append(a);
            });
        },
        wrap: function(a) {
            var b = n.isFunction(a);
            return this.each(function(c) {
                n(this).wrapAll(b ? a.call(this, c) : a);
            });
        },
        unwrap: function() {
            return this.parent().each(function() {
                n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
            }).end();
        }
    }), n.expr.filters.hidden = function(a) {
        return !n.expr.filters.visible(a);
    }, n.expr.filters.visible = function(a) {
        return a.offsetWidth > 0 || a.offsetHeight > 0 || a.getClientRects().length > 0;
    };
    var Bb = /%20/g, Cb = /\[\]$/, Db = /\r?\n/g, Eb = /^(?:submit|button|image|reset|file)$/i, Fb = /^(?:input|select|textarea|keygen)/i;
    function Gb(a, b, c, d) {
        var e;
        if (n.isArray(b)) n.each(b, function(b, e) {
            c || Cb.test(a) ? d(a, e) : Gb(a + "[" + ("object" == typeof e && null != e ? b : "") + "]", e, c, d);
        });
        else if (c || "object" !== n.type(b)) d(a, b);
        else for(e in b)Gb(a + "[" + e + "]", b[e], c, d);
    }
    n.param = function(a, b) {
        var c, d = [], e = function(a, b) {
            b = n.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b);
        };
        if (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional), n.isArray(a) || a.jquery && !n.isPlainObject(a)) n.each(a, function() {
            e(this.name, this.value);
        });
        else for(c in a)Gb(c, a[c], b, e);
        return d.join("&").replace(Bb, "+");
    }, n.fn.extend({
        serialize: function() {
            return n.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                var a = n.prop(this, "elements");
                return a ? n.makeArray(a) : this;
            }).filter(function() {
                var a = this.type;
                return this.name && !n(this).is(":disabled") && Fb.test(this.nodeName) && !Eb.test(a) && (this.checked || !X.test(a));
            }).map(function(a, b) {
                var c = n(this).val();
                return null == c ? null : n.isArray(c) ? n.map(c, function(a) {
                    return {
                        name: b.name,
                        value: a.replace(Db, "\r\n")
                    };
                }) : {
                    name: b.name,
                    value: c.replace(Db, "\r\n")
                };
            }).get();
        }
    }), n.ajaxSettings.xhr = function() {
        try {
            return new a.XMLHttpRequest;
        } catch (b) {}
    };
    var Hb = {
        0: 200,
        1223: 204
    }, Ib = n.ajaxSettings.xhr();
    l.cors = !!Ib && "withCredentials" in Ib, l.ajax = Ib = !!Ib, n.ajaxTransport(function(b) {
        var c, d;
        return l.cors || Ib && !b.crossDomain ? {
            send: function(e, f) {
                var g, h = b.xhr();
                if (h.open(b.type, b.url, b.async, b.username, b.password), b.xhrFields) for(g in b.xhrFields)h[g] = b.xhrFields[g];
                b.mimeType && h.overrideMimeType && h.overrideMimeType(b.mimeType), b.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest");
                for(g in e)h.setRequestHeader(g, e[g]);
                c = function(a) {
                    return function() {
                        c && (c = d = h.onload = h.onerror = h.onabort = h.onreadystatechange = null, "abort" === a ? h.abort() : "error" === a ? "number" != typeof h.status ? f(0, "error") : f(h.status, h.statusText) : f(Hb[h.status] || h.status, h.statusText, "text" !== (h.responseType || "text") || "string" != typeof h.responseText ? {
                            binary: h.response
                        } : {
                            text: h.responseText
                        }, h.getAllResponseHeaders()));
                    };
                }, h.onload = c(), d = h.onerror = c("error"), void 0 !== h.onabort ? h.onabort = d : h.onreadystatechange = function() {
                    4 === h.readyState && a.setTimeout(function() {
                        c && d();
                    });
                }, c = c("abort");
                try {
                    h.send(b.hasContent && b.data || null);
                } catch (i) {
                    if (c) throw i;
                }
            },
            abort: function() {
                c && c();
            }
        } : void 0;
    }), n.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(a) {
                return n.globalEval(a), a;
            }
        }
    }), n.ajaxPrefilter("script", function(a) {
        void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET");
    }), n.ajaxTransport("script", function(a) {
        if (a.crossDomain) {
            var b, c;
            return {
                send: function(e, f) {
                    b = n("<script>").prop({
                        charset: a.scriptCharset,
                        src: a.url
                    }).on("load error", c = function(a) {
                        b.remove(), c = null, a && f("error" === a.type ? 404 : 200, a.type);
                    }), d.head.appendChild(b[0]);
                },
                abort: function() {
                    c && c();
                }
            };
        }
    });
    var Jb = [], Kb = /(=)\?(?=&|$)|\?\?/;
    n.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var a = Jb.pop() || n.expando + "_" + kb++;
            return this[a] = !0, a;
        }
    }), n.ajaxPrefilter("json jsonp", function(b, c, d) {
        var e, f, g, h = b.jsonp !== !1 && (Kb.test(b.url) ? "url" : "string" == typeof b.data && 0 === (b.contentType || "").indexOf("application/x-www-form-urlencoded") && Kb.test(b.data) && "data");
        return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = n.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(Kb, "$1" + e) : b.jsonp !== !1 && (b.url += (lb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function() {
            return g || n.error(e + " was not called"), g[0];
        }, b.dataTypes[0] = "json", f = a[e], a[e] = function() {
            g = arguments;
        }, d.always(function() {
            void 0 === f ? n(a).removeProp(e) : a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, Jb.push(e)), g && n.isFunction(f) && f(g[0]), g = f = void 0;
        }), "script") : void 0;
    }), n.parseHTML = function(a, b, c) {
        if (!a || "string" != typeof a) return null;
        "boolean" == typeof b && (c = b, b = !1), b = b || d;
        var e = x.exec(a), f = !c && [];
        return e ? [
            b.createElement(e[1])
        ] : (e = ca([
            a
        ], b, f), f && f.length && n(f).remove(), n.merge([], e.childNodes));
    };
    var Lb = n.fn.load;
    n.fn.load = function(a, b, c) {
        if ("string" != typeof a && Lb) return Lb.apply(this, arguments);
        var d, e, f, g = this, h = a.indexOf(" ");
        return h > -1 && (d = n.trim(a.slice(h)), a = a.slice(0, h)), n.isFunction(b) ? (c = b, b = void 0) : b && "object" == typeof b && (e = "POST"), g.length > 0 && n.ajax({
            url: a,
            type: e || "GET",
            dataType: "html",
            data: b
        }).done(function(a) {
            f = arguments, g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a);
        }).always(c && function(a, b) {
            g.each(function() {
                c.apply(this, f || [
                    a.responseText,
                    b,
                    a
                ]);
            });
        }), this;
    }, n.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(a, b) {
        n.fn[b] = function(a) {
            return this.on(b, a);
        };
    }), n.expr.filters.animated = function(a) {
        return n.grep(n.timers, function(b) {
            return a === b.elem;
        }).length;
    };
    function Mb(a) {
        return n.isWindow(a) ? a : 9 === a.nodeType && a.defaultView;
    }
    n.offset = {
        setOffset: function(a, b, c) {
            var d, e, f, g, h, i, j, k = n.css(a, "position"), l = n(a), m = {};
            "static" === k && (a.style.position = "relative"), h = l.offset(), f = n.css(a, "top"), i = n.css(a, "left"), j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), n.isFunction(b) && (b = b.call(a, c, n.extend({}, h))), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : l.css(m);
        }
    }, n.fn.extend({
        offset: function(a) {
            if (arguments.length) return void 0 === a ? this : this.each(function(b) {
                n.offset.setOffset(this, a, b);
            });
            var b, c, d = this[0], e = {
                top: 0,
                left: 0
            }, f = d && d.ownerDocument;
            if (f) return b = f.documentElement, n.contains(b, d) ? (e = d.getBoundingClientRect(), c = Mb(f), {
                top: e.top + c.pageYOffset - b.clientTop,
                left: e.left + c.pageXOffset - b.clientLeft
            }) : e;
        },
        position: function() {
            if (this[0]) {
                var a, b, c = this[0], d = {
                    top: 0,
                    left: 0
                };
                return "fixed" === n.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), n.nodeName(a[0], "html") || (d = a.offset()), d.top += n.css(a[0], "borderTopWidth", !0), d.left += n.css(a[0], "borderLeftWidth", !0)), {
                    top: b.top - d.top - n.css(c, "marginTop", !0),
                    left: b.left - d.left - n.css(c, "marginLeft", !0)
                };
            }
        },
        offsetParent: function() {
            return this.map(function() {
                var a = this.offsetParent;
                while(a && "static" === n.css(a, "position"))a = a.offsetParent;
                return a || Ea;
            });
        }
    }), n.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(a, b) {
        var c = "pageYOffset" === b;
        n.fn[a] = function(d) {
            return K(this, function(a, d, e) {
                var f = Mb(a);
                return void 0 === e ? f ? f[b] : a[d] : void (f ? f.scrollTo(c ? f.pageXOffset : e, c ? e : f.pageYOffset) : a[d] = e);
            }, a, d, arguments.length);
        };
    }), n.each([
        "top",
        "left"
    ], function(a, b) {
        n.cssHooks[b] = Ga(l.pixelPosition, function(a, c) {
            return c ? (c = Fa(a, b), Ba.test(c) ? n(a).position()[b] + "px" : c) : void 0;
        });
    }), n.each({
        Height: "height",
        Width: "width"
    }, function(a, b) {
        n.each({
            padding: "inner" + a,
            content: b,
            "": "outer" + a
        }, function(c, d) {
            n.fn[d] = function(d, e) {
                var f = arguments.length && (c || "boolean" != typeof d), g = c || (d === !0 || e === !0 ? "margin" : "border");
                return K(this, function(b, c, d) {
                    var e;
                    return n.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement, Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? n.css(b, c, g) : n.style(b, c, d, g);
                }, b, f ? d : void 0, f, null);
            };
        });
    }), n.fn.extend({
        bind: function(a, b, c) {
            return this.on(a, null, b, c);
        },
        unbind: function(a, b) {
            return this.off(a, null, b);
        },
        delegate: function(a, b, c, d) {
            return this.on(b, a, c, d);
        },
        undelegate: function(a, b, c) {
            return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c);
        },
        size: function() {
            return this.length;
        }
    }), n.fn.andSelf = n.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return n;
    });
    var Nb = a.jQuery, Ob = a.$;
    return n.noConflict = function(b) {
        return a.$ === n && (a.$ = Ob), b && a.jQuery === n && (a.jQuery = Nb), n;
    }, b || (a.jQuery = a.$ = n), n;
});


function $8bc1fb5ab8196e1c$var$VerifyMessage() {
    var strFormAction = $("#inpId").parent("form").attr("action"), strName = $("#inpName").val(), strEmail = $("#inpEmail").val(), strHomePage = $("#inpHomePage").val(), strVerify = $("#inpVerify").val(), strArticle = $("#txaArticle").val(), intReplyID = $("#inpRevID").val(), intPostID = $("#inpId").val(), intMaxLen = 1e3;
    if ("" == strName) return alert("undefined" == typeof lang_comment_name_error ? "name error" : lang_comment_name_error), !1;
    if (re = new RegExp("^[._A-Za-z0-9\u4E00-\u9FA5]+$"), !re.test(strName)) return alert("undefined" == typeof lang_comment_name_error ? "name error" : lang_comment_name_error), !1;
    if ("" == strEmail) return alert("\u90AE\u7BB1\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u53EF\u80FD\u8FC7\u957F\u6216\u4E3A\u7A7A"), !1;
    if (re = new RegExp("^[\\w-]+(\\.[\\w-]+)*@[\\w-]+(\\.[\\w-]+)+$"), !re.test(strEmail)) return alert("undefined" == typeof lang_comment_email_error ? "email error" : lang_comment_email_error), !1;
    if ("string" == typeof strArticle) {
        if ("" == strArticle) return alert("undefined" == typeof lang_comment_content_error ? "content error" : lang_comment_content_error), !1;
        if (strArticle.length > 1e3) return alert("undefined" == typeof lang_comment_content_error ? "content error" : lang_comment_content_error), !1;
    }
    var strSubmit = $("#inpId").parent("form").find(":submit").val();
    return $("#inpId").parent("form").find(":submit").val("Waiting...").attr("disabled", "disabled").addClass("loading"), $.post(strFormAction, {
        isajax: !0,
        postid: intPostID,
        verify: strVerify,
        name: strName,
        email: strEmail,
        content: strArticle,
        homepage: strHomePage,
        replyid: intReplyID
    }, function(data) {
        var s;
        if ($("#inpId").parent("form").find(":submit").removeClass("loading"), $("#inpId").parent("form").find(":submit").removeAttr("disabled"), $("#inpId").parent("form").find(":submit").val(strSubmit), (s = data).search("faultCode") > 0 && s.search("faultString") > 0) alert(s.match("<string>.+?</string>")[0].replace("<string>", "").replace("</string>", ""));
        else {
            var s, cmt = (s = data).match(/cmt\d+/);
            0 == intReplyID ? $(s).insertAfter("#AjaxCommentBegin") : $("#cmt-" + intReplyID).append(s), window.location = "#" + cmt, $("#txaArticle").val(""), $8bc1fb5ab8196e1c$var$CommentComplete();
        }
    }), !1;
}
function $8bc1fb5ab8196e1c$var$RevertComment(i) {
    $("#inpRevID").val(i);
    var frm = $("#divCommentPost"), cancel = $("#cancel-reply"), temp = $("#temp-frm"), div = document.createElement("div");
    div.id = "temp-frm", div.style.display = "none", frm.before(div), $("#cmt-" + i).after(frm), $body = window.opera ? "CSS1Compat" == document.compatMode ? $("html") : $("body") : $("html,body"), $body.animate({
        scrollTop: $("#cmt-" + i).offset().top - 200
    }, 800), frm.addClass("reply-frm"), cancel.show(), cancel.click(function() {
        $("#inpRevID").val(0);
        var temp = $("#temp-frm"), frm = $("#divCommentPost");
        if (temp.length && frm.length) return temp.before(frm), temp.remove(), $(this).hide(), frm.removeClass("reply-frm"), !1;
    });
    try {
        $("#txaArticle").focus();
    } catch (e) {}
    return !1;
}
function $8bc1fb5ab8196e1c$var$GetComments(logid, page) {
    $("span.commentspage").html("Waiting..."), $.get(bloghost + "zb_system/cmd.php?act=getcmt&postid=" + logid + "&page=" + page, function(data) {
        $("#AjaxCommentBegin").nextUntil("#AjaxCommentEnd").remove(), $("#AjaxCommentEnd").before(data), $("#cancel-reply").click();
    });
}
function $8bc1fb5ab8196e1c$var$CommentComplete() {
    $("#cancel-reply").click();
}


(function() {
    var h = {}, mt = {}, c = {
        id: "bc7f7d5ac14c62acefcea619da5a640d",
        dm: [
            "www.lw50.com"
        ],
        js: "tongji.baidu.com/hm-web/js/",
        etrk: [],
        cetrk: [],
        cptrk: [],
        icon: '',
        ctrk: [],
        vdur: 1800000,
        age: 31536000000,
        qiao: 0,
        pt: 0,
        spa: 0,
        aet: '',
        hca: '4ED68E72911EE146',
        ab: 0,
        v: 1,
        apps: ''
    };
    var s = void 0, t = !0, u = null, v = !1;
    mt.cookie = {};
    mt.cookie.set = function(e, b, a) {
        var f;
        a.D && (f = new Date, f.setTime(f.getTime() + a.D));
        document.cookie = e + "=" + b + (a.domain ? "; domain=" + a.domain : "") + (a.path ? "; path=" + a.path : "") + (f ? "; expires=" + f.toGMTString() : "") + (a.Yb ? "; secure" : "");
    };
    mt.cookie.get = function(e) {
        return (e = RegExp("(^| )" + e + "=([^;]*)(;|$)").exec(document.cookie)) ? e[2] : u;
    };
    mt.cookie.rb = function(e, b) {
        try {
            var a = "Hm_ck_" + +new Date;
            mt.cookie.set(a, "42", {
                domain: e,
                path: b,
                D: s
            });
            var f = "42" === mt.cookie.get(a) ? "1" : "0";
            mt.cookie.set(a, "", {
                domain: e,
                path: b,
                D: -1
            });
            return f;
        } catch (d) {
            return "0";
        }
    };
    mt.lang = {};
    mt.lang.j = function(e, b) {
        return "[object " + b + "]" === ({}).toString.call(e);
    };
    mt.lang.l = function(e) {
        return mt.lang.j(e, "Function");
    };
    mt.lang.K = function(e) {
        return mt.lang.j(e, "Object");
    };
    mt.lang.Ub = function(e) {
        return mt.lang.j(e, "Number") && isFinite(e);
    };
    mt.lang.$ = function(e) {
        return mt.lang.j(e, "String");
    };
    mt.lang.isArray = function(e) {
        return mt.lang.j(e, "Array");
    };
    mt.lang.g = function(e) {
        return e.replace ? e.replace(/'/g, "'0").replace(/\*/g, "'1").replace(/!/g, "'2") : e;
    };
    mt.lang.trim = function(e) {
        return e.replace(/^\s+|\s+$/g, "");
    };
    mt.lang.find = function(e, b, a) {
        if (mt.lang.isArray(e) && mt.lang.l(b)) {
            for(var f = e.length, d = 0; d < f; d++)if (d in e && b.call(a || e, e[d], d)) return e[d];
        }
        return u;
    };
    mt.lang.Y = function(e, b) {
        return mt.lang.find(e, function(a) {
            return a === b;
        }) != u;
    };
    mt.lang.filter = function(e, b) {
        var a = -1, f = 0, d = e == u ? 0 : e.length, q = [];
        if (mt.lang.l(b)) for(; ++a < d;){
            var k = e[a];
            b(k, a, e) && (q[f++] = k);
        }
        return q;
    };
    mt.lang.unique = function(e, b) {
        var a = e.length, f = e.slice(0), d, q;
        for(mt.lang.l(b) || (b = function(a, f) {
            return a === f;
        }); 0 < --a;){
            q = f[a];
            for(d = a; d--;)if (b(q, f[d])) {
                f.splice(a, 1);
                break;
            }
        }
        return f;
    };
    mt.lang.Vb = function(e, b) {
        function a(a) {
            a = (f + f + Number(a).toString(2)).slice(-64);
            return [
                parseInt(a.slice(0, 32), 2),
                parseInt(a.slice(-32), 2)
            ];
        }
        var f = "00000000000000000000000000000000", d = a(e), q = a(b);
        return parseInt((f + ((d[0] | q[0]) >>> 0).toString(2)).slice(-32) + (f + ((d[1] | q[1]) >>> 0).toString(2)).slice(-32), 2);
    };
    mt.url = {};
    mt.url.f = function(e, b) {
        var a = e.match(RegExp("(^|&|\\?|#)(" + b + ")=([^&#]*)(&|$|#)", ""));
        return a ? a[3] : u;
    };
    mt.url.Ta = function(e) {
        return (e = e.match(/^(https?:\/\/)?([^\/\?#]*)/)) ? e[2].replace(/.*@/, "") : u;
    };
    mt.url.W = function(e) {
        return (e = mt.url.Ta(e)) ? e.replace(/:\d+$/, "") : e;
    };
    mt.url.pb = function(e) {
        var b = document.location.href, b = b.replace(/^https?:\/\//, "");
        return 0 === b.indexOf(e);
    };
    mt.url.qb = function(e, b) {
        e = "." + e.replace(/:\d+/, "");
        b = "." + b.replace(/:\d+/, "");
        var a = e.indexOf(b);
        return -1 < a && a + b.length === e.length;
    };
    (function() {
        var e = mt.lang, b = mt.url;
        mt.d = {};
        mt.d.Ma = function(a) {
            return document.getElementById(a);
        };
        mt.d.Tb = function(a) {
            if (!a) return u;
            try {
                a = String(a);
                if (0 === a.indexOf("!HMCQ!")) return a;
                if (0 === a.indexOf("!HMCC!")) return document.querySelector(a.substring(6, a.length));
                for(var f = a.split(">"), d = document.body, b = f.length - 1; 0 <= b; b--)if (-1 < f[b].indexOf("#")) {
                    var e = f[b].split("#")[1];
                    (d = document.getElementById(e)) || (d = document.getElementById(decodeURIComponent(e)));
                    f = f.splice(b + 1, f.length - (b + 1));
                    break;
                }
                for(a = 0; d && a < f.length;){
                    var g = String(f[a]).toLowerCase();
                    if (!("html" === g || "body" === g)) {
                        var b = 0, r = f[a].match(/\[(\d+)\]/i), e = [];
                        if (r) b = r[1] - 1, g = g.split("[")[0];
                        else if (1 !== d.childNodes.length) {
                            for(var n = 0, p = 0, l = d.childNodes.length; p < l; p++){
                                var m = d.childNodes[p];
                                1 === m.nodeType && m.nodeName.toLowerCase() === g && n++;
                                if (1 < n) return u;
                            }
                            if (1 !== n) return u;
                        }
                        for(n = 0; n < d.childNodes.length; n++)1 === d.childNodes[n].nodeType && d.childNodes[n].nodeName.toLowerCase() === g && e.push(d.childNodes[n]);
                        if (!e[b]) return u;
                        d = e[b];
                    }
                    a++;
                }
                return d;
            } catch (w) {
                return u;
            }
        };
        mt.d.ga = function(a, f) {
            var d = [], b = [];
            if (!a) return b;
            for(; a.parentNode != u;){
                for(var e = 0, g = 0, r = a.parentNode.childNodes.length, n = 0; n < r; n++){
                    var p = a.parentNode.childNodes[n];
                    if (p.nodeName === a.nodeName && (e++, p === a && (g = e), 0 < g && 1 < e)) break;
                }
                if ((r = "" !== a.id) && f) {
                    d.unshift("#" + encodeURIComponent(a.id));
                    break;
                } else r && (r = "#" + encodeURIComponent(a.id), r = 0 < d.length ? r + ">" + d.join(">") : r, b.push(r)), d.unshift(encodeURIComponent(String(a.nodeName).toLowerCase()) + (1 < e ? "[" + g + "]" : ""));
                a = a.parentNode;
            }
            b.push(d.join(">"));
            return b;
        };
        mt.d.Ya = function(a) {
            return (a = mt.d.ga(a, t)) && a.length ? String(a[0]) : "";
        };
        mt.d.Xa = function(a) {
            return mt.d.ga(a, v);
        };
        mt.d.Na = function(a) {
            var f;
            for(f = "A"; (a = a.parentNode) && 1 == a.nodeType;)if (a.tagName == f) return a;
            return u;
        };
        mt.d.Qa = function(a) {
            return 9 === a.nodeType ? a : a.ownerDocument || a.document;
        };
        mt.d.Va = function(a) {
            var f = {
                top: 0,
                left: 0
            };
            if (!a) return f;
            var d = mt.d.Qa(a).documentElement;
            "undefined" !== typeof a.getBoundingClientRect && (f = a.getBoundingClientRect());
            return {
                top: f.top + (window.pageYOffset || d.scrollTop) - (d.clientTop || 0),
                left: f.left + (window.pageXOffset || d.scrollLeft) - (d.clientLeft || 0)
            };
        };
        mt.d.getAttribute = function(a, f) {
            var d = a.getAttribute && a.getAttribute(f) || u;
            if (!d && a.attributes && a.attributes.length) for(var b = a.attributes, e = b.length, g = 0; g < e; g++)b[g].nodeName === f && (d = b[g].nodeValue);
            return d;
        };
        mt.d.Ra = function(a) {
            var f = "document";
            a.tagName !== s && (f = a.tagName);
            return f.toLowerCase();
        };
        mt.d.$a = function(a) {
            var f = "";
            a.textContent ? f = e.trim(a.textContent) : a.innerText && (f = e.trim(a.innerText));
            f && (f = f.replace(/\s+/g, " ").substring(0, 255));
            return f;
        };
        mt.d.Sb = function(a, f) {
            var d;
            e.$(a) && 0 === String(a).indexOf("!HMCQ!") ? (d = String(a), d = b.f(document.location.href, d.substring(6, d.length))) : e.$(a) || (d = mt.d.Ra(a), "input" === d && f && ("button" === a.type || "submit" === a.type) ? d = e.trim(a.value) || "" : "input" === d && !f && "password" !== a.type ? d = e.trim(a.value) || "" : "img" === d ? (d = mt.d.getAttribute, d = d(a, "alt") || d(a, "title") || d(a, "src")) : d = "body" === d || "html" === d ? [
                "(hm-default-content-for-",
                d,
                ")"
            ].join("") : mt.d.$a(a));
            return String(d || "").substring(0, 255);
        };
        (function() {
            (mt.d.Wb = function() {
                function a() {
                    if (!a.L) {
                        a.L = t;
                        for(var f = 0, d = b.length; f < d; f++)b[f]();
                    }
                }
                function f() {
                    try {
                        document.documentElement.doScroll("left");
                    } catch (d) {
                        setTimeout(f, 1);
                        return;
                    }
                    a();
                }
                var d = v, b = [], e;
                document.addEventListener ? e = function() {
                    document.removeEventListener("DOMContentLoaded", e, v);
                    a();
                } : document.attachEvent && (e = function() {
                    "complete" === document.readyState && (document.detachEvent("onreadystatechange", e), a());
                });
                (function() {
                    if (!d) {
                        if (d = t, "complete" === document.readyState) a.L = t;
                        else if (document.addEventListener) document.addEventListener("DOMContentLoaded", e, v), window.addEventListener("load", a, v);
                        else if (document.attachEvent) {
                            document.attachEvent("onreadystatechange", e);
                            window.attachEvent("onload", a);
                            var b = v;
                            try {
                                b = window.frameElement == u;
                            } catch (q) {}
                            document.documentElement.doScroll && b && f();
                        }
                    }
                })();
                return function(f) {
                    a.L ? f() : b.push(f);
                };
            }()).L = v;
        })();
        return mt.d;
    })();
    mt.event = {};
    mt.event.c = function(e, b, a) {
        e.attachEvent ? e.attachEvent("on" + b, function(f) {
            a.call(e, f);
        }) : e.addEventListener && e.addEventListener(b, a, v);
    };
    (function() {
        var e = mt.event;
        mt.e = {};
        mt.e.nb = /msie (\d+\.\d+)/i.test(navigator.userAgent);
        mt.e.cookieEnabled = navigator.cookieEnabled;
        mt.e.javaEnabled = navigator.javaEnabled();
        mt.e.language = navigator.language || navigator.browserLanguage || navigator.systemLanguage || navigator.userLanguage || "";
        mt.e.Ab = (window.screen.width || 0) + "x" + (window.screen.height || 0);
        mt.e.colorDepth = window.screen.colorDepth || 0;
        mt.e.Za = function() {
            var b;
            b = b || document;
            return parseInt(window.pageYOffset || b.documentElement.scrollTop || b.body && b.body.scrollTop || 0, 10);
        };
        mt.e.bb = function() {
            var b = document;
            return parseInt(window.innerHeight || b.documentElement.clientHeight || b.body && b.body.clientHeight || 0, 10);
        };
        mt.e.X = function() {
            return mt.e.Za() + mt.e.bb();
        };
        mt.e.ta = 0;
        mt.e.cb = function() {
            var b = document;
            return parseInt(window.innerWidth || b.documentElement.clientWidth || b.body.offsetWidth || 0, 10);
        };
        mt.e.orientation = 0;
        (function() {
            function b() {
                var a = 0;
                window.orientation !== s && (a = window.orientation);
                screen && screen.orientation && screen.orientation.angle !== s && (a = screen.orientation.angle);
                mt.e.orientation = a;
                mt.e.ta = mt.e.cb();
            }
            b();
            e.c(window, "orientationchange", b);
        })();
        return mt.e;
    })();
    mt.z = {};
    mt.z.parse = function(e) {
        return new Function("return (" + e + ")")();
    };
    mt.z.stringify = function() {
        function e(f) {
            /["\\\x00-\x1f]/.test(f) && (f = f.replace(/["\\\x00-\x1f]/g, function(f) {
                var b = a[f];
                if (b) return b;
                b = f.charCodeAt();
                return "\\u00" + Math.floor(b / 16).toString(16) + (b % 16).toString(16);
            }));
            return '"' + f + '"';
        }
        function b(a) {
            return 10 > a ? "0" + a : a;
        }
        var a = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
        };
        return function(a) {
            switch(typeof a){
                case "undefined":
                    return "undefined";
                case "number":
                    return isFinite(a) ? String(a) : "null";
                case "string":
                    return e(a);
                case "boolean":
                    return String(a);
                default:
                    if (a === u) return "null";
                    if (a instanceof Array) {
                        var d = [
                            "["
                        ], q = a.length, k, g, r;
                        for(g = 0; g < q; g++)switch(r = a[g], typeof r){
                            case "undefined":
                            case "function":
                            case "unknown":
                                break;
                            default:
                                k && d.push(","), d.push(mt.z.stringify(r)), k = 1;
                        }
                        d.push("]");
                        return d.join("");
                    }
                    if (a instanceof Date) return '"' + a.getFullYear() + "-" + b(a.getMonth() + 1) + "-" + b(a.getDate()) + "T" + b(a.getHours()) + ":" + b(a.getMinutes()) + ":" + b(a.getSeconds()) + '"';
                    k = [
                        "{"
                    ];
                    g = mt.z.stringify;
                    for(q in a)if (Object.prototype.hasOwnProperty.call(a, q)) switch(r = a[q], typeof r){
                        case "undefined":
                        case "unknown":
                        case "function":
                            break;
                        default:
                            d && k.push(","), d = 1, k.push(g(q) + ":" + g(r));
                    }
                    k.push("}");
                    return k.join("");
            }
        };
    }();
    mt.localStorage = {};
    mt.localStorage.R = function() {
        if (!mt.localStorage.h) try {
            mt.localStorage.h = document.createElement("input"), mt.localStorage.h.type = "hidden", mt.localStorage.h.style.display = "none", mt.localStorage.h.addBehavior("#default#userData"), document.getElementsByTagName("head")[0].appendChild(mt.localStorage.h);
        } catch (e) {
            return v;
        }
        return t;
    };
    mt.localStorage.set = function(e, b, a) {
        var f = new Date;
        f.setTime(f.getTime() + (a || 31536E6));
        try {
            window.localStorage ? (b = f.getTime() + "|" + b, window.localStorage.setItem(e, b)) : mt.localStorage.R() && (mt.localStorage.h.expires = f.toUTCString(), mt.localStorage.h.load(document.location.hostname), mt.localStorage.h.setAttribute(e, b), mt.localStorage.h.save(document.location.hostname));
        } catch (d) {}
    };
    mt.localStorage.get = function(e) {
        if (window.localStorage) {
            if (e = window.localStorage.getItem(e)) {
                var b = e.indexOf("|"), a = e.substring(0, b) - 0;
                if (a && a > (new Date).getTime()) return e.substring(b + 1);
            }
        } else if (mt.localStorage.R()) try {
            return mt.localStorage.h.load(document.location.hostname), mt.localStorage.h.getAttribute(e);
        } catch (f) {}
        return u;
    };
    mt.localStorage.remove = function(e) {
        if (window.localStorage) window.localStorage.removeItem(e);
        else if (mt.localStorage.R()) try {
            mt.localStorage.h.load(document.location.hostname), mt.localStorage.h.removeAttribute(e), mt.localStorage.h.save(document.location.hostname);
        } catch (b) {}
    };
    mt.sessionStorage = {};
    mt.sessionStorage.set = function(e, b) {
        try {
            window.sessionStorage && window.sessionStorage.setItem(e, b);
        } catch (a) {}
    };
    mt.sessionStorage.get = function(e) {
        try {
            return window.sessionStorage ? window.sessionStorage.getItem(e) : u;
        } catch (b) {
            return u;
        }
    };
    mt.sessionStorage.remove = function(e) {
        try {
            window.sessionStorage && window.sessionStorage.removeItem(e);
        } catch (b) {}
    };
    (function() {
        var e = mt.z;
        mt.B = {};
        mt.B.log = function(b, a) {
            var f = new Image, d = "mini_tangram_log_" + Math.floor(2147483648 * Math.random()).toString(36);
            window[d] = f;
            f.onload = function() {
                f.onload = u;
                f = window[d] = u;
                a && a(b);
            };
            f.src = b;
        };
        mt.B.get = function(b, a) {
            return mt.B.xa({
                url: b,
                method: "GET",
                data: a.data,
                timeout: a.timeout,
                noCache: t,
                success: a.success,
                fail: a.fail
            });
        };
        mt.B.xa = function(b) {
            function a(a) {
                var m = b[a];
                if (m) {
                    if (p && clearTimeout(p), "success" !== a) m && m(n);
                    else {
                        var d;
                        try {
                            d = e.parse(n.responseText);
                        } catch (f) {
                            m && m(n);
                            return;
                        }
                        m && m(n, d);
                    }
                }
            }
            b = b || {};
            var f = function(a) {
                var m = [], b;
                for(b in a)a.hasOwnProperty(b) && m.push(encodeURIComponent(b) + "=" + encodeURIComponent(a[b]));
                return m.join("&");
            }(b.data || {}), d = b.url, q = (b.method || "GET").toUpperCase(), k = b.headers || {}, g = b.timeout || 0, r = b.noCache || v, n, p;
            try {
                a: if (window.XMLHttpRequest) n = new XMLHttpRequest;
                else {
                    try {
                        n = new ActiveXObject("Microsoft.XMLHTTP");
                        break a;
                    } catch (l) {}
                    n = s;
                }
                "GET" === q && (f && (d += (0 <= d.indexOf("?") ? "&" : "?") + f, f = u), r && (d += (0 <= d.indexOf("?") ? "&" : "?") + "b" + +new Date + "=1"));
                n.open(q, d, t);
                n.onreadystatechange = function() {
                    if (4 === n.readyState) {
                        var m = 0;
                        try {
                            m = n.status;
                        } catch (b) {
                            a("fail");
                            return;
                        }
                        200 <= m && 300 > m || 304 === m || 1223 === m ? a("success") : a("fail");
                    }
                };
                for(var m in k)k.hasOwnProperty(m) && n.setRequestHeader(m, k[m]);
                g && (p = setTimeout(function() {
                    n.onreadystatechange = function() {};
                    n.abort();
                    a("fail");
                }, g));
                n.send(f);
            } catch (w) {
                a("fail");
            }
            return n;
        };
        return mt.B;
    })();
    h.s = {
        lb: "http://tongji.baidu.com/hm-web/welcome/ico",
        ba: "hm.baidu.com/hm.gif",
        ya: /^(tongji|hmcdn).baidu.com$/,
        Gb: "tongji.baidu.com",
        ib: "hmmd",
        jb: "hmpl",
        Jb: "utm_medium",
        hb: "hmkw",
        Lb: "utm_term",
        fb: "hmci",
        Ib: "utm_content",
        kb: "hmsr",
        Kb: "utm_source",
        gb: "hmcu",
        Hb: "utm_campaign",
        la: 0,
        C: Math.round(+new Date / 1E3),
        protocol: "https:" === document.location.protocol ? "https:" : "http:",
        M: "https:",
        Da: 6E5,
        Xb: 5E3,
        Ea: 5,
        ea: 1024,
        H: 2147483647,
        sa: "hca cc cf ci ck cl cm cp cu cw ds vl ep et ja ln lo lt rnd si su v cv lv api sn r ww p ct u tt".split(" "),
        ha: t,
        Nb: {
            id: "data-hm-id",
            Rb: "data-hm-class",
            $b: "data-hm-xpath",
            content: "data-hm-content",
            Zb: "data-hm-tag",
            link: "data-hm-link"
        },
        Pb: "data-hm-enabled",
        Ob: "data-hm-disabled",
        xb: "https://hmcdn.baidu.com/static/tongji/plugins/",
        oa: [
            "UrlChangeTracker"
        ]
    };
    (function() {
        var e = {
            w: {},
            c: function(b, a) {
                this.w[b] = this.w[b] || [];
                this.w[b].push(a);
            },
            k: function(b, a) {
                this.w[b] = this.w[b] || [];
                for(var f = this.w[b].length, d = 0; d < f; d++)this.w[b][d](a);
            }
        };
        return h.t = e;
    })();
    (function() {
        var e = mt.lang, b = /^https?:\/\//, a = {
            Pa: function(a) {
                var b;
                try {
                    b = JSON.parse(decodeURIComponent(a[0]));
                } catch (e) {}
                return b;
            },
            ma: function(b, d) {
                return a.na(h.b && h.b.a && h.b.a.u, b, d) || a.na(document.location.href, b, d);
            },
            na: function(a, d, e) {
                if (a === s) return v;
                b.test(d) || (a = a.replace(b, ""));
                d = d.replace(/\/$/, "");
                a = a.replace(/\/$/, "");
                e && (a = a.replace(/^(https?:\/\/)?www\./, "$1"));
                return RegExp("^" + d.replace(/[?.+^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*") + "$").test(a);
            },
            I: function(b, d) {
                var q = a.Pa(b);
                if (!e.j(q, "Undefined")) {
                    if (e.isArray(q)) {
                        for(var k = 0; k < q.length; k++)if (a.ma(q[k], d)) return t;
                        return v;
                    }
                    if (e.K(q)) {
                        var k = [], g;
                        for(g in q)q.hasOwnProperty(g) && a.ma(g, d) && (k = k.concat(q[g]));
                        return k;
                    }
                }
            }
        };
        return h.T = a;
    })();
    (function() {
        function e(a, e) {
            var d = document.createElement("script");
            d.charset = "utf-8";
            b.l(e) && (d.readyState ? d.onreadystatechange = function() {
                if ("loaded" === d.readyState || "complete" === d.readyState) d.onreadystatechange = u, e();
            } : d.onload = function() {
                e();
            });
            d.src = a;
            var q = document.getElementsByTagName("script")[0];
            q.parentNode.insertBefore(d, q);
        }
        var b = mt.lang;
        return h.load = e;
    })();
    (function() {
        var e = h.s, b = {
            F: function() {
                if ("" !== c.icon) {
                    var a = c.icon.split("|"), b = e.lb + "?s=" + c.id, d = "https://hmcdn.baidu.com/static" + a[0] + ".gif";
                    document.write("swf" === a[1] || "gif" === a[1] ? '<a href="' + b + '" target="_blank"><img border="0" src="' + d + '" width="' + a[2] + '" height="' + a[3] + '"></a>' : '<a href="' + b + '" target="_blank">' + a[0] + "</a>");
                }
            }
        };
        h.t.c("pv-b", b.F);
        return b;
    })();
    (function() {
        var e = mt.url, b = mt.cookie, a = mt.localStorage, f = mt.sessionStorage, d = {
            getData: function(d) {
                try {
                    return b.get(d) || f.get(d) || a.get(d);
                } catch (e) {}
            },
            setData: function(e, k, g) {
                try {
                    b.set(e, k, {
                        domain: d.J(),
                        path: d.V(),
                        D: g
                    }), g ? a.set(e, k, g) : f.set(e, k);
                } catch (r) {}
            },
            removeData: function(e) {
                try {
                    b.set(e, "", {
                        domain: d.J(),
                        path: d.V(),
                        D: -1
                    }), f.remove(e), a.remove(e);
                } catch (k) {}
            },
            J: function() {
                for(var a = document.location.hostname, b = 0, d = c.dm.length; b < d; b++)if (e.qb(a, c.dm[b])) return c.dm[b].replace(/(:\d+)?[/?#].*/, "");
                return a;
            },
            V: function() {
                for(var a = 0, b = c.dm.length; a < b; a++){
                    var d = c.dm[a];
                    if (-1 < d.indexOf("/") && e.pb(d)) return d.replace(/^[^/]+(\/.*)/, "$1") + "/";
                }
                return "/";
            }
        };
        return h.S = d;
    })();
    (function() {
        var e = mt.lang, b = mt.d, a = h.T, f = {
            Ha: function(d, e) {
                return function(k) {
                    var g = k.target || k.srcElement;
                    if (g) {
                        var r = a.I(e) || [], n = g.getAttribute(d.Q);
                        k = k.clientX + ":" + k.clientY;
                        if (n && n === k) g.removeAttribute(d.Q);
                        else if (0 < r.length && (g = b.Xa(g)) && g.length) {
                            if (r = g.length, n = g[g.length - 1], 1E4 > r * n.split(">").length) for(n = 0; n < r; n++)f.ra(d, g[n]);
                            else f.ra(d, n);
                        }
                    }
                };
            },
            ra: function(a, b) {
                for(var f = {}, g = String(b).split(">").length, r = 0; r < g; r++)f[b] = "", b = b.substring(0, b.lastIndexOf(">"));
                a && e.K(a) && a.da && a.da(f);
            },
            zb: function(a, b) {
                return function(e) {
                    (e.target || e.srcElement).setAttribute(a.Q, e.clientX + ":" + e.clientY);
                    a && a.O && (b ? a.O(b) : a.O("#" + encodeURIComponent(this.id), e.type));
                };
            }
        };
        return h.Ia = f;
    })();
    (function() {
        var e = mt.d, b = mt.event, a = h.T, f = h.Ia, d = {
            Q: "HM_fix",
            va: function() {
                b.c(document, "click", f.Ha(d, c.etrk));
                for(var q = a.I(c.etrk) || [], k = 0; k < q.length; k++){
                    var g = q[k];
                    -1 === g.indexOf(">") && (0 === g.indexOf("#") && (g = g.substring(1)), (g = e.Ma(g)) && b.c(g, "click", f.zb(d)));
                }
            },
            da: function(b) {
                for(var e = a.I(c.etrk) || [], f = 0; f < e.length; f++){
                    var r = e[f];
                    b.hasOwnProperty(r) && d.O(r);
                }
            },
            O: function(a, b) {
                h.b.a.et = 1;
                h.b.a.ep = "{id:" + a + ",eventType:" + (b || "click") + "}";
                h.b.n();
            }
        };
        h.t.c("pv-b", d.va);
        return d;
    })();
    (function() {
        var e = mt.d, b = mt.lang, a = mt.event, f = mt.e, d = h.s, q = h.T, k = [], g = {
            ua: function() {
                c.ctrk && 0 < c.ctrk.length && (a.c(document, "mouseup", g.Ca()), a.c(window, "unload", function() {
                    g.N();
                }), setInterval(function() {
                    g.N();
                }, d.Da));
            },
            Ca: function() {
                return function(a) {
                    if (q.I(c.ctrk, t) && (a = g.Oa(a), "" !== a)) {
                        var b = (d.M + "//" + d.ba + "?" + h.b.qa().replace(/ep=[^&]*/, "ep=" + encodeURIComponent(a))).length;
                        b + (d.H + "").length > d.ea || (b + encodeURIComponent(k.join("!") + (k.length ? "!" : "")).length + (d.H + "").length > d.ea && g.N(), k.push(a), (k.length >= d.Ea || /\*a\*/.test(a)) && g.N());
                    }
                };
            },
            Oa: function(a) {
                var d = a.target || a.srcElement, k, l;
                f.nb ? (l = Math.max(document.documentElement.scrollTop, document.body.scrollTop), k = Math.max(document.documentElement.scrollLeft, document.body.scrollLeft), k = a.clientX + k, l = a.clientY + l) : (k = a.pageX, l = a.pageY);
                a = g.Ua(a, d, k, l);
                var m = window.innerWidth || document.documentElement.clientWidth || document.body.offsetWidth;
                switch(c.align){
                    case 1:
                        k -= m / 2;
                        break;
                    case 2:
                        k -= m;
                }
                m = [];
                m.push(k);
                m.push(l);
                m.push(a.ub);
                m.push(a.vb);
                m.push(a.yb);
                m.push(b.g(a.wb));
                m.push(a.Mb);
                m.push(a.eb);
                (d = "a" === (d.tagName || "").toLowerCase() ? d : e.Na(d)) ? (m.push("a"), m.push(b.g(encodeURIComponent(d.href)))) : m.push("b");
                return m.join("*");
            },
            Ua: function(a, d, g, k) {
                a = e.Ya(d);
                var m = 0, w = 0, y = 0, x = 0;
                if (d && (m = d.offsetWidth || d.clientWidth, w = d.offsetHeight || d.clientHeight, x = e.Va(d), y = x.left, x = x.top, b.l(d.getBBox) && (w = d.getBBox(), m = w.width, w = w.height), "html" === (d.tagName || "").toLowerCase())) m = Math.max(m, d.clientWidth), w = Math.max(w, d.clientHeight);
                return {
                    ub: Math.round(100 * ((g - y) / m)),
                    vb: Math.round(100 * ((k - x) / w)),
                    yb: f.orientation,
                    wb: a,
                    Mb: m,
                    eb: w
                };
            },
            N: function() {
                0 !== k.length && (h.b.a.et = 2, h.b.a.ep = k.join("!"), h.b.n(), k = []);
            }
        };
        h.t.c("pv-b", g.ua);
        return g;
    })();
    (function() {
        function e() {
            return function() {
                h.b.a.et = 3;
                h.b.a.ep = h.U.Wa() + "," + h.U.Sa();
                h.b.a.hca = c.hca;
                h.b.n();
            };
        }
        function b() {
            clearTimeout(C);
            var a;
            y && (a = "visible" == document[y]);
            x && (a = !document[x]);
            g = "undefined" == typeof a ? t : a;
            if ((!k || !r) && g && n) w = t, l = +new Date;
            else if (k && r && (!g || !n)) w = v, m += +new Date - l;
            k = g;
            r = n;
            C = setTimeout(b, 100);
        }
        function a(a) {
            var b = document, m = "";
            if (a in b) m = a;
            else for(var d = [
                "webkit",
                "ms",
                "moz",
                "o"
            ], e = 0; e < d.length; e++){
                var f = d[e] + a.charAt(0).toUpperCase() + a.slice(1);
                if (f in b) {
                    m = f;
                    break;
                }
            }
            return m;
        }
        function f(a) {
            if (!("focus" == a.type || "blur" == a.type) || !(a.target && a.target != window)) n = "focus" == a.type || "focusin" == a.type ? t : v, b();
        }
        var d = mt.event, q = h.t, k = t, g = t, r = t, n = t, p = +new Date, l = p, m = 0, w = t, y = a("visibilityState"), x = a("hidden"), C;
        b();
        (function() {
            var a = y.replace(/[vV]isibilityState/, "visibilitychange");
            d.c(document, a, b);
            d.c(window, "pageshow", b);
            d.c(window, "pagehide", b);
            "object" == typeof document.onfocusin ? (d.c(document, "focusin", f), d.c(document, "focusout", f)) : (d.c(window, "focus", f), d.c(window, "blur", f));
        })();
        h.U = {
            Wa: function() {
                return +new Date - p;
            },
            Sa: function() {
                return w ? +new Date - l + m : m;
            }
        };
        q.c("pv-b", function() {
            d.c(window, "unload", e());
        });
        q.c("duration-send", e());
        q.c("duration-done", function() {
            l = p = +new Date;
            m = 0;
        });
        return h.U;
    })();
    (function() {
        var e = mt.lang, b = h.s, a = h.load, f = h.S, d = {
            mb: function(d) {
                if ((window._dxt === s || e.j(window._dxt, "Array")) && "undefined" !== typeof h.b) {
                    var k = f.J();
                    a([
                        b.protocol,
                        "//datax.baidu.com/x.js?si=",
                        c.id,
                        "&dm=",
                        encodeURIComponent(k)
                    ].join(""), d);
                }
            },
            Fb: function(a) {
                if (e.j(a, "String") || e.j(a, "Number")) window._dxt = window._dxt || [], window._dxt.push([
                    "_setUserId",
                    a
                ]);
            }
        };
        return h.Fa = d;
    })();
    (function() {
        function e(a, b, d, e) {
            if (!(a === s || b === s || e === s)) {
                if ("" === a) return [
                    b,
                    d,
                    e
                ].join("*");
                a = String(a).split("!");
                for(var f, g = v, k = 0; k < a.length; k++)if (f = a[k].split("*"), String(b) === f[0]) {
                    f[1] = d;
                    f[2] = e;
                    a[k] = f.join("*");
                    g = t;
                    break;
                }
                g || a.push([
                    b,
                    d,
                    e
                ].join("*"));
                return a.join("!");
            }
        }
        function b(a) {
            for(var d in a)if (({}).hasOwnProperty.call(a, d)) {
                var e = a[d];
                f.K(e) || f.isArray(e) ? b(e) : a[d] = String(e);
            }
        }
        var a = mt.url, f = mt.lang, d = mt.z, q = mt.e, k = h.s, g = h.t, r = h.Fa, n = h.load, p = h.S, l = {
            G: [],
            P: 0,
            Z: v,
            o: {
                ca: "",
                page: ""
            },
            F: function() {
                l.i = 0;
                g.c("pv-b", function() {
                    l.Ga();
                    l.Ja();
                });
                g.c("pv-d", function() {
                    l.Ka();
                    l.o.page = "";
                });
                g.c("stag-b", function() {
                    h.b.a.api = l.i || l.P ? l.i + "_" + l.P : "";
                    h.b.a.ct = [
                        decodeURIComponent(p.getData("Hm_ct_" + c.id) || ""),
                        l.o.ca,
                        l.o.page
                    ].join("!");
                });
                g.c("stag-d", function() {
                    h.b.a.api = 0;
                    l.i = 0;
                    l.P = 0;
                });
            },
            Ga: function() {
                var a = window._hmt || [];
                if (!a || f.j(a, "Array")) window._hmt = {
                    id: c.id,
                    cmd: {},
                    push: function() {
                        for(var a = window._hmt, b = 0; b < arguments.length; b++){
                            var e = arguments[b];
                            f.j(e, "Array") && (a.cmd[a.id].push(e), "_setAccount" === e[0] && 1 < e.length && /^[0-9a-f]{31,32}$/.test(e[1]) && (e = e[1], a.id = e, a.cmd[e] = a.cmd[e] || []));
                        }
                    }
                }, window._hmt.cmd[c.id] = [], window._hmt.push.apply(window._hmt, a);
            },
            Ja: function() {
                var a = window._hmt;
                if (a && a.cmd && a.cmd[c.id]) for(var b = a.cmd[c.id], e = /^_track(Event|Order)$/, d = 0, f = b.length; d < f; d++){
                    var g = b[d];
                    e.test(g[0]) ? l.G.push(g) : l.aa(g);
                }
                a.cmd[c.id] = {
                    push: l.aa
                };
            },
            Ka: function() {
                if (0 < l.G.length) for(var a = 0, b = l.G.length; a < b; a++)l.aa(l.G[a]);
                l.G = u;
            },
            aa: function(a) {
                var b = a[0];
                if (l.hasOwnProperty(b) && f.l(l[b])) l[b](a);
            },
            _setAccount: function(a) {
                1 < a.length && /^[0-9a-f]{31,32}$/.test(a[1]) && (l.i |= 1);
            },
            _setAutoPageview: function(a) {
                if (1 < a.length && (a = a[1], v === a || t === a)) l.i |= 2, h.b.ia = a;
            },
            _trackPageview: function(a) {
                1 < a.length && a[1].charAt && "/" === a[1].charAt(0) && (l.i |= 4, h.b.a.sn = h.b.fa(), h.b.a.et = 0, h.b.a.ep = "", h.b.a.vl = q.X(), l.Z || (h.b.a.su = h.b.a.u || document.location.href), h.b.a.u = k.protocol + "//" + document.location.host + a[1], h.b.n(), h.b.sb = +new Date);
            },
            _trackEvent: function(a) {
                2 < a.length && (l.i |= 8, h.b.a.et = 4, h.b.a.ep = f.g(a[1]) + "*" + f.g(a[2]) + (a[3] ? "*" + f.g(a[3]) : "") + (a[4] ? "*" + f.g(a[4]) : ""), h.b.n());
            },
            _setCustomVar: function(a) {
                if (!(4 > a.length)) {
                    var b = a[1], e = a[4] || 3;
                    if (0 < b && 6 > b && 0 < e && 4 > e) {
                        l.P++;
                        for(var d = (h.b.a.cv || "*").split("!"), g = d.length; g < b - 1; g++)d.push("*");
                        d[b - 1] = e + "*" + f.g(a[2]) + "*" + f.g(a[3]);
                        h.b.a.cv = d.join("!");
                        a = h.b.a.cv.replace(/[^1](\*[^!]*){2}/g, "*").replace(/((^|!)\*)+$/g, "");
                        "" !== a ? p.setData("Hm_cv_" + c.id, encodeURIComponent(a), c.age) : p.removeData("Hm_cv_" + c.id);
                    }
                }
            },
            _setUserTag: function(a) {
                if (!(3 > a.length)) {
                    var b = f.g(a[1]);
                    a = f.g(a[2]);
                    if (b !== s && a !== s) {
                        var d = decodeURIComponent(p.getData("Hm_ct_" + c.id) || ""), d = e(d, b, 1, a);
                        p.setData("Hm_ct_" + c.id, encodeURIComponent(d), c.age);
                    }
                }
            },
            _setVisitTag: function(a) {
                if (!(3 > a.length)) {
                    var b = f.g(a[1]);
                    a = f.g(a[2]);
                    if (b !== s && a !== s) {
                        var d = l.o.ca, d = e(d, b, 2, a);
                        l.o.ca = d;
                    }
                }
            },
            _setPageTag: function(a) {
                if (!(3 > a.length)) {
                    var b = f.g(a[1]);
                    a = f.g(a[2]);
                    if (b !== s && a !== s) {
                        var d = l.o.page, d = e(d, b, 3, a);
                        l.o.page = d;
                    }
                }
            },
            _setReferrerOverride: function(a) {
                1 < a.length && (a = a[1], f.j(a, "String") ? (h.b.a.su = "/" === a.charAt(0) ? k.protocol + "//" + window.location.host + a : a, l.Z = t) : l.Z = v);
            },
            _trackOrder: function(a) {
                a = a[1];
                f.K(a) && (b(a), l.i |= 16, h.b.a.et = 94, h.b.a.ep = d.stringify(a), h.b.n());
            },
            _setDataxId: function(a) {
                a = a[1];
                r.mb();
                r.Fb(a);
            },
            _setAutoTracking: function(a) {
                if (1 < a.length && (a = a[1], v === a || t === a)) h.b.ka = a;
            },
            _trackPageDuration: function(a) {
                1 < a.length ? (a = a[1], 2 === String(a).split(",").length && (h.b.a.et = 3, h.b.a.ep = a, h.b.n())) : g.k("duration-send");
                g.k("duration-done");
            },
            _require: function(b) {
                1 < b.length && (b = b[1], k.ya.test(a.W(b)) && n(b));
            },
            _providePlugin: function(a) {
                if (1 < a.length) {
                    var b = window._hmt, d = a[1];
                    a = a[2];
                    if (f.Y(k.oa, d) && f.l(a) && (b.plugins = b.plugins || {}, b.A = b.A || {}, b.plugins[d] = a, b.m = b.m || [], a = b.m.slice(), d && a.length && a[0][1] === d)) for(var e = 0, g = a.length; e < g; e++){
                        var l = a[e][2] || {};
                        if (b.plugins[d] && !b.A[d]) b.A[d] = new b.plugins[d](l), b.m.shift();
                        else break;
                    }
                }
            },
            _requirePlugin: function(a) {
                if (1 < a.length) {
                    var b = window._hmt, d = a[1], e = a[2] || {};
                    if (f.Y(k.oa, d)) {
                        if (b.plugins = b.plugins || {}, b.A = b.A || {}, b.plugins[d] && !b.A[d]) b.A[d] = new b.plugins[d](e);
                        else {
                            b.m = b.m || [];
                            for(var e = 0, g = b.m.length; e < g; e++)if (b.m[e][1] === d) return;
                            b.m.push(a);
                            l._require([
                                u,
                                k.xb + d + ".js"
                            ]);
                        }
                    }
                }
            }
        };
        l.F();
        h.za = l;
        return h.za;
    })();
    (function() {
        var e = h.t;
        c.spa !== s && "1" === String(c.spa) && (window._hmt = window._hmt || [], window._hmt.push([
            "_requirePlugin",
            "UrlChangeTracker"
        ]), e.c("pv-b", function() {
            "" !== window.location.hash && (h.b.a.u = window.location.href);
        }));
    })();
    (function() {
        function e() {
            "undefined" === typeof window["_bdhm_loaded_" + c.id] && (window["_bdhm_loaded_" + c.id] = t, this.a = {}, this.ka = this.ia = t, this.ha = p.ha, this.Qb = f.$(c.aet) && 0 < c.aet.length ? c.aet.split(",") : "", this.F());
        }
        var b = mt.url, a = mt.B, f = mt.lang, d = mt.cookie, q = mt.e, k = mt.sessionStorage, g = mt.z, r = mt.event, n = h.S, p = h.s, l = h.load, m = h.t;
        e.prototype = {
            Db: function() {
                var a, b, e, f;
                p.la = n.getData("Hm_lpvt_" + c.id) || 0;
                if (f = n.getData("Hm_lvt_" + c.id)) {
                    for(b = f.split(","); 2592E3 < p.C - b[0];)b.shift();
                    e = 4 > b.length ? 2 : 3;
                    for(p.C - p.la > c.vdur && b.push(p.C); 4 < b.length;)b.shift();
                    f = b.join(",");
                    b = b[b.length - 1];
                } else f = p.C, b = "", e = 1;
                this.ob() ? (n.setData("Hm_lvt_" + c.id, f, c.age), n.setData("Hm_lpvt_" + c.id, p.C), a = d.rb(n.J(), n.V())) : this.La();
                this.a.cc = a;
                this.a.lt = b;
                this.a.lv = e;
            },
            ob: function() {
                var a = b.W(document.location.href);
                return !f.Y("sjh.baidu.com isite.baidu.com ls.wejianzhan.com bs.wejianzhan.com product.weijianzhan.com qianhu.weijianzhan.com aisite.wejianzhan.com".split(" "), a);
            },
            La: function() {
                for(var a = document.cookie.split(";"), b = 0; b < a.length; b++){
                    var d = a[b].split("=");
                    d.length && /Hm_(up|ct|cv|lp?vt)_[0-9a-f]{31}/.test(String(d[0])) && n.removeData(d[0]);
                    d.length && /Hm_ck_[0-9]{13}/.test(String(d[0])) && n.removeData(d[0]);
                }
            },
            qa: function() {
                for(var a = [], b = this.a.et, d = 0, e = p.sa.length; d < e; d++){
                    var f = p.sa[d], g = this.a[f];
                    "undefined" !== typeof g && "" !== g && ("tt" !== f || "tt" === f && 0 === b) && ("ct" !== f || "ct" === f && 0 === b) && a.push(f + "=" + encodeURIComponent(g));
                }
                return a.join("&");
            },
            Eb: function() {
                this.Db();
                this.a.si = c.id;
                this.a.sn = this.fa();
                this.a.su = document.referrer;
                this.a.ds = q.Ab;
                this.a.cl = q.colorDepth + "-bit";
                this.a.ln = String(q.language).toLowerCase();
                this.a.ja = q.javaEnabled ? 1 : 0;
                this.a.ck = q.cookieEnabled ? 1 : 0;
                this.a.lo = "number" === typeof _bdhm_top ? 1 : 0;
                this.a.v = "1.2.92";
                this.a.cv = decodeURIComponent(n.getData("Hm_cv_" + c.id) || "");
                this.a.tt = document.title || "";
                this.a.vl = q.X();
                var a = document.location.href;
                this.a.cm = b.f(a, p.ib) || "";
                this.a.cp = b.f(a, p.jb) || b.f(a, p.Jb) || "";
                this.a.cw = b.f(a, p.hb) || b.f(a, p.Lb) || "";
                this.a.ci = b.f(a, p.fb) || b.f(a, p.Ib) || "";
                this.a.cf = b.f(a, p.kb) || b.f(a, p.Kb) || "";
                this.a.cu = b.f(a, p.gb) || b.f(a, p.Hb) || "";
                /https?:/.test(document.location.protocol) && (this.a.u = a);
            },
            F: function() {
                try {
                    this.Eb(), this.Cb(), h.b = this, this.Aa(), this.tb(), m.k("pv-b"), this.Bb();
                } catch (b) {
                    var d = [];
                    d.push("si=" + c.id);
                    d.push("n=" + encodeURIComponent(b.name));
                    d.push("m=" + encodeURIComponent(b.message));
                    d.push("r=" + encodeURIComponent(document.referrer));
                    a.log(p.M + "//" + p.ba + "?" + d.join("&"));
                }
            },
            Bb: function() {
                function a() {
                    m.k("pv-d");
                }
                this.ia ? (this.a.et = 0, this.a.ep = "", m.k("setPageviewProp"), this.a.vl = q.X(), this.n(a), this.a.p = "") : a();
                this.sb = +new Date;
                m.k("clearPageviewProp");
            },
            n: function(b) {
                if (this.ka) {
                    var d = this;
                    d.a.rnd = Math.round(Math.random() * p.H);
                    d.a.r = q.orientation;
                    d.a.ww = q.ta;
                    m.k("stag-b");
                    var e = p.M + "//" + p.ba + "?" + d.qa();
                    m.k("stag-d");
                    d.wa(e);
                    a.log(e, function(a) {
                        d.pa(a);
                        f.l(b) && b.call(d);
                    });
                }
            },
            Aa: function() {
                try {
                    if (window.postMessage && window.self !== window.parent) {
                        var a = this;
                        r.c(window, "message", function(d) {
                            if (b.W(d.origin) === p.Gb) {
                                d = d.data || {};
                                var e = d.jn || "", f = /^customevent$|^heatmap$|^pageclick$|^select$/.test(e);
                                if (RegExp(c.id).test(d.sd || "") && f) a.a.rnd = Math.round(Math.random() * p.H), l(p.protocol + "//" + c.js + e + ".js?" + a.a.rnd);
                            }
                        });
                        window.parent.postMessage({
                            id: c.id,
                            url: document.location.href,
                            status: "__Messenger__hmLoaded"
                        }, "*");
                    }
                } catch (d) {}
            },
            tb: function() {
                try {
                    if (window.self === window.parent) {
                        var a = document.location.href, d = b.f(a, "baidu-analytics-token"), e = b.f(a, "baidu-analytics-jn");
                        /^[a-f0-9]{32}\/?$/.test(d) && /^overlay\/?$/.test(e) && l(p.protocol + "//" + c.js + e + ".js?" + Math.round(Math.random() * p.H));
                    }
                } catch (f) {}
            },
            wa: function(a) {
                var b;
                try {
                    b = g.parse(k.get("Hm_unsent_" + c.id) || "[]");
                } catch (d) {
                    b = [];
                }
                var e = this.a.u ? "" : "&u=" + encodeURIComponent(document.location.href);
                b.push(a.replace(/^https?:\/\//, "") + e);
                k.set("Hm_unsent_" + c.id, g.stringify(b));
            },
            pa: function(a) {
                var b;
                try {
                    b = g.parse(k.get("Hm_unsent_" + c.id) || "[]");
                } catch (d) {
                    b = [];
                }
                if (b.length) {
                    a = a.replace(/^https?:\/\//, "");
                    for(var e = 0; e < b.length; e++)if (a.replace(/&u=[^&]*/, "") === b[e].replace(/&u=[^&]*/, "")) {
                        b.splice(e, 1);
                        break;
                    }
                    b.length ? k.set("Hm_unsent_" + c.id, g.stringify(b)) : this.Ba();
                }
            },
            Ba: function() {
                k.remove("Hm_unsent_" + c.id);
            },
            Cb: function() {
                var b = this, d;
                try {
                    d = g.parse(k.get("Hm_unsent_" + c.id) || "[]");
                } catch (e) {
                    d = [];
                }
                if (d.length) for(var f = function(d) {
                    a.log(p.M + "//" + d, function(a) {
                        b.pa(a);
                    });
                }, l = 0; l < d.length; l++)f(d[l]);
            },
            fa: function() {
                return Math.round(+new Date / 1E3) % 65535;
            }
        };
        return new e;
    })();
    var z = h.s, A = h.load;
    if (c.apps) {
        var B = [
            z.protocol,
            "//ers.baidu.com/app/s.js?"
        ];
        B.push(c.apps);
        A(B.join(""));
    }
    var D = h.s, E = h.load;
    c.pt && E([
        D.protocol,
        "//ada.baidu.com/phone-tracker/insert_bdtj?sid=",
        c.pt
    ].join(""));
    var F = h.load;
    if (c.qiao) {
        for(var G = [
            "https://goutong.baidu.com/site/"
        ], H = c.id, I = 5381, J = H.length, K = 0; K < J; K++)I = (33 * I + Number(H.charCodeAt(K))) % 4294967296;
        2147483648 < I && (I -= 2147483648);
        G.push(I % 1E3 + "/");
        G.push(c.id + "/b.js");
        G.push("?siteId=" + c.qiao);
        F(G.join(""));
    }
})();


var $aa5a477bcbf0331e$var$zbpConfig = {
    bloghost: "https://www.lw50.com/",
    blogversion: "173045",
    ajaxurl: "https://www.lw50.com/zb_system/cmd.php?act=ajax&src=",
    cookiepath: "/",
    lang: {
        error: {
            72: "\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A\u6216\u683C\u5F0F\u4E0D\u6B63\u786E",
            29: "\u90AE\u7BB1\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u53EF\u80FD\u8FC7\u957F\u6216\u4E3A\u7A7A",
            46: "\u8BC4\u8BBA\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A\u6216\u8FC7\u957F"
        }
    },
    comment: {
        useDefaultEvents: !0,
        inputs: {
            action: {
                getter: function() {
                    return $("#inpId").parent("form").attr("action");
                }
            },
            name: {
                selector: "#inpName",
                saveLocally: !0,
                required: !0,
                validateRule: /^[^\s　]+$/gi,
                validateFailedErrorCode: 72
            },
            email: {
                selector: "#inpEmail",
                saveLocally: !0,
                validateRule: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/gi,
                validateFailedErrorCode: 29
            },
            homepage: {
                selector: "#inpHomePage",
                getter: function() {
                    var t = $("#inpHomePage").val();
                    return /^(.+)\:\/\//.test(t) || "" === t ? t : "http://" + t;
                },
                saveLocally: !0
            },
            postid: {
                selector: "#inpId",
                required: !0
            },
            verify: {
                selector: "#inpVerify"
            },
            content: {
                selector: "#txaArticle",
                required: !0,
                validateRule: /./gi,
                validateFailedErrorCode: 46
            },
            replyid: {
                selector: "#inpRevID"
            },
            format: {
                getter: function() {
                    return "json";
                }
            }
        }
    }
}, $aa5a477bcbf0331e$var$zbp = new ZBP($aa5a477bcbf0331e$var$zbpConfig), $aa5a477bcbf0331e$var$bloghost = $aa5a477bcbf0331e$var$zbp.options.bloghost, $aa5a477bcbf0331e$var$cookiespath = $aa5a477bcbf0331e$var$zbp.options.cookiepath, $aa5a477bcbf0331e$var$ajaxurl = $aa5a477bcbf0331e$var$zbp.options.ajaxurl, $aa5a477bcbf0331e$var$lang_comment_name_error = $aa5a477bcbf0331e$var$zbp.options.lang.error[72], $aa5a477bcbf0331e$var$lang_comment_email_error = $aa5a477bcbf0331e$var$zbp.options.lang.error[29], $aa5a477bcbf0331e$var$lang_comment_content_error = $aa5a477bcbf0331e$var$zbp.options.lang.error[46];
$(function() {
    $aa5a477bcbf0331e$var$zbp.cookie.set("timezone", (new Date).getTimezoneOffset() / 60 * -1);
    var $cpLogin = $(".cp-login").find("a"), $cpVrs = $(".cp-vrs").find("a"), $addinfo = $aa5a477bcbf0331e$var$zbp.cookie.get("addinfo");
    $addinfo && (($addinfo = JSON.parse($addinfo)).chkadmin && ($(".cp-hello").html("\u6B22\u8FCE " + $addinfo.useralias + " (" + $addinfo.levelname + ")"), $cpLogin.html("\u540E\u53F0\u7BA1\u7406")), $addinfo.chkarticle && ($cpVrs.html("\u65B0\u5EFA\u6587\u7AE0"), $cpVrs.attr("href", $aa5a477bcbf0331e$var$zbp.options.bloghost + "zb_system/cmd.php?act=ArticleEdt")));
}), $(function() {
    let inpNameVal = $($aa5a477bcbf0331e$var$zbpConfig.comment.inputs.name.selector).val();
    void 0 !== inpNameVal && ("" !== inpNameVal.trim() && "\u8BBF\u5BA2" !== inpNameVal || $aa5a477bcbf0331e$var$zbp.userinfo.output());
}), document.writeln("<script src='https://www.lw50.com/zb_users/plugin/UEditor/third-party/prism/prism.js' type='text/javascript'><\/script><link rel='stylesheet' type='text/css' href='https://www.lw50.com/zb_users/plugin/UEditor/third-party/prism/prism.css'/>"), $(function() {
    var compatibility = {
        as3: "actionscript",
        "c#": "csharp",
        delphi: "pascal",
        html: "markup",
        xml: "markup",
        vb: "basic",
        js: "javascript",
        plain: "markdown",
        pl: "perl",
        ps: "powershell"
    }, runFunction = function(doms, callback) {
        doms.each(function(index, unwrappedDom) {
            var dom = $(unwrappedDom), codeDom = $("<code>");
            callback && callback(dom);
            var languageClass = "prism-language-" + function(classObject) {
                if (null === classObject) return "markdown";
                var className = classObject[1];
                return compatibility[className] ? compatibility[className] : className;
            }(dom.attr("class").match(/prism-language-([0-9a-zA-Z]+)/));
            codeDom.html(dom.html()).addClass("prism-line-numbers").addClass(languageClass), dom.html("").addClass(languageClass).append(codeDom);
        });
    };
    runFunction($("pre.prism-highlight")), runFunction($('pre[class*="brush:"]'), function(preDom) {
        var original;
        null !== (original = preDom.attr("class").match(/brush:([a-zA-Z0-9\#]+);/)) && (preDom.get(0).className = "prism-highlight prism-language-" + original[1]);
    }), Prism.highlightAll();
});


var $16dc2c7f3f77c38b$exports = {};
var $16dc2c7f3f77c38b$var$_self = "undefined" != typeof window ? window : "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {}, $16dc2c7f3f77c38b$var$Prism = function() {
    var e = /\blang(?:uage)?-(?!\*)(\w+)\b/i, t = $16dc2c7f3f77c38b$var$_self.Prism = {
        util: {
            encode: function(e) {
                return e instanceof n ? new n(e.type, t.util.encode(e.content), e.alias) : "Array" === t.util.type(e) ? e.map(t.util.encode) : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            type: function(e) {
                return Object.prototype.toString.call(e).match(/\[object (\w+)\]/)[1];
            },
            clone: function(e) {
                var n = t.util.type(e);
                switch(n){
                    case "Object":
                        var a = {};
                        for(var r in e)e.hasOwnProperty(r) && (a[r] = t.util.clone(e[r]));
                        return a;
                    case "Array":
                        return e.map && e.map(function(e) {
                            return t.util.clone(e);
                        });
                }
                return e;
            }
        },
        languages: {
            extend: function(e, n) {
                var a = t.util.clone(t.languages[e]);
                for(var r in n)a[r] = n[r];
                return a;
            },
            insertBefore: function(e, n, a, r) {
                r = r || t.languages;
                var l = r[e];
                if (2 == arguments.length) {
                    a = arguments[1];
                    for(var i in a)a.hasOwnProperty(i) && (l[i] = a[i]);
                    return l;
                }
                var o = {};
                for(var s in l)if (l.hasOwnProperty(s)) {
                    if (s == n) for(var i in a)a.hasOwnProperty(i) && (o[i] = a[i]);
                    o[s] = l[s];
                }
                return t.languages.DFS(t.languages, function(t, n) {
                    n === r[e] && t != e && (this[t] = o);
                }), r[e] = o;
            },
            DFS: function(e, n, a) {
                for(var r in e)e.hasOwnProperty(r) && (n.call(e, r, e[r], a || r), "Object" === t.util.type(e[r]) ? t.languages.DFS(e[r], n) : "Array" === t.util.type(e[r]) && t.languages.DFS(e[r], n, r));
            }
        },
        plugins: {},
        highlightAll: function(e, n) {
            for(var a, r = document.querySelectorAll('code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'), l = 0; a = r[l++];)t.highlightElement(a, e === !0, n);
        },
        highlightElement: function(n, a, r) {
            for(var l, i, o = n; o && !e.test(o.className);)o = o.parentNode;
            o && (l = (o.className.match(e) || [
                ,
                ""
            ])[1], i = t.languages[l]), n.className = n.className.replace(e, "").replace(/\s+/g, " ") + " language-" + l, o = n.parentNode, /pre/i.test(o.nodeName) && (o.className = o.className.replace(e, "").replace(/\s+/g, " ") + " language-" + l);
            var s = n.textContent, u = {
                element: n,
                language: l,
                grammar: i,
                code: s
            };
            if (!s || !i) return t.hooks.run("complete", u), void 0;
            if (t.hooks.run("before-highlight", u), a && $16dc2c7f3f77c38b$var$_self.Worker) {
                var g = new Worker(t.filename);
                g.onmessage = function(e) {
                    u.highlightedCode = e.data, t.hooks.run("before-insert", u), u.element.innerHTML = u.highlightedCode, r && r.call(u.element), t.hooks.run("after-highlight", u), t.hooks.run("complete", u);
                }, g.postMessage(JSON.stringify({
                    language: u.language,
                    code: u.code,
                    immediateClose: !0
                }));
            } else u.highlightedCode = t.highlight(u.code, u.grammar, u.language), t.hooks.run("before-insert", u), u.element.innerHTML = u.highlightedCode, r && r.call(n), t.hooks.run("after-highlight", u), t.hooks.run("complete", u);
        },
        highlight: function(e, a, r) {
            var l = t.tokenize(e, a);
            return n.stringify(t.util.encode(l), r);
        },
        tokenize: function(e, n) {
            var a = t.Token, r = [
                e
            ], l = n.rest;
            if (l) {
                for(var i in l)n[i] = l[i];
                delete n.rest;
            }
            e: for(var i in n)if (n.hasOwnProperty(i) && n[i]) {
                var o = n[i];
                o = "Array" === t.util.type(o) ? o : [
                    o
                ];
                for(var s = 0; s < o.length; ++s){
                    var u = o[s], g = u.inside, c = !!u.lookbehind, f = 0, h = u.alias;
                    u = u.pattern || u;
                    for(var p = 0; p < r.length; p++){
                        var d = r[p];
                        if (r.length > e.length) break e;
                        if (!(d instanceof a)) {
                            u.lastIndex = 0;
                            var m = u.exec(d);
                            if (m) {
                                c && (f = m[1].length);
                                var y = m.index - 1 + f, m = m[0].slice(f), v = m.length, k = y + v, b = d.slice(0, y + 1), w = d.slice(k + 1), P = [
                                    p,
                                    1
                                ];
                                b && P.push(b);
                                var A = new a(i, g ? t.tokenize(m, g) : m, h);
                                P.push(A), w && P.push(w), Array.prototype.splice.apply(r, P);
                            }
                        }
                    }
                }
            }
            return r;
        },
        hooks: {
            all: {},
            add: function(e, n) {
                var a = t.hooks.all;
                a[e] = a[e] || [], a[e].push(n);
            },
            run: function(e, n) {
                var a = t.hooks.all[e];
                if (a && a.length) for(var r, l = 0; r = a[l++];)r(n);
            }
        }
    }, n = t.Token = function(e, t, n) {
        this.type = e, this.content = t, this.alias = n;
    };
    if (n.stringify = function(e, a, r) {
        if ("string" == typeof e) return e;
        if ("Array" === t.util.type(e)) return e.map(function(t) {
            return n.stringify(t, a, e);
        }).join("");
        var l = {
            type: e.type,
            content: n.stringify(e.content, a, r),
            tag: "span",
            classes: [
                "prism-token",
                "prism-" + e.type
            ],
            attributes: {},
            language: a,
            parent: r
        };
        if ("comment" == l.type && (l.attributes.spellcheck = "true"), e.alias) {
            var i = "Array" === t.util.type(e.alias) ? e.alias : [
                e.alias
            ];
            Array.prototype.push.apply(l.classes, i);
        }
        t.hooks.run("wrap", l);
        var o = "";
        for(var s in l.attributes)o += (o ? " " : "") + s + '="' + (l.attributes[s] || "") + '"';
        return "<" + l.tag + ' class="' + l.classes.join(" ") + '" ' + o + ">" + l.content + "</" + l.tag + ">";
    }, !$16dc2c7f3f77c38b$var$_self.document) return $16dc2c7f3f77c38b$var$_self.addEventListener ? ($16dc2c7f3f77c38b$var$_self.addEventListener("message", function(e) {
        var n = JSON.parse(e.data), a = n.language, r = n.code, l = n.immediateClose;
        $16dc2c7f3f77c38b$var$_self.postMessage(t.highlight(r, t.languages[a], a)), l && $16dc2c7f3f77c38b$var$_self.close();
    }, !1), $16dc2c7f3f77c38b$var$_self.Prism) : $16dc2c7f3f77c38b$var$_self.Prism;
    var a = document.getElementsByTagName("script");
    return a = a[a.length - 1], a && (t.filename = a.src, document.addEventListener && !a.hasAttribute("data-manual") && document.addEventListener("DOMContentLoaded", t.highlightAll)), $16dc2c7f3f77c38b$var$_self.Prism;
}();
$16dc2c7f3f77c38b$exports && ($16dc2c7f3f77c38b$exports = $16dc2c7f3f77c38b$var$Prism), "undefined" != typeof $parcel$global && ($parcel$global.Prism = $16dc2c7f3f77c38b$var$Prism);
$16dc2c7f3f77c38b$var$Prism.languages.markup = {
    comment: /<!--[\w\W]*?-->/,
    prolog: /<\?[\w\W]+?\?>/,
    doctype: /<!DOCTYPE[\w\W]+?>/,
    cdata: /<!\[CDATA\[[\w\W]*?]]>/i,
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=.$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\\1|\\?(?!\1)[\w\W])*\1|[^\s'">=]+))?)*\s*\/?>/i,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/i,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "attr-value": {
                pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/i,
                inside: {
                    punctuation: /[=>"']/
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: /&#?[\da-z]{1,8};/i
}, $16dc2c7f3f77c38b$var$Prism.hooks.add("wrap", function(a) {
    "entity" === a.type && (a.attributes.title = a.content.replace(/&amp;/, "&"));
}), $16dc2c7f3f77c38b$var$Prism.languages.xml = $16dc2c7f3f77c38b$var$Prism.languages.markup, $16dc2c7f3f77c38b$var$Prism.languages.html = $16dc2c7f3f77c38b$var$Prism.languages.markup, $16dc2c7f3f77c38b$var$Prism.languages.mathml = $16dc2c7f3f77c38b$var$Prism.languages.markup, $16dc2c7f3f77c38b$var$Prism.languages.svg = $16dc2c7f3f77c38b$var$Prism.languages.markup;
$16dc2c7f3f77c38b$var$Prism.languages.css = {
    comment: /\/\*[\w\W]*?\*\//,
    atrule: {
        pattern: /@[\w-]+?.*?(;|(?=\s*\{))/i,
        inside: {
            rule: /@[\w-]+/
        }
    },
    url: /url\((?:(["'])(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
    selector: /[^\{\}\s][^\{\};]*?(?=\s*\{)/,
    string: /("|')(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1/,
    property: /(\b|\B)[\w-]+(?=\s*:)/i,
    important: /\B!important\b/i,
    "function": /[-a-z0-9]+(?=\()/i,
    punctuation: /[(){};:]/
}, $16dc2c7f3f77c38b$var$Prism.languages.css.atrule.inside.rest = $16dc2c7f3f77c38b$var$Prism.util.clone($16dc2c7f3f77c38b$var$Prism.languages.css), $16dc2c7f3f77c38b$var$Prism.languages.markup && ($16dc2c7f3f77c38b$var$Prism.languages.insertBefore("markup", "tag", {
    style: {
        pattern: /(<style[\w\W]*?>)[\w\W]*?(?=<\/style>)/i,
        lookbehind: !0,
        inside: $16dc2c7f3f77c38b$var$Prism.languages.css,
        alias: "language-css"
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("inside", "attr-value", {
    "style-attr": {
        pattern: /\s*style=("|').*?\1/i,
        inside: {
            "attr-name": {
                pattern: /^\s*style/i,
                inside: $16dc2c7f3f77c38b$var$Prism.languages.markup.tag.inside
            },
            punctuation: /^\s*=\s*['"]|['"]\s*$/,
            "attr-value": {
                pattern: /.+/i,
                inside: $16dc2c7f3f77c38b$var$Prism.languages.css
            }
        },
        alias: "language-css"
    }
}, $16dc2c7f3f77c38b$var$Prism.languages.markup.tag));
$16dc2c7f3f77c38b$var$Prism.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\w\W]*?\*\//,
            lookbehind: !0
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0
        }
    ],
    string: /(["'])(\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
    "class-name": {
        pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/i,
        lookbehind: !0,
        inside: {
            punctuation: /(\.|\\)/
        }
    },
    keyword: /\b(if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
    "boolean": /\b(true|false)\b/,
    "function": /[a-z0-9_]+(?=\()/i,
    number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
    punctuation: /[{}[\];(),.:]/
};
$16dc2c7f3f77c38b$var$Prism.languages.javascript = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    keyword: /\b(as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
    number: /\b-?(0x[\dA-Fa-f]+|0b[01]+|0o[0-7]+|\d*\.?\d+([Ee][+-]?\d+)?|NaN|Infinity)\b/,
    "function": /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\()/i
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: /(^|[^\/])\/(?!\/)(\[.+?]|\\.|[^\/\\\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
        lookbehind: !0
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("javascript", "class-name", {
    "template-string": {
        pattern: /`(?:\\`|\\?[^`])*`/,
        inside: {
            interpolation: {
                pattern: /\$\{[^}]+\}/,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $16dc2c7f3f77c38b$var$Prism.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.markup && $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("markup", "tag", {
    script: {
        pattern: /(<script[\w\W]*?>)[\w\W]*?(?=<\/script>)/i,
        lookbehind: !0,
        inside: $16dc2c7f3f77c38b$var$Prism.languages.javascript,
        alias: "language-javascript"
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.js = $16dc2c7f3f77c38b$var$Prism.languages.javascript;
$16dc2c7f3f77c38b$var$Prism.languages.actionscript = $16dc2c7f3f77c38b$var$Prism.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|else|extends|finally|for|function|if|implements|import|in|instanceof|interface|internal|is|native|new|null|package|private|protected|public|return|super|switch|this|throw|try|typeof|use|var|void|while|with|dynamic|each|final|get|include|namespace|native|override|set|static)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
}), $16dc2c7f3f77c38b$var$Prism.languages.actionscript["class-name"].alias = "function", $16dc2c7f3f77c38b$var$Prism.languages.markup && $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("actionscript", "string", {
    xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\\1|\\?(?!\1)[\w\W])*\2)*\s*\/?>/,
        lookbehind: !0,
        inside: {
            rest: $16dc2c7f3f77c38b$var$Prism.languages.markup
        }
    }
});
$16dc2c7f3f77c38b$var$Prism.languages.applescript = {
    comment: [
        /\(\*(?:\(\*[\w\W]*?\*\)|[\w\W])*?\*\)/,
        /--.+/,
        /#.+/
    ],
    string: /"(?:\\?.)*?"/,
    number: /\b-?\d*\.?\d+([Ee]-?\d+)?\b/,
    operator: [
        /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
        /\b(?:(?:start|begin|end)s? with|(?:(?:does not|doesn't) contain|contains?)|(?:is|isn't|is not) (?:in|contained by)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:(?:does not|doesn't) come|comes) (?:before|after)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equals|equal to|isn't|is not)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|or|div|mod|as|not))\b/
    ],
    keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
    "class": {
        pattern: /\b(?:alias|application|boolean|class|constant|date|file|integer|list|number|POSIX file|real|record|reference|RGB color|script|text|centimetres|centimeters|feet|inches|kilometres|kilometers|metres|meters|miles|yards|square feet|square kilometres|square kilometers|square metres|square meters|square miles|square yards|cubic centimetres|cubic centimeters|cubic feet|cubic inches|cubic metres|cubic meters|cubic yards|gallons|litres|liters|quarts|grams|kilograms|ounces|pounds|degrees Celsius|degrees Fahrenheit|degrees Kelvin)\b/,
        alias: "builtin"
    },
    punctuation: /[{}():,¬«»《》]/
};
$16dc2c7f3f77c38b$var$Prism.languages.aspnet = $16dc2c7f3f77c38b$var$Prism.languages.extend("markup", {
    "page-directive tag": {
        pattern: /<%\s*@.*%>/i,
        inside: {
            "page-directive tag": /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
            rest: $16dc2c7f3f77c38b$var$Prism.languages.markup.tag.inside
        }
    },
    "directive tag": {
        pattern: /<%.*%>/i,
        inside: {
            "directive tag": /<%\s*?[$=%#:]{0,2}|%>/i,
            rest: $16dc2c7f3f77c38b$var$Prism.languages.csharp
        }
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\\1|\\?(?!\1)[\w\W])*\1|[^\s'">=]+))?)*\s*\/?>/i, $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("inside", "punctuation", {
    "directive tag": $16dc2c7f3f77c38b$var$Prism.languages.aspnet["directive tag"]
}, $16dc2c7f3f77c38b$var$Prism.languages.aspnet.tag.inside["attr-value"]), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("aspnet", "comment", {
    "asp comment": /<%--[\w\W]*?--%>/
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("aspnet", $16dc2c7f3f77c38b$var$Prism.languages.javascript ? "script" : "tag", {
    "asp script": {
        pattern: /(<script(?=.*runat=['"]?server['"]?)[\w\W]*?>)[\w\W]*?(?=<\/script>)/i,
        lookbehind: !0,
        inside: $16dc2c7f3f77c38b$var$Prism.languages.csharp || {}
    }
});
!function(e) {
    var t = {
        variable: [
            {
                pattern: /\$?\(\([\w\W]+?\)\)/,
                inside: {
                    variable: [
                        {
                            pattern: /(^\$\(\([\w\W]+)\)\)/,
                            lookbehind: !0
                        },
                        /^\$\(\(/
                    ],
                    number: /\b-?(?:0x[\dA-Fa-f]+|\d*\.?\d+(?:[Ee]-?\d+)?)\b/,
                    operator: /--?|-=|\+\+?|\+=|!=?|~|\*\*?|\*=|\/=?|%=?|<<=?|>>=?|<=?|>=?|==?|&&?|&=|\^=?|\|\|?|\|=|\?|:/,
                    punctuation: /\(\(?|\)\)?|,|;/
                }
            },
            {
                pattern: /\$\([^)]+\)|`[^`]+`/,
                inside: {
                    variable: /^\$\(|^`|\)$|`$/
                }
            },
            /\$(?:[a-z0-9_#\?\*!@]+|\{[^}]+\})/i
        ]
    };
    e.languages.bash = {
        shebang: {
            pattern: /^#!\s*\/bin\/bash|^#!\s*\/bin\/sh/,
            alias: "important"
        },
        comment: {
            pattern: /(^|[^"{\\])#.*/,
            lookbehind: !0
        },
        string: [
            {
                pattern: /((?:^|[^<])<<\s*)(?:"|')?(\w+?)(?:"|')?\s*\r?\n(?:[\s\S])*?\r?\n\2/g,
                lookbehind: !0,
                inside: t
            },
            {
                pattern: /("|')(?:\\?[\s\S])*?\1/g,
                inside: t
            }
        ],
        variable: t.variable,
        "function": {
            pattern: /(^|\s|;|\||&)(?:alias|apropos|apt-get|aptitude|aspell|awk|basename|bash|bc|bg|builtin|bzip2|cal|cat|cd|cfdisk|chgrp|chmod|chown|chroot|chkconfig|cksum|clear|cmp|comm|command|cp|cron|crontab|csplit|cut|date|dc|dd|ddrescue|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|enable|env|ethtool|eval|exec|expand|expect|export|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|getopts|git|grep|groupadd|groupdel|groupmod|groups|gzip|hash|head|help|hg|history|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|jobs|join|kill|killall|less|link|ln|locate|logname|logout|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|make|man|mkdir|mkfifo|mkisofs|mknod|more|most|mount|mtools|mtr|mv|mmv|nano|netstat|nice|nl|nohup|notify-send|nslookup|open|op|passwd|paste|pathchk|ping|pkill|popd|pr|printcap|printenv|printf|ps|pushd|pv|pwd|quota|quotacheck|quotactl|ram|rar|rcp|read|readarray|readonly|reboot|rename|renice|remsync|rev|rm|rmdir|rsync|screen|scp|sdiff|sed|seq|service|sftp|shift|shopt|shutdown|sleep|slocate|sort|source|split|ssh|stat|strace|su|sudo|sum|suspend|sync|tail|tar|tee|test|time|timeout|times|touch|top|traceroute|trap|tr|tsort|tty|type|ulimit|umask|umount|unalias|uname|unexpand|uniq|units|unrar|unshar|uptime|useradd|userdel|usermod|users|uuencode|uudecode|v|vdir|vi|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yes|zip)(?=$|\s|;|\||&)/,
            lookbehind: !0
        },
        keyword: {
            pattern: /(^|\s|;|\||&)(?:let|:|\.|if|then|else|elif|fi|for|break|continue|while|in|case|function|select|do|done|until|echo|exit|return|set|declare)(?=$|\s|;|\||&)/,
            lookbehind: !0
        },
        "boolean": {
            pattern: /(^|\s|;|\||&)(?:true|false)(?=$|\s|;|\||&)/,
            lookbehind: !0
        },
        operator: /&&?|\|\|?|==?|!=?|<<<?|>>|<=?|>=?|=~/,
        punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];]/
    };
    var a = t.variable[1].inside;
    a["function"] = e.languages.bash["function"], a.keyword = e.languages.bash.keyword, a.boolean = e.languages.bash.boolean, a.operator = e.languages.bash.operator, a.punctuation = e.languages.bash.punctuation;
}($16dc2c7f3f77c38b$var$Prism);
$16dc2c7f3f77c38b$var$Prism.languages.basic = {
    string: /"(?:""|[!#$%&'()*,\/:;<=>?^_ +\-.A-Z\d])*"/i,
    comment: {
        pattern: /(?:!|REM\b).+/i,
        inside: {
            keyword: /^REM/i
        }
    },
    number: /(?:\b|\B[.-])(?:\d+\.?\d*)(?:E[+-]?\d+)?/i,
    keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SHARED|SINGLE|SELECT CASE|SHELL|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
    "function": /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
    operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
    punctuation: /[,;:()]/
};
$16dc2c7f3f77c38b$var$Prism.languages.c = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    keyword: /\b(asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
    operator: /\-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*\/]/,
    number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)[ful]*\b/i
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("c", "string", {
    macro: {
        pattern: /(^\s*)#\s*[a-z]+([^\r\n\\]|\\.|\\(?:\r\n?|\n))*/im,
        lookbehind: !0,
        alias: "property",
        inside: {
            string: {
                pattern: /(#\s*include\s*)(<.+?>|("|')(\\?.)+?\3)/,
                lookbehind: !0
            },
            directive: {
                pattern: /(#\s*)\b(define|elif|else|endif|error|ifdef|ifndef|if|import|include|line|pragma|undef|using)\b/,
                lookbehind: !0,
                alias: "keyword"
            }
        }
    },
    constant: /\b(__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|stdin|stdout|stderr)\b/
}), delete $16dc2c7f3f77c38b$var$Prism.languages.c["class-name"], delete $16dc2c7f3f77c38b$var$Prism.languages.c["boolean"];
$16dc2c7f3f77c38b$var$Prism.languages.csharp = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    keyword: /\b(abstract|as|async|await|base|bool|break|byte|case|catch|char|checked|class|const|continue|decimal|default|delegate|do|double|else|enum|event|explicit|extern|false|finally|fixed|float|for|foreach|goto|if|implicit|in|int|interface|internal|is|lock|long|namespace|new|null|object|operator|out|override|params|private|protected|public|readonly|ref|return|sbyte|sealed|short|sizeof|stackalloc|static|string|struct|switch|this|throw|true|try|typeof|uint|ulong|unchecked|unsafe|ushort|using|virtual|void|volatile|while|add|alias|ascending|async|await|descending|dynamic|from|get|global|group|into|join|let|orderby|partial|remove|select|set|value|var|where|yield)\b/,
    string: [
        /@("|')(\1\1|\\\1|\\?(?!\1)[\s\S])*\1/,
        /("|')(\\?.)*?\1/
    ],
    number: /\b-?(0x[\da-f]+|\d*\.?\d+f?)\b/i
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("csharp", "keyword", {
    preprocessor: {
        pattern: /(^\s*)#.*/m,
        lookbehind: !0,
        alias: "property",
        inside: {
            directive: {
                pattern: /(\s*#)\b(define|elif|else|endif|endregion|error|if|line|pragma|region|undef|warning)\b/,
                lookbehind: !0,
                alias: "keyword"
            }
        }
    }
});
$16dc2c7f3f77c38b$var$Prism.languages.cpp = $16dc2c7f3f77c38b$var$Prism.languages.extend("c", {
    keyword: /\b(alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|class|compl|const|constexpr|const_cast|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|float|for|friend|goto|if|inline|int|long|mutable|namespace|new|noexcept|nullptr|operator|private|protected|public|register|reinterpret_cast|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,
    "boolean": /\b(true|false)\b/,
    operator: /[-+]{1,2}|!=?|<{1,2}=?|>{1,2}=?|\->|:{1,2}|={1,2}|\^|~|%|&{1,2}|\|?\||\?|\*|\/|\b(and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("cpp", "keyword", {
    "class-name": {
        pattern: /(class\s+)[a-z0-9_]+/i,
        lookbehind: !0
    }
});
!function(e) {
    var n = /#(?!\{).+/, t = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
        comment: n,
        string: [
            /'(?:\\?[^\\])*?'/,
            {
                pattern: /"(?:\\?[^\\])*?"/,
                inside: {
                    interpolation: t
                }
            }
        ],
        keyword: /\b(and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
            pattern: /@(?!\d)\w+/,
            alias: "variable"
        }
    }), e.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
            pattern: /###[\s\S]+?###/,
            alias: "comment"
        },
        "block-regex": {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: "regex",
            inside: {
                comment: n,
                interpolation: t
            }
        }
    }), e.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
            pattern: /`(?:\\?[\s\S])*?`/,
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: "punctuation"
                },
                rest: e.languages.javascript
            }
        },
        "multiline-string": [
            {
                pattern: /'''[\s\S]*?'''/,
                alias: "string"
            },
            {
                pattern: /"""[\s\S]*?"""/,
                alias: "string",
                inside: {
                    interpolation: t
                }
            }
        ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
        property: /(?!\d)\w+(?=\s*:(?!:))/
    });
}($16dc2c7f3f77c38b$var$Prism);
!function(e) {
    e.languages.ruby = e.languages.extend("clike", {
        comment: /#(?!\{[^\r\n]*?\}).*/,
        keyword: /\b(alias|and|BEGIN|begin|break|case|class|def|define_method|defined|do|each|else|elsif|END|end|ensure|false|for|if|in|module|new|next|nil|not|or|raise|redo|require|rescue|retry|return|self|super|then|throw|true|undef|unless|until|when|while|yield)\b/
    });
    var n = {
        pattern: /#\{[^}]+\}/,
        inside: {
            delimiter: {
                pattern: /^#\{|\}$/,
                alias: "tag"
            },
            rest: e.util.clone(e.languages.ruby)
        }
    };
    e.languages.insertBefore("ruby", "keyword", {
        regex: [
            {
                pattern: /%r([^a-zA-Z0-9\s\{\(\[<])(?:[^\\]|\\[\s\S])*?\1[gim]{0,3}/,
                inside: {
                    interpolation: n
                }
            },
            {
                pattern: /%r\((?:[^()\\]|\\[\s\S])*\)[gim]{0,3}/,
                inside: {
                    interpolation: n
                }
            },
            {
                pattern: /%r\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}[gim]{0,3}/,
                inside: {
                    interpolation: n
                }
            },
            {
                pattern: /%r\[(?:[^\[\]\\]|\\[\s\S])*\][gim]{0,3}/,
                inside: {
                    interpolation: n
                }
            },
            {
                pattern: /%r<(?:[^<>\\]|\\[\s\S])*>[gim]{0,3}/,
                inside: {
                    interpolation: n
                }
            },
            {
                pattern: /(^|[^\/])\/(?!\/)(\[.+?]|\\.|[^\/\r\n])+\/[gim]{0,3}(?=\s*($|[\r\n,.;})]))/,
                lookbehind: !0
            }
        ],
        variable: /[@$]+[a-zA-Z_][a-zA-Z_0-9]*(?:[?!]|\b)/,
        symbol: /:[a-zA-Z_][a-zA-Z_0-9]*(?:[?!]|\b)/
    }), e.languages.insertBefore("ruby", "number", {
        builtin: /\b(Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Stat|File|Fixnum|Fload|Hash|Integer|IO|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|String|Struct|TMS|Symbol|ThreadGroup|Thread|Time|TrueClass)\b/,
        constant: /\b[A-Z][a-zA-Z_0-9]*(?:[?!]|\b)/
    }), e.languages.ruby.string = [
        {
            pattern: /%[qQiIwWxs]?([^a-zA-Z0-9\s\{\(\[<])(?:[^\\]|\\[\s\S])*?\1/,
            inside: {
                interpolation: n
            }
        },
        {
            pattern: /%[qQiIwWxs]?\((?:[^()\\]|\\[\s\S])*\)/,
            inside: {
                interpolation: n
            }
        },
        {
            pattern: /%[qQiIwWxs]?\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}/,
            inside: {
                interpolation: n
            }
        },
        {
            pattern: /%[qQiIwWxs]?\[(?:[^\[\]\\]|\\[\s\S])*\]/,
            inside: {
                interpolation: n
            }
        },
        {
            pattern: /%[qQiIwWxs]?<(?:[^<>\\]|\\[\s\S])*>/,
            inside: {
                interpolation: n
            }
        },
        {
            pattern: /("|')(#\{[^}]+\}|\\(?:\r?\n|\r)|\\?.)*?\1/,
            inside: {
                interpolation: n
            }
        }
    ];
}($16dc2c7f3f77c38b$var$Prism);
$16dc2c7f3f77c38b$var$Prism.languages.css.selector = {
    pattern: /[^\{\}\s][^\{\}]*(?=\s*\{)/,
    inside: {
        "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
        "pseudo-class": /:[-\w]+(?:\(.*\))?/,
        "class": /\.[-:\.\w]+/,
        id: /#[-:\.\w]+/
    }
}, $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("css", "function", {
    hexcode: /#[\da-f]{3,6}/i,
    entity: /\\[\da-f]{1,8}/i,
    number: /[\d%\.]+/
});
$16dc2c7f3f77c38b$var$Prism.languages.diff = {
    coord: [
        /^(?:\*{3}|-{3}|\+{3}).*$/m,
        /^@@.*@@$/m,
        /^\d+.*$/m
    ],
    deleted: /^[-<].+$/m,
    inserted: /^[+>].+$/m,
    diff: {
        pattern: /^!(?!!).+$/m,
        alias: "important"
    }
};
$16dc2c7f3f77c38b$var$Prism.languages.erlang = {
    comment: /%.+/,
    string: /"(?:\\?.)*?"/,
    "quoted-function": {
        pattern: /'(?:\\.|[^'\\])+'(?=\()/,
        alias: "function"
    },
    "quoted-atom": {
        pattern: /'(?:\\.|[^'\\])+'/,
        alias: "atom"
    },
    "boolean": /\b(?:true|false)\b/,
    keyword: /\b(?:fun|when|case|of|end|if|receive|after|try|catch)\b/,
    number: [
        /\$\\?./,
        /\d+#[a-z0-9]+/i,
        /(?:\b|-)\d*\.?\d+([Ee][+-]?\d+)?\b/
    ],
    "function": /\b[a-z][\w@]*(?=\()/,
    variable: {
        pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
        lookbehind: !0
    },
    operator: [
        /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:bnot|div|rem|band|bor|bxor|bsl|bsr|not|and|or|xor|orelse|andalso)\b/,
        {
            pattern: /(^|[^<])<(?!<)/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^>])>(?!>)/,
            lookbehind: !0
        }
    ],
    atom: /\b[a-z][\w@]*/,
    punctuation: /[()[\]{}:;,.#|]|<<|>>/
};
$16dc2c7f3f77c38b$var$Prism.languages.fsharp = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    comment: [
        {
            pattern: /(^|[^\\])\(\*[\w\W]*?\*\)/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0
        }
    ],
    keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(abstract|and|as|assert|base|begin|class|default|delegate|do|done|downcast|downto|elif|else|end|exception|extern|false|finally|for|fun|function|global|if|in|inherit|inline|interface|internal|lazy|match|member|module|mutable|namespace|new|not|null|of|open|or|override|private|public|rec|select|static|struct|then|to|true|try|type|upcast|val|void|when|while|with|asr|land|lor|lsl|lsr|lxor|mod|sig|atomic|break|checked|component|const|constraint|constructor|continue|eager|event|external|fixed|functor|include|method|mixin|object|parallel|process|protected|pure|sealed|tailcall|trait|virtual|volatile)\b/,
    string: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|("|')(?:\\\1|\\?(?!\1)[\s\S])*\1)B?/,
    number: [
        /\b-?0x[\da-fA-F]+(un|lf|LF)?\b/,
        /\b-?0b[01]+(y|uy)?\b/,
        /\b-?(\d*\.?\d+|\d+\.)([fFmM]|[eE][+-]?\d+)?\b/,
        /\b-?\d+(y|uy|s|us|l|u|ul|L|UL|I)?\b/
    ]
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("fsharp", "keyword", {
    preprocessor: {
        pattern: /^[^\r\n\S]*#.*/m,
        alias: "property",
        inside: {
            directive: {
                pattern: /(\s*#)\b(else|endif|if|light|line|nowarn)\b/,
                lookbehind: !0,
                alias: "keyword"
            }
        }
    }
});
$16dc2c7f3f77c38b$var$Prism.languages.fortran = {
    "quoted-number": {
        pattern: /[BOZ](['"])[A-F0-9]+\1/i,
        alias: "number"
    },
    string: {
        pattern: /(?:\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:\s*!.+(?:\r\n?|\n))?|(?!\1).)*(?:\1|&)/,
        inside: {
            comment: {
                pattern: /(&(?:\r\n?|\n)\s*)!.*/,
                lookbehind: !0
            }
        }
    },
    comment: /!.*/,
    "boolean": /\.(?:TRUE|FALSE)\.(?:_\w+)?/i,
    number: /(?:\b|[+-])(?:\d+(?:\.\d*)?|\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
    keyword: [
        /\b(?:INTEGER|REAL|DOUBLE ?PRECISION|COMPLEX|CHARACTER|LOGICAL)\b/i,
        /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
        /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
        /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEWHERE|ELSEIF|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
    ],
    operator: [
        /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.(?:EQ|NE|LT|LE|GT|GE|NOT|AND|OR|EQV|NEQV)\.|\.[A-Z]+\./i,
        {
            pattern: /(^|(?!\().)\/(?!\))/,
            lookbehind: !0
        }
    ],
    punctuation: /\(\/|\/\)|[(),;:&]/
};
$16dc2c7f3f77c38b$var$Prism.languages.go = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    keyword: /\b(break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    builtin: /\b(bool|byte|complex(64|128)|error|float(32|64)|rune|string|u?int(8|16|32|64|)|uintptr|append|cap|close|complex|copy|delete|imag|len|make|new|panic|print(ln)?|real|recover)\b/,
    "boolean": /\b(_|iota|nil|true|false)\b/,
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    number: /\b(-?(0x[a-f\d]+|(\d+\.?\d*|\.\d+)(e[-+]?\d+)?)i?)\b/i,
    string: /("|'|`)(\\?.|\r|\n)*?\1/
}), delete $16dc2c7f3f77c38b$var$Prism.languages.go["class-name"];
$16dc2c7f3f77c38b$var$Prism.languages.groovy = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    keyword: /\b(as|def|in|abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
    string: /("""|''')[\W\w]*?\1|("|'|\/)(?:\\?.)*?\2|(\$\/)(\$\/\$|[\W\w])*?\/\$/,
    number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?[\d]+)?)[glidf]?\b/i,
    operator: {
        pattern: /(^|[^.])(~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.{1,2}(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
        lookbehind: !0
    },
    punctuation: /\.+|[{}[\];(),:$]/
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("groovy", "string", {
    shebang: {
        pattern: /#!.+/,
        alias: "comment"
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("groovy", "punctuation", {
    "spock-block": /\b(setup|given|when|then|and|cleanup|expect|where):/
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("groovy", "function", {
    annotation: {
        pattern: /(^|[^.])@\w+/,
        lookbehind: !0
    }
}), $16dc2c7f3f77c38b$var$Prism.hooks.add("wrap", function(e) {
    if ("groovy" === e.language && "string" === e.type) {
        var t = e.content[0];
        if ("'" != t) {
            var n = /([^\\])(\$(\{.*?\}|[\w\.]+))/;
            "$" === t && (n = /([^\$])(\$(\{.*?\}|[\w\.]+))/), e.content = $16dc2c7f3f77c38b$var$Prism.highlight(e.content, {
                expression: {
                    pattern: n,
                    lookbehind: !0,
                    inside: $16dc2c7f3f77c38b$var$Prism.languages.groovy
                }
            }), e.classes.push("/" === t ? "regex" : "gstring");
        }
    }
});
$16dc2c7f3f77c38b$var$Prism.languages.haskell = {
    comment: {
        pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(--[^-!#$%*+=?&@|~.:<>^\\\/].*|{-[\w\W]*?-})/m,
        lookbehind: !0
    },
    "char": /'([^\\']|\\([abfnrtv\\"'&]|\^[A-Z@[\]\^_]|NUL|SOH|STX|ETX|EOT|ENQ|ACK|BEL|BS|HT|LF|VT|FF|CR|SO|SI|DLE|DC1|DC2|DC3|DC4|NAK|SYN|ETB|CAN|EM|SUB|ESC|FS|GS|RS|US|SP|DEL|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
    string: /"([^\\"]|\\([abfnrtv\\"'&]|\^[A-Z@[\]\^_]|NUL|SOH|STX|ETX|EOT|ENQ|ACK|BEL|BS|HT|LF|VT|FF|CR|SO|SI|DLE|DC1|DC2|DC3|DC4|NAK|SYN|ETB|CAN|EM|SUB|ESC|FS|GS|RS|US|SP|DEL|\d+|o[0-7]+|x[0-9a-fA-F]+)|\\\s+\\)*"/,
    keyword: /\b(case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
    import_statement: {
        pattern: /(\r?\n|\r|^)\s*import\s+(qualified\s+)?([A-Z][_a-zA-Z0-9']*)(\.[A-Z][_a-zA-Z0-9']*)*(\s+as\s+([A-Z][_a-zA-Z0-9']*)(\.[A-Z][_a-zA-Z0-9']*)*)?(\s+hiding\b)?/m,
        inside: {
            keyword: /\b(import|qualified|as|hiding)\b/
        }
    },
    builtin: /\b(abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
    number: /\b(\d+(\.\d+)?(e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
    operator: /\s\.\s|[-!#$%*+=?&@|~.:<>^\\\/]*\.[-!#$%*+=?&@|~.:<>^\\\/]+|[-!#$%*+=?&@|~.:<>^\\\/]+\.[-!#$%*+=?&@|~.:<>^\\\/]*|[-!#$%*+=?&@|~:<>^\\\/]+|`([A-Z][_a-zA-Z0-9']*\.)*[_a-z][_a-zA-Z0-9']*`/,
    hvariable: /\b([A-Z][_a-zA-Z0-9']*\.)*[_a-z][_a-zA-Z0-9']*\b/,
    constant: /\b([A-Z][_a-zA-Z0-9']*\.)*[A-Z][_a-zA-Z0-9']*\b/,
    punctuation: /[{}[\];(),.:]/
};
$16dc2c7f3f77c38b$var$Prism.languages.java = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    keyword: /\b(abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while)\b/,
    number: /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp\-]+\b|\b\d*\.?\d+(?:e[+-]?\d+)?[df]?\b/i,
    operator: {
        pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
        lookbehind: !0
    }
});
!function(a) {
    var e = /\\([^a-z()[\]]|[a-z\*]+)/i, n = {
        "equation-command": {
            pattern: e,
            alias: "regex"
        }
    };
    a.languages.latex = {
        comment: /%.*/m,
        cdata: {
            pattern: /(\\begin\{((?:verbatim|lstlisting)\*?)\})([\w\W]*?)(?=\\end\{\2\})/,
            lookbehind: !0
        },
        equation: [
            {
                pattern: /\$(?:\\?[\w\W])*?\$|\\\((?:\\?[\w\W])*?\\\)|\\\[(?:\\?[\w\W])*?\\\]/,
                inside: n,
                alias: "string"
            },
            {
                pattern: /(\\begin\{((?:equation|math|eqnarray|align|multline|gather)\*?)\})([\w\W]*?)(?=\\end\{\2\})/,
                lookbehind: !0,
                inside: n,
                alias: "string"
            }
        ],
        keyword: {
            pattern: /(\\(?:begin|end|ref|cite|label|usepackage|documentclass)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
            lookbehind: !0
        },
        url: {
            pattern: /(\\url\{)[^}]+(?=\})/,
            lookbehind: !0
        },
        headline: {
            pattern: /(\\(?:part|chapter|section|subsection|frametitle|subsubsection|paragraph|subparagraph|subsubparagraph|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\}(?:\[[^\]]+\])?)/,
            lookbehind: !0,
            alias: "class-name"
        },
        "function": {
            pattern: e,
            alias: "selector"
        },
        punctuation: /[[\]{}&]/
    };
}($16dc2c7f3f77c38b$var$Prism);
$16dc2c7f3f77c38b$var$Prism.languages.less = $16dc2c7f3f77c38b$var$Prism.languages.extend("css", {
    comment: [
        /\/\*[\w\W]*?\*\//,
        {
            pattern: /(^|[^\\])\/\/.*/,
            lookbehind: !0
        }
    ],
    atrule: {
        pattern: /@[\w-]+?(?:\([^{}]+\)|[^(){};])*?(?=\s*\{)/i,
        inside: {
            punctuation: /[:()]/
        }
    },
    selector: {
        pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\([^{}]*\)|[^{};@])*?(?=\s*\{)/,
        inside: {
            variable: /@+[\w-]+/
        }
    },
    property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/i,
    punctuation: /[{}();:,]/,
    operator: /[+\-*\/]/
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("less", "punctuation", {
    "function": $16dc2c7f3f77c38b$var$Prism.languages.less.function
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("less", "property", {
    variable: [
        {
            pattern: /@[\w-]+\s*:/,
            inside: {
                punctuation: /:/
            }
        },
        /@@?[\w-]+/
    ],
    "mixin-usage": {
        pattern: /([{;]\s*)[.#](?!\d)[\w-]+.*?(?=[(;])/,
        lookbehind: !0,
        alias: "function"
    }
});
$16dc2c7f3f77c38b$var$Prism.languages.matlab = {
    string: /\B'(?:''|[^'\n])*'/,
    comment: [
        /%\{[\s\S]*?\}%/,
        /%.+/
    ],
    number: /\b-?(?:\d*\.?\d+(?:[eE][+-]?\d+)?(?:[ij])?|[ij])\b/,
    keyword: /\b(?:break|case|catch|continue|else|elseif|end|for|function|if|inf|NaN|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
    "function": /(?!\d)\w+(?=\s*\()/,
    operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
    punctuation: /\.{3}|[.,;\[\](){}!]/
};
$16dc2c7f3f77c38b$var$Prism.languages.objectivec = $16dc2c7f3f77c38b$var$Prism.languages.extend("c", {
    keyword: /\b(asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while|in|self|super)\b|(@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    string: /("|')(\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|@"(\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});
$16dc2c7f3f77c38b$var$Prism.languages.ocaml = {
    comment: /\(\*[\s\S]*?\*\)/,
    string: [
        /"(?:\\.|[^\\\r\n"])*"/,
        /(['`])(?:\\(?:\d+|x[\da-f]+|.)|(?!\1)[^\\\r\n])\1/i
    ],
    number: /\b-?(?:0x[\da-f][\da-f_]+|(?:0[bo])?\d[\d_]*\.?[\d_]*(?:e[+-]?[\d_]+)?)/i,
    type: {
        pattern: /\B['`][a-z\d_]*/i,
        alias: "variable"
    },
    directive: {
        pattern: /\B#[a-z\d_]+/i,
        alias: "function"
    },
    keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|object|of|open|prefix|private|rec|then|sig|struct|to|try|type|val|value|virtual|where|while|with)\b/,
    "boolean": /\b(?:false|true)\b/,
    operator: /:=|[=<>@^|&+\-*\/$%!?~][!$%&\*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lxor|lsl|lsr|mod|nor|or)\b/,
    punctuation: /[(){}\[\]|_.,:;]/
};
$16dc2c7f3f77c38b$var$Prism.languages.perl = {
    comment: [
        {
            pattern: /(^\s*)=\w+[\s\S]*?=cut.*/m,
            lookbehind: !0
        },
        {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: !0
        }
    ],
    string: [
        /\b(?:q|qq|qx|qw)\s*([^a-zA-Z0-9\s\{\(\[<])(?:[^\\]|\\[\s\S])*?\1/,
        /\b(?:q|qq|qx|qw)\s+([a-zA-Z0-9])(?:[^\\]|\\[\s\S])*?\1/,
        /\b(?:q|qq|qx|qw)\s*\((?:[^()\\]|\\[\s\S])*\)/,
        /\b(?:q|qq|qx|qw)\s*\{(?:[^{}\\]|\\[\s\S])*\}/,
        /\b(?:q|qq|qx|qw)\s*\[(?:[^[\]\\]|\\[\s\S])*\]/,
        /\b(?:q|qq|qx|qw)\s*<(?:[^<>\\]|\\[\s\S])*>/,
        /("|`)(?:[^\\]|\\[\s\S])*?\1/,
        /'(?:[^'\\\r\n]|\\.)*'/
    ],
    regex: [
        /\b(?:m|qr)\s*([^a-zA-Z0-9\s\{\(\[<])(?:[^\\]|\\[\s\S])*?\1[msixpodualngc]*/,
        /\b(?:m|qr)\s+([a-zA-Z0-9])(?:[^\\]|\\.)*?\1[msixpodualngc]*/,
        /\b(?:m|qr)\s*\((?:[^()\\]|\\[\s\S])*\)[msixpodualngc]*/,
        /\b(?:m|qr)\s*\{(?:[^{}\\]|\\[\s\S])*\}[msixpodualngc]*/,
        /\b(?:m|qr)\s*\[(?:[^[\]\\]|\\[\s\S])*\][msixpodualngc]*/,
        /\b(?:m|qr)\s*<(?:[^<>\\]|\\[\s\S])*>[msixpodualngc]*/,
        {
            pattern: /(^|[^-]\b)(?:s|tr|y)\s*([^a-zA-Z0-9\s\{\(\[<])(?:[^\\]|\\[\s\S])*?\2(?:[^\\]|\\[\s\S])*?\2[msixpodualngcer]*/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^-]\b)(?:s|tr|y)\s+([a-zA-Z0-9])(?:[^\\]|\\[\s\S])*?\2(?:[^\\]|\\[\s\S])*?\2[msixpodualngcer]*/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^-]\b)(?:s|tr|y)\s*\((?:[^()\\]|\\[\s\S])*\)\s*\((?:[^()\\]|\\[\s\S])*\)[msixpodualngcer]*/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^-]\b)(?:s|tr|y)\s*\{(?:[^{}\\]|\\[\s\S])*\}\s*\{(?:[^{}\\]|\\[\s\S])*\}[msixpodualngcer]*/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^-]\b)(?:s|tr|y)\s*\[(?:[^[\]\\]|\\[\s\S])*\]\s*\[(?:[^[\]\\]|\\[\s\S])*\][msixpodualngcer]*/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^-]\b)(?:s|tr|y)\s*<(?:[^<>\\]|\\[\s\S])*>\s*<(?:[^<>\\]|\\[\s\S])*>[msixpodualngcer]*/,
            lookbehind: !0
        },
        /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(lt|gt|le|ge|eq|ne|cmp|not|and|or|xor|x)\b))/
    ],
    variable: [
        /[&*$@%]\{\^[A-Z]+\}/,
        /[&*$@%]\^[A-Z_]/,
        /[&*$@%]#?(?=\{)/,
        /[&*$@%]#?((::)*'?(?!\d)[\w$]+)+(::)*/i,
        /[&*$@%]\d+/,
        /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
    ],
    filehandle: {
        pattern: /<(?![<=])\S*>|\b_\b/,
        alias: "symbol"
    },
    vstring: {
        pattern: /v\d+(\.\d+)*|\d+(\.\d+){2,}/,
        alias: "string"
    },
    "function": {
        pattern: /sub [a-z0-9_]+/i,
        inside: {
            keyword: /sub/
        }
    },
    keyword: /\b(any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
    number: /\b-?(0x[\dA-Fa-f](_?[\dA-Fa-f])*|0b[01](_?[01])*|(\d(_?\d)*)?\.?\d(_?\d)*([Ee][+-]?\d+)?)\b/,
    operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(lt|gt|le|ge|eq|ne|cmp|not|and|or|xor)\b/,
    punctuation: /[{}[\];(),:]/
};
$16dc2c7f3f77c38b$var$Prism.languages.php = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    keyword: /\b(and|or|xor|array|as|break|case|cfunction|class|const|continue|declare|default|die|do|else|elseif|enddeclare|endfor|endforeach|endif|endswitch|endwhile|extends|for|foreach|function|include|include_once|global|if|new|return|static|switch|use|require|require_once|var|while|abstract|interface|public|implements|private|protected|parent|throw|null|echo|print|trait|namespace|final|yield|goto|instanceof|finally|try|catch)\b/i,
    constant: /\b[A-Z0-9_]{2,}\b/,
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\w\W]*?\*\/|\/\/.*)/,
        lookbehind: !0
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("php", "class-name", {
    "shell-comment": {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0,
        alias: "comment"
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("php", "keyword", {
    delimiter: /\?>|<\?(?:php)?/i,
    variable: /\$\w+\b/i,
    "package": {
        pattern: /(\\|namespace\s+|use\s+)[\w\\]+/,
        lookbehind: !0,
        inside: {
            punctuation: /\\/
        }
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("php", "operator", {
    property: {
        pattern: /(->)[\w]+/,
        lookbehind: !0
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.markup && ($16dc2c7f3f77c38b$var$Prism.hooks.add("before-highlight", function(e) {
    "php" === e.language && (e.tokenStack = [], e.backupCode = e.code, e.code = e.code.replace(/(?:<\?php|<\?)[\w\W]*?(?:\?>)/gi, function(a) {
        return e.tokenStack.push(a), "{{{PHP" + e.tokenStack.length + "}}}";
    }));
}), $16dc2c7f3f77c38b$var$Prism.hooks.add("before-insert", function(e) {
    "php" === e.language && (e.code = e.backupCode, delete e.backupCode);
}), $16dc2c7f3f77c38b$var$Prism.hooks.add("after-highlight", function(e) {
    if ("php" === e.language) {
        for(var a, n = 0; a = e.tokenStack[n]; n++)e.highlightedCode = e.highlightedCode.replace("{{{PHP" + (n + 1) + "}}}", $16dc2c7f3f77c38b$var$Prism.highlight(a, e.grammar, "php").replace(/\$/g, "$$$$"));
        e.element.innerHTML = e.highlightedCode;
    }
}), $16dc2c7f3f77c38b$var$Prism.hooks.add("wrap", function(e) {
    "php" === e.language && "markup" === e.type && (e.content = e.content.replace(/(\{\{\{PHP[0-9]+\}\}\})/g, '<span class="token php">$1</span>'));
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("php", "comment", {
    markup: {
        pattern: /<[^?]\/?(.*?)>/,
        inside: $16dc2c7f3f77c38b$var$Prism.languages.markup
    },
    php: /\{\{\{PHP[0-9]+\}\}\}/
}));
$16dc2c7f3f77c38b$var$Prism.languages.insertBefore("php", "variable", {
    "this": /\$this\b/,
    global: /\$(?:_(?:SERVER|GET|POST|FILES|REQUEST|SESSION|ENV|COOKIE)|GLOBALS|HTTP_RAW_POST_DATA|argc|argv|php_errormsg|http_response_header)/,
    scope: {
        pattern: /\b[\w\\]+::/,
        inside: {
            keyword: /(static|self|parent)/,
            punctuation: /(::|\\)/
        }
    }
});
$16dc2c7f3f77c38b$var$Prism.languages.powershell = {
    comment: [
        {
            pattern: /(^|[^`])<#[\w\W]*?#>/,
            lookbehind: !0
        },
        {
            pattern: /(^|[^`])#.+/,
            lookbehind: !0
        }
    ],
    string: [
        {
            pattern: /"(`?[\w\W])*?"/,
            inside: {
                "function": {
                    pattern: /[^`]\$\(.*?\)/,
                    inside: {}
                }
            }
        },
        /'([^']|'')*'/
    ],
    namespace: /\[[a-z][\w\W]*?\]/i,
    "boolean": /\$(true|false)\b/i,
    variable: /\$\w+\b/i,
    "function": [
        /\b(Add-(Computer|Content|History|Member|PSSnapin|Type)|Checkpoint-Computer|Clear-(Content|EventLog|History|Item|ItemProperty|Variable)|Compare-Object|Complete-Transaction|Connect-PSSession|ConvertFrom-(Csv|Json|StringData)|Convert-Path|ConvertTo-(Csv|Html|Json|Xml)|Copy-(Item|ItemProperty)|Debug-Process|Disable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)|Disconnect-PSSession|Enable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)|Enter-PSSession|Exit-PSSession|Export-(Alias|Clixml|Console|Csv|FormatData|ModuleMember|PSSession)|ForEach-Object|Format-(Custom|List|Table|Wide)|Get-(Alias|ChildItem|Command|ComputerRestorePoint|Content|ControlPanelItem|Culture|Date|Event|EventLog|EventSubscriber|FormatData|Help|History|Host|HotFix|Item|ItemProperty|Job|Location|Member|Module|Process|PSBreakpoint|PSCallStack|PSDrive|PSProvider|PSSession|PSSessionConfiguration|PSSnapin|Random|Service|TraceSource|Transaction|TypeData|UICulture|Unique|Variable|WmiObject)|Group-Object|Import-(Alias|Clixml|Csv|LocalizedData|Module|PSSession)|Invoke-(Command|Expression|History|Item|RestMethod|WebRequest|WmiMethod)|Join-Path|Limit-EventLog|Measure-(Command|Object)|Move-(Item|ItemProperty)|New-(Alias|Event|EventLog|Item|ItemProperty|Module|ModuleManifest|Object|PSDrive|PSSession|PSSessionConfigurationFile|PSSessionOption|PSTransportOption|Service|TimeSpan|Variable|WebServiceProxy)|Out-(Default|File|GridView|Host|Null|Printer|String)|Pop-Location|Push-Location|Read-Host|Receive-(Job|PSSession)|Register-(EngineEvent|ObjectEvent|PSSessionConfiguration|WmiEvent)|Remove-(Computer|Event|EventLog|Item|ItemProperty|Job|Module|PSBreakpoint|PSDrive|PSSession|PSSnapin|TypeData|Variable|WmiObject)|Rename-(Computer|Item|ItemProperty)|Reset-ComputerMachinePassword|Resolve-Path|Restart-(Computer|Service)|Restore-Computer|Resume-(Job|Service)|Save-Help|Select-(Object|String|Xml)|Send-MailMessage|Set-(Alias|Content|Date|Item|ItemProperty|Location|PSBreakpoint|PSDebug|PSSessionConfiguration|Service|StrictMode|TraceSource|Variable|WmiInstance)|Show-(Command|ControlPanelItem|EventLog)|Sort-Object|Split-Path|Start-(Job|Process|Service|Sleep|Transaction)|Stop-(Computer|Job|Process|Service)|Suspend-(Job|Service)|Tee-Object|Test-(ComputerSecureChannel|Connection|ModuleManifest|Path|PSSessionConfigurationFile)|Trace-Command|Unblock-File|Undo-Transaction|Unregister-(Event|PSSessionConfiguration)|Update-(FormatData|Help|List|TypeData)|Use-Transaction|Wait-(Event|Job|Process)|Where-Object|Write-(Debug|Error|EventLog|Host|Output|Progress|Verbose|Warning))\b/i,
        /\b(ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
    ],
    keyword: /\b(Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
    operator: {
        pattern: /(\W?)(!|-(eq|ne|gt|ge|lt|le|sh[lr]|not|b?(and|x?or)|(Not)?(Like|Match|Contains|In)|Replace|Join|is(Not)?|as)\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
        lookbehind: !0
    },
    punctuation: /[|{}[\];(),.]/
}, $16dc2c7f3f77c38b$var$Prism.languages.powershell.string[0].inside.boolean = $16dc2c7f3f77c38b$var$Prism.languages.powershell.boolean, $16dc2c7f3f77c38b$var$Prism.languages.powershell.string[0].inside.variable = $16dc2c7f3f77c38b$var$Prism.languages.powershell.variable, $16dc2c7f3f77c38b$var$Prism.languages.powershell.string[0].inside.function.inside = $16dc2c7f3f77c38b$var$Prism.util.clone($16dc2c7f3f77c38b$var$Prism.languages.powershell);
$16dc2c7f3f77c38b$var$Prism.languages.python = {
    "triple-quoted-string": {
        pattern: /"""[\s\S]+?"""|'''[\s\S]+?'''/,
        alias: "string"
    },
    comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0
    },
    string: /("|')(?:\\?.)*?\1/,
    "function": {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_][a-zA-Z0-9_]*(?=\()/g,
        lookbehind: !0
    },
    "class-name": {
        pattern: /(\bclass\s+)[a-z0-9_]+/i,
        lookbehind: !0
    },
    keyword: /\b(?:as|assert|async|await|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|pass|print|raise|return|try|while|with|yield)\b/,
    "boolean": /\b(?:True|False)\b/,
    number: /\b-?(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*\.?\d*|\.\d+)(?:e[+-]?\d+)?j?\b/i,
    operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:or|and|not)\b/,
    punctuation: /[{}[\];(),.:]/
};
$16dc2c7f3f77c38b$var$Prism.languages.r = {
    comment: /#.*/,
    string: /(['"])(?:\\?.)*?\1/,
    "percent-operator": {
        pattern: /%[^%\s]*%/,
        alias: "operator"
    },
    "boolean": /\b(?:TRUE|FALSE)\b/,
    ellipsis: /\.\.(?:\.|\d+)/,
    number: [
        /\b(?:NaN|Inf)\b/,
        /\b(?:0x[\dA-Fa-f]+(?:\.\d*)?|\d*\.?\d+)(?:[EePp][+-]?\d+)?[iL]?\b/
    ],
    keyword: /\b(?:if|else|repeat|while|function|for|in|next|break|NULL|NA|NA_integer_|NA_real_|NA_complex_|NA_character_)\b/,
    operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
    punctuation: /[(){}\[\],;]/
};
!function(a) {
    var s = a.util.clone(a.languages.javascript);
    a.languages.jsx = a.languages.extend("markup", s), a.languages.jsx.tag.pattern = /<\/?[\w:-]+\s*(?:\s+[\w:-]+(?:=(?:("|')(\\?[\w\W])*?\1|[^\s'">=]+|(\{[\w\W]*?\})))?\s*)*\/?>/i, a.languages.jsx.tag.inside["attr-value"].pattern = /=[^\{](?:('|")[\w\W]*?(\1)|[^\s>]+)/i, a.languages.insertBefore("inside", "attr-value", {
        script: {
            pattern: /=(\{(?:\{[^}]*\}|[^}])+\})/i,
            inside: {
                "function": a.languages.javascript.function,
                punctuation: /[={}[\];(),.:]/,
                keyword: a.languages.javascript.keyword,
                "boolean": a.languages.javascript.boolean
            },
            alias: "language-javascript"
        }
    }, a.languages.jsx.tag);
}($16dc2c7f3f77c38b$var$Prism);
!function(e) {
    e.languages.crystal = e.languages.extend("ruby", {
        keyword: [
            /\b(?:abstract|alias|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|rescue|return|require|self|sizeof|struct|super|then|type|typeof|union|unless|until|when|while|with|yield|__DIR__|__FILE__|__LINE__)\b/,
            {
                pattern: /(\.\s*)(?:is_a|responds_to)\?/,
                lookbehind: !0
            }
        ],
        number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[0-9a-fA-F_]*[0-9a-fA-F]|(?:[0-9](?:[0-9_]*[0-9])?)(?:\.[0-9_]*[0-9])?(?:[eE][+-]?[0-9_]*[0-9])?)(?:_(?:[uif](?:8|16|32|64))?)?\b/
    });
    var t = e.util.clone(e.languages.crystal);
    e.languages.insertBefore("crystal", "string", {
        attribute: {
            pattern: /@\[.+?\]/,
            alias: "attr-name",
            inside: {
                delimiter: {
                    pattern: /^@\[|\]$/,
                    alias: "tag"
                },
                rest: t
            }
        },
        expansion: [
            {
                pattern: /\{\{.+?\}\}/,
                inside: {
                    delimiter: {
                        pattern: /^\{\{|\}\}$/,
                        alias: "tag"
                    },
                    rest: t
                }
            },
            {
                pattern: /\{%.+?%\}/,
                inside: {
                    delimiter: {
                        pattern: /^\{%|%\}$/,
                        alias: "tag"
                    },
                    rest: t
                }
            }
        ]
    });
}($16dc2c7f3f77c38b$var$Prism);
$16dc2c7f3f77c38b$var$Prism.languages.rust = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\w\W]*?\*\//,
            lookbehind: !0
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0
        }
    ],
    string: [
        /b?r(#*)"(?:\\?.)*?"\1/,
        /b?("|')(?:\\?.)*?\1/
    ],
    keyword: /\b(?:abstract|alignof|as|be|box|break|const|continue|crate|do|else|enum|extern|false|final|fn|for|if|impl|in|let|loop|match|mod|move|mut|offsetof|once|override|priv|pub|pure|ref|return|sizeof|static|self|struct|super|true|trait|type|typeof|unsafe|unsized|use|virtual|where|while|yield)\b/,
    attribute: {
        pattern: /#!?\[.+?\]/,
        alias: "attr-name"
    },
    "function": [
        /[a-z0-9_]+(?=\s*\()/i,
        /[a-z0-9_]+!(?=\s*\(|\[)/i
    ],
    "macro-rules": {
        pattern: /[a-z0-9_]+!/i,
        alias: "function"
    },
    number: /\b-?(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(\d(_?\d)*)?\.?\d(_?\d)*([Ee][+-]?\d+)?)(?:_?(?:[iu](?:8|16|32|64)?|f32|f64))?\b/,
    "closure-params": {
        pattern: /\|[^|]*\|(?=\s*[{-])/,
        inside: {
            punctuation: /[\|:,]/,
            operator: /[&*]/
        }
    },
    punctuation: /[{}[\];(),:]|\.+|->/,
    operator: /[-+*\/%!^=]=?|@|&[&=]?|\|[|=]?|<<?=?|>>?=?/
};
!function(e) {
    e.languages.sass = e.languages.extend("css", {
        comment: {
            pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t]+.+)*/m,
            lookbehind: !0
        }
    }), e.languages.insertBefore("sass", "atrule", {
        "atrule-line": {
            pattern: /^(?:[ \t]*)[@+=].+/m,
            inside: {
                atrule: /(?:@[\w-]+|[+=])/m
            }
        }
    }), delete e.languages.sass.atrule;
    var a = /((\$[-_\w]+)|(#\{\$[-_\w]+\}))/i, t = [
        /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|or|not)\b/,
        {
            pattern: /(\s+)-(?=\s)/,
            lookbehind: !0
        }
    ];
    e.languages.insertBefore("sass", "property", {
        "variable-line": {
            pattern: /^[ \t]*\$.+/m,
            inside: {
                punctuation: /:/,
                variable: a,
                operator: t
            }
        },
        "property-line": {
            pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s]+.*)/m,
            inside: {
                property: [
                    /[^:\s]+(?=\s*:)/,
                    {
                        pattern: /(:)[^:\s]+/,
                        lookbehind: !0
                    }
                ],
                punctuation: /:/,
                variable: a,
                operator: t,
                important: e.languages.sass.important
            }
        }
    }), delete e.languages.sass.property, delete e.languages.sass.important, delete e.languages.sass.selector, e.languages.insertBefore("sass", "punctuation", {
        selector: {
            pattern: /([ \t]*)\S(?:,?[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,?[^,\r\n]+)*)*/,
            lookbehind: !0
        }
    });
}($16dc2c7f3f77c38b$var$Prism);
$16dc2c7f3f77c38b$var$Prism.languages.scss = $16dc2c7f3f77c38b$var$Prism.languages.extend("css", {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\w\W]*?\*\/|\/\/.*)/,
        lookbehind: !0
    },
    atrule: {
        pattern: /@[\w-]+(?:\([^()]+\)|[^(])*?(?=\s+[{;])/,
        inside: {
            rule: /@[\w-]+/
        }
    },
    url: /(?:[-a-z]+-)*url(?=\()/i,
    selector: {
        pattern: /(?=\S)[^@;\{\}\(\)]?([^@;\{\}\(\)]|&|#\{\$[-_\w]+\})+(?=\s*\{(\}|\s|[^\}]+(:|\{)[^\}]+))/m,
        inside: {
            placeholder: /%[-_\w]+/
        }
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("scss", "atrule", {
    keyword: [
        /@(?:if|else(?: if)?|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)/i,
        {
            pattern: /( +)(?:from|through)(?= )/,
            lookbehind: !0
        }
    ]
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("scss", "property", {
    variable: /\$[-_\w]+|#\{\$[-_\w]+\}/
}), $16dc2c7f3f77c38b$var$Prism.languages.insertBefore("scss", "function", {
    placeholder: {
        pattern: /%[-_\w]+/,
        alias: "selector"
    },
    statement: /\B!(?:default|optional)\b/i,
    "boolean": /\b(?:true|false)\b/,
    "null": /\bnull\b/,
    operator: {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|or|not)(?=\s)/,
        lookbehind: !0
    }
}), $16dc2c7f3f77c38b$var$Prism.languages.scss.atrule.inside.rest = $16dc2c7f3f77c38b$var$Prism.util.clone($16dc2c7f3f77c38b$var$Prism.languages.scss);
$16dc2c7f3f77c38b$var$Prism.languages.scala = $16dc2c7f3f77c38b$var$Prism.languages.extend("java", {
    keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
    string: /"""[\W\w]*?"""|"(?:[^"\\\r\n]|\\.)*"|'(?:[^\\\r\n']|\\.[^\\']*)'/,
    builtin: /\b(?:String|Int|Long|Short|Byte|Boolean|Double|Float|Char|Any|AnyRef|AnyVal|Unit|Nothing)\b/,
    number: /\b(?:0x[\da-f]*\.?[\da-f]+|\d*\.?\d+e?\d*[dfl]?)\b/i,
    symbol: /'[^\d\s\\]\w*/
}), delete $16dc2c7f3f77c38b$var$Prism.languages.scala["class-name"], delete $16dc2c7f3f77c38b$var$Prism.languages.scala["function"];
$16dc2c7f3f77c38b$var$Prism.languages.pascal = {
    comment: [
        /\(\*[\s\S]+?\*\)/,
        /\{[\s\S]+?\}/,
        /\/\/.*/
    ],
    string: /(?:'(?:''|[^'\r\n])*'|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
    keyword: [
        {
            pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
            lookbehind: !0
        },
        {
            pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
            lookbehind: !0
        },
        {
            pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
            lookbehind: !0
        },
        {
            pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
            lookbehind: !0
        }
    ],
    number: [
        /[+-]?(?:[&%]\d+|\$[a-f\d]+)/i,
        /([+-]|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
    ],
    operator: [
        /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/i,
        {
            pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
            lookbehind: !0
        }
    ],
    punctuation: /\(\.|\.\)|[()\[\]:;,.]/
};
$16dc2c7f3f77c38b$var$Prism.languages.sql = {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\w\W]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: !0
    },
    string: {
        pattern: /(^|[^@\\])("|')(?:\\?[\s\S])*?\2/,
        lookbehind: !0
    },
    variable: /@[\w.$]+|@("|'|`)(?:\\?[\s\S])+?\1/,
    "function": /\b(?:COUNT|SUM|AVG|MIN|MAX|FIRST|LAST|UCASE|LCASE|MID|LEN|ROUND|NOW|FORMAT)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR VARYING|CHARACTER (?:SET|VARYING)|CHARSET|CHECK|CHECKPOINT|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMN|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS|CONTAINSTABLE|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|DATA(?:BASES?)?|DATETIME|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE(?: PRECISION)?|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE KEY|ELSE|ENABLE|ENCLOSED BY|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPE(?:D BY)?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|IDENTITY(?:_INSERT|COL)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTO|INVOKER|ISOLATION LEVEL|JOIN|KEYS?|KILL|LANGUAGE SQL|LAST|LEFT|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MODIFIES SQL DATA|MODIFY|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL(?: CHAR VARYING| CHARACTER(?: VARYING)?| VARCHAR)?|NATURAL|NCHAR(?: VARCHAR)?|NEXT|NO(?: SQL|CHECK|CYCLE)?|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READ(?:S SQL DATA|TEXT)?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEATABLE|REPLICATION|REQUIRE|RESTORE|RESTRICT|RETURNS?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE MODE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|START(?:ING BY)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED BY|TEXT(?:SIZE)?|THEN|TIMESTAMP|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNPIVOT|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?)\b/i,
    "boolean": /\b(?:TRUE|FALSE|NULL)\b/i,
    number: /\b-?(?:0x)?\d*\.?[\da-f]+\b/,
    operator: /[-+*\/=%^~]|&&?|\|?\||!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|IN|LIKE|NOT|OR|IS|DIV|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
};
$16dc2c7f3f77c38b$var$Prism.languages.swift = $16dc2c7f3f77c38b$var$Prism.languages.extend("clike", {
    string: {
        pattern: /("|')(\\(?:\((?:[^()]|\([^)]+\))+\)|\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        inside: {
            interpolation: {
                pattern: /\\\((?:[^()]|\([^)]+\))+\)/,
                inside: {
                    delimiter: {
                        pattern: /^\\\(|\)$/,
                        alias: "variable"
                    }
                }
            }
        }
    },
    keyword: /\b(as|associativity|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic(?:Type)?|else|enum|extension|fallthrough|final|for|func|get|guard|if|import|in|infix|init|inout|internal|is|lazy|left|let|mutating|new|none|nonmutating|operator|optional|override|postfix|precedence|prefix|private|Protocol|public|repeat|required|rethrows|return|right|safe|self|Self|set|static|struct|subscript|super|switch|throws?|try|Type|typealias|unowned|unsafe|var|weak|where|while|willSet|__(?:COLUMN__|FILE__|FUNCTION__|LINE__))\b/,
    number: /\b([\d_]+(\.[\de_]+)?|0x[a-f0-9_]+(\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    constant: /\b(nil|[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    atrule: /@\b(IB(?:Outlet|Designable|Action|Inspectable)|class_protocol|exported|noreturn|NS(?:Copying|Managed)|objc|UIApplicationMain|auto_closure)\b/,
    builtin: /\b([A-Z]\S+|abs|advance|alignof(?:Value)?|assert|contains|count(?:Elements)?|debugPrint(?:ln)?|distance|drop(?:First|Last)|dump|enumerate|equal|filter|find|first|getVaList|indices|isEmpty|join|last|lexicographicalCompare|map|max(?:Element)?|min(?:Element)?|numericCast|overlaps|partition|print(?:ln)?|reduce|reflect|reverse|sizeof(?:Value)?|sort(?:ed)?|split|startsWith|stride(?:of(?:Value)?)?|suffix|swap|toDebugString|toString|transcode|underestimateCount|unsafeBitCast|with(?:ExtendedLifetime|Unsafe(?:MutablePointers?|Pointers?)|VaList))\b/
}), $16dc2c7f3f77c38b$var$Prism.languages.swift.string.inside.interpolation.inside.rest = $16dc2c7f3f77c38b$var$Prism.util.clone($16dc2c7f3f77c38b$var$Prism.languages.swift);
$16dc2c7f3f77c38b$var$Prism.languages.typescript = $16dc2c7f3f77c38b$var$Prism.languages.extend("javascript", {
    keyword: /\b(break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|false|finally|for|function|get|if|implements|import|in|instanceof|interface|let|new|null|package|private|protected|public|return|set|static|super|switch|this|throw|true|try|typeof|var|void|while|with|yield|module|declare|constructor|string|Function|any|number|boolean|Array|enum)\b/
});
!function() {
    "undefined" != typeof self && self.Prism && self.document && $16dc2c7f3f77c38b$var$Prism.hooks.add("complete", function(e) {
        if (e.code) {
            var t = e.element.parentNode, s = /\s*\bprism-line-numbers\b\s*/;
            if (t && /pre/i.test(t.nodeName) && (s.test(t.className) || s.test(e.element.className)) && !e.element.querySelector(".prism-line-numbers-rows")) {
                s.test(e.element.className) && (e.element.className = e.element.className.replace(s, "")), s.test(t.className) || (t.className += " prism-line-numbers");
                var n, a = e.code.match(/\n(?!$)/g), l = a ? a.length + 1 : 1, m = new Array(l + 1);
                m = m.join("<span></span>"), n = document.createElement("span"), n.className = "prism-line-numbers-rows", n.innerHTML = m, t.hasAttribute("data-start") && (t.style.counterReset = "linenumber " + (parseInt(t.getAttribute("data-start"), 10) - 1)), e.element.appendChild(n);
            }
        }
    });
}();
!function() {
    if ("undefined" != typeof self && self.Prism && self.document) {
        var e = {
            css: "CSS",
            clike: "C-like",
            javascript: "JavaScript",
            abap: "ABAP",
            actionscript: "ActionScript",
            apacheconf: "Apache Configuration",
            apl: "APL",
            applescript: "AppleScript",
            asciidoc: "AsciiDoc",
            aspnet: "ASP.NET (C#)",
            autoit: "AutoIt",
            autohotkey: "AutoHotkey",
            basic: "BASIC",
            csharp: "C#",
            cpp: "C++",
            coffeescript: "CoffeeScript",
            "css-extras": "CSS Extras",
            fsharp: "F#",
            glsl: "GLSL",
            http: "HTTP",
            inform7: "Inform 7",
            latex: "LaTeX",
            lolcode: "LOLCODE",
            matlab: "MATLAB",
            mel: "MEL",
            nasm: "NASM",
            nginx: "nginx",
            nsis: "NSIS",
            objectivec: "Objective-C",
            ocaml: "OCaml",
            parigp: "PARI/GP",
            php: "PHP",
            "php-extras": "PHP Extras",
            powershell: "PowerShell",
            jsx: "React JSX",
            rest: "reST (reStructuredText)",
            sas: "SAS",
            sass: "Sass (Sass)",
            scss: "Sass (Scss)",
            sql: "SQL",
            typescript: "TypeScript",
            vhdl: "VHDL",
            vim: "vim",
            wiki: "Wiki markup",
            yaml: "YAML"
        };
        $16dc2c7f3f77c38b$var$Prism.hooks.add("before-highlight", function(a) {
            var s = a.element.parentNode;
            if (s && /pre/i.test(s.nodeName)) {
                var t = e[a.language] || a.language.substring(0, 1).toUpperCase() + a.language.substring(1);
                s.setAttribute("data-language", t);
                var i, r, l = s.previousSibling;
                l && /\s*\bprism-show-language\b\s*/.test(l.className) && l.firstChild && /\s*\bprism-show-language-label\b\s*/.test(l.firstChild.className) ? (r = l.firstChild, r.getAttribute("data-language") !== t && (r.setAttribute("data-language", t), r.innerHTML = t)) : (i = document.createElement("div"), r = document.createElement("div"), r.className = "prism-show-language-label", r.setAttribute("data-language", t), r.innerHTML = t, i.className = "prism-show-language", i.appendChild(r), s.parentNode.insertBefore(i, s));
            }
        });
    }
}();


var $3b2111debd702654$exports = {};
(function() {
    var t = "system-default", e = [
        "comment.postsuccess",
        "comment.posterror"
    ], n = {
        "comment.reply": "comment.reply.start",
        "userinfo.savefromhtml": "userinfo.readFromHtml"
    }, o = function(o, r) {
        if ("undefined" == typeof jQuery && void 0 === r) throw new Error("No jQuery!");
        this.$ = r || window.jQuery, Object.keys || (Object.keys = function(t) {
            return this.$.map(t, function(t, e) {
                return e;
            });
        }), console || (window.console = {}, console.logs = [], console.log = console.error = console.warn = function() {
            console.logs.push(arguments);
        }), e = e.concat(Object.keys(n));
        var s = this;
        return i(this), o = o || {}, o.cookiepath = o.cookiepath || "/", o.bloghost = o.bloghost || location.origin, o.ajaxurl = o.ajaxurl || location.origin, o.commentmaxlength = o.commentmaxlength || 1e3, o.lang = o.lang || {}, o.comment = o.comment || {}, o.comment.inputs = o.comment.inputs || {}, o.comment.useDefaultEvents = o.comment.useDefaultEvents || !1, this.eachOnCommentInputs = function(t) {
            return s.$.each(o.comment.inputs, t);
        }, this.eachOnCommentInputs(function(t, e) {
            !e.getter && e.selector && (e.getter = function() {
                return s.$(e.selector).val();
            }), !e.setter && e.selector && (e.setter = function(t) {
                return s.$(e.selector).val(t);
            }), e.validator || (e.validator = function(t, n) {
                for(t = t || e.getter();;){
                    if (t = t || "", t = t.toString().trim(), "" === t) {
                        if (e.required) break;
                        return n(null);
                    }
                    if (e.validateRule && (e.validateRule.lastIndex = 0, !e.validateRule.test(t))) break;
                    return n(null);
                }
                var o = new Error(e.validateFailedMessage || s.options.lang.error[e.validateFailedErrorCode]);
                return o.code = e.validateFailedErrorCode, n(o);
            });
        }), this.options = o, this.plugin.on("userinfo.output", "system", function() {
            s.eachOnCommentInputs(function(t, e) {
                e.saveLocally && (s.userinfo[t] = s.cookie.get("zbp_userinfo_" + t), s.userinfo[t] && e.setter(s.userinfo[t]));
            });
        }), this.plugin.on("userinfo.readFromHtml", "system", function() {
            s.eachOnCommentInputs(function(t, e) {
                e.saveLocally && (s.userinfo[t] = e.getter());
            }), s.userinfo.save();
        }), this.plugin.on("userinfo.save", "system", function() {
            s.eachOnCommentInputs(function(t, e) {
                e.saveLocally && (s.userinfo[t] = e.getter(), s.cookie.set("zbp_userinfo_" + t, s.userinfo[t]));
            });
        }), this.plugin.on("comment.get", "system", function(t, e) {
            s.$.get(s.options.bloghost + "zb_system/cmd.php?act=getcmt&postid=" + t + "&page=" + e, function(n, o, i) {
                s.plugin.emit("comment.got", [
                    t,
                    e
                ], n, o, i);
            });
        }), this.plugin.on("comment.post.validate", "system", function(t) {
            var e = 0, n = !1, o = function(o) {
                if (!n) {
                    if (o) return n = !0, void s.plugin.emit("comment.post.validate.error", o, t);
                    if (e++, e === Object.keys(s.options.comment.inputs).length) {
                        var i = {
                            no: 0,
                            msg: ""
                        };
                        if (s.plugin.emit("comment.verifydata", i, t), i.no > 0) {
                            o = new Error(i.msg);
                            return o.code = i.no, void s.plugin.emit("comment.post.validate.error", o, t);
                        }
                        s.plugin.emit("comment.post.validate.success", t);
                    }
                }
            };
            s.eachOnCommentInputs(function(e, n) {
                n.validator(t[e], o);
            });
        }), this.plugin.on("comment.post.start", "system", function(t) {
            s.eachOnCommentInputs(function(e, n) {
                t[e] = t[e] || n.getter();
            }), t.commentKey = (new Date).getTime() + "" + Math.random(), s.plugin.emit("comment.post.validate", t);
        }), this.plugin.on("comment.post.validate.error", "system", function(t, e) {
            s.plugin.emit("comment.post.error", t, e);
        }), this.plugin.on("comment.post.validate.success", "system", function(t) {
            s.$.post(t.action, t).done(function(e, n, o) {
                s.plugin.emit("comment.postsuccess", t, e, n, o);
                var i = s.$.parseJSON(e);
                if (i.err && i.err.code > 0) {
                    var r = new Error(i.err.msg);
                    r.code = i.err.code, s.plugin.emit("comment.post.error", r, t, i, n, o);
                } else s.plugin.emit("comment.post.success", t, i, n, o);
            }).fail(function(e, n) {
                var o = new Error(n);
                o.code = 255, s.plugin.emit("comment.post.error", o, t, n, e);
            });
        }), this.plugin.on("comment.post.success", "system", function(t, e, n, o) {
            s.plugin.emit("comment.post.done", null, t, e, n, o);
        }), this.plugin.on("comment.post.error", "system", function(t, e, n, o, i) {
            s.plugin.emit("comment.posterror", {
                jqXHR: i,
                msg: t.message,
                code: t.code
            }, e), s.plugin.emit("comment.post.done", t, e, n, o, i);
        }), this.options.comment.useDefaultEvents && (this.plugin.on("comment.reply.start", t, function(t) {
            this.$("#inpRevID").val(t), this.$("#cancel-reply").show().bind("click", function() {
                return s.plugin.emit("comment.reply.cancel"), s.$("#inpRevID").val(0), s.$(this).hide(), window.location.hash = "#comment", !1;
            }), window.location.hash = "#comment";
        }), this.plugin.on("comment.got", t, function(t, e, n, o) {
            this.$("#AjaxCommentBegin").nextUntil("#AjaxCommentEnd").remove(), this.$("#AjaxCommentBegin").after(e);
        }), this.plugin.on("comment.post.start", t, function() {
            var t = s.$("#inpId").parent("form").find(":submit");
            t.data("orig", t.val()).val("Waiting...").attr("disabled", "disabled").addClass("loading");
        }), this.plugin.on("comment.post.done", t, function(t) {
            var e = s.$("#inpId").parent("form").find(":submit");
            e.removeClass("loading").removeAttr("disabled"), e.data("orig") && e.val(e.data("orig"));
        }), this.plugin.on("comment.post.success", t, function(t, e, n, o) {
            "0" === t.replyid.toString() ? this.$(e.data.html).insertAfter("#AjaxCommentBegin") : this.$(e.data.html).insertAfter("#AjaxComment" + t.replyid), location.hash = "#cmt" + e.data.ID, this.$("#txaArticle").val(""), this.userinfo.readFromHtml();
        }), this.plugin.on("comment.post.error", t, function(t) {
            throw alert(t.message), new Error("ERROR - " + t.message);
        })), this;
    };
    o.prototype._plugins = {};
    var i = function(o) {
        o.utils = {}, o.utils.getFromIndex = function(t, e) {
            for(var n = [], o = t; o < e.length; o++)n.push(e[o]);
            return n;
        };
        var i = function() {};
        i.prototype.checkIsInterfaceDeprecated = function(t) {
            return e.indexOf(t) >= 0 && (console.warn("Interface '" + t + "' is deprecated in ZBP 1.6, please update your plugin or theme!"), !0);
        }, i.prototype.bind = i.prototype.on = i.prototype.addListener = function(t, e, i) {
            return this.checkIsInterfaceDeprecated(t) && n[t] && (t = n[t]), void 0 === o._plugins[t] && (o._plugins[t] = {}), o._plugins[t][e] = i, o;
        }, i.prototype.unbind = i.prototype.removeListener = function(e, i) {
            return i || (i = ""), this.checkIsInterfaceDeprecated(e) && "system" === i && (i = t, n[e] && (e = n[e])), "" === i ? o._plugins[e] = {} : o._plugins[e] && (o._plugins[e][i] = null, delete o._plugins[e][i]), o;
        }, i.prototype.emit = function(t) {
            var e = o.utils.getFromIndex(1, arguments);
            for(var n in o._plugins[t])o._plugins[t][n].apply(o, e);
            return o;
        }, i.prototype.listenerCount = function(t) {
            return Object.keys(o._plugins[t]);
        }, o.plugin = new i;
        var r = function() {};
        r.prototype.get = function(t) {
            var e = document.cookie.match(new RegExp("(^| )" + t + "=([^;]*)(;|$)"));
            return e ? unescape(e[2]) : null;
        }, r.prototype.set = function(t, e, n) {
            var i = new Date;
            return n && i.setTime(i.getTime() + parseInt(24 * n * 3600000)), document.cookie = t + "=" + escape(e) + "; " + (n ? "expires=" + i.toGMTString() + "; " : "") + "path=" + o.options.cookiepath, o;
        }, o.cookie = new r;
        var s = function() {};
        s.prototype.output = function() {
            return o.plugin.emit("userinfo.output"), o;
        }, s.prototype.save = function() {
            return o.plugin.emit("userinfo.save"), o;
        }, s.prototype.saveFromHtml = s.prototype.readFromHtml = function() {
            return o.plugin.emit("userinfo.readFromHtml"), o;
        }, o.userinfo = new s;
        var u = function() {};
        u.prototype.get = function(t, e) {
            o.plugin.emit("comment.get", t, e);
        }, u.prototype.reply = function(t) {
            o.plugin.emit("comment.reply.start", t);
        }, u.prototype.post = function(t) {
            t = t || {};
            try {
                o.plugin.emit("comment.post.start", t);
            } catch (t) {
                console.error(t);
            }
            return !1;
        }, o.comment = new u;
    };
    "function" == typeof define && define.amd ? define("zbp", [], function() {
        return o;
    }) : "function" == typeof define && define.cmd ? define("zbp", [], function(t, e, n) {
        n.exports = o;
    }) : $3b2111debd702654$exports = o;
})();




//# sourceMappingURL=CSS.347c8c59.js.map
